import globalAxios from 'axios';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

/* tslint:disable */
var BASE_PATH = 'http://gdm-tvpage.demo.hybris.com/rest/v2';
/**
 *
 * @export
 * @class BaseAPI
 */
var BaseAPI = /** @class */ (function () {
    function BaseAPI(configuration, basePath, axios) {
        if (basePath === void 0) { basePath = BASE_PATH; }
        if (axios === void 0) { axios = globalAxios; }
        this.basePath = basePath;
        this.axios = axios;
        if (configuration) {
            this.configuration = configuration;
            this.basePath = (configuration.basePath || this.basePath).replace(/\/+$/, '');
        }
    }
    return BaseAPI;
}());
/**
 *
 * @export
 * @class RequiredError
 * @extends {Error}
 */
var RequiredError = /** @class */ (function (_super) {
    __extends(RequiredError, _super);
    function RequiredError(field, msg) {
        var _this = _super.call(this, msg) || this;
        _this.field = field;
        _this.name = 'RequiredError';
        return _this;
    }
    return RequiredError;
}(Error));

/* tslint:disable */
/**
 *
 * @export
 */
var DUMMY_BASE_URL = 'https://example.com';
/**
 *
 * @throws {RequiredError}
 * @export
 */
var assertParamExists = function (functionName, paramName, paramValue) {
    if (paramValue === null || paramValue === undefined) {
        throw new RequiredError(paramName, "Required parameter " + paramName + " was null or undefined when calling " + functionName + ".");
    }
};
/**
 *
 * @export
 */
var setOAuthToObject = function (object, name, scopes, configuration) {
    return __awaiter(this, void 0, void 0, function () {
        var localVarAccessTokenValue, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!(configuration && configuration.accessToken)) return [3 /*break*/, 5];
                    if (!(typeof configuration.accessToken === 'function')) return [3 /*break*/, 2];
                    return [4 /*yield*/, configuration.accessToken(name, scopes)];
                case 1:
                    _a = _b.sent();
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, configuration.accessToken];
                case 3:
                    _a = _b.sent();
                    _b.label = 4;
                case 4:
                    localVarAccessTokenValue = _a;
                    object["Authorization"] = "Bearer " + localVarAccessTokenValue;
                    _b.label = 5;
                case 5: return [2 /*return*/];
            }
        });
    });
};
/**
 *
 * @export
 */
var setSearchParams = function (url) {
    var objects = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        objects[_i - 1] = arguments[_i];
    }
    var searchParams = new URLSearchParams(url.search);
    for (var _a = 0, objects_1 = objects; _a < objects_1.length; _a++) {
        var object = objects_1[_a];
        for (var key in object) {
            if (Array.isArray(object[key])) {
                searchParams.delete(key);
                for (var _b = 0, _c = object[key]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    searchParams.append(key, item);
                }
            }
            else {
                searchParams.set(key, object[key]);
            }
        }
    }
    url.search = searchParams.toString();
};
/**
 *
 * @export
 */
var serializeDataIfNeeded = function (value, requestOptions, configuration) {
    var nonString = typeof value !== 'string';
    var needsSerialization = nonString && configuration && configuration.isJsonMime
        ? configuration.isJsonMime(requestOptions.headers['Content-Type'])
        : nonString;
    return needsSerialization
        ? JSON.stringify(value !== undefined ? value : {})
        : (value || "");
};
/**
 *
 * @export
 */
var toPathString = function (url) {
    return url.pathname + url.search + url.hash;
};
/**
 *
 * @export
 */
var createRequestFunction = function (axiosArgs, globalAxios, BASE_PATH, configuration) {
    return function (axios, basePath) {
        if (axios === void 0) { axios = globalAxios; }
        if (basePath === void 0) { basePath = BASE_PATH; }
        var axiosRequestArgs = __assign(__assign({}, axiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + axiosArgs.url });
        return axios.request(axiosRequestArgs);
    };
};

/* tslint:disable */
/**
 * @export
 * @enum {string}
 */
var ImageImageTypeEnum;
(function (ImageImageTypeEnum) {
    ImageImageTypeEnum["Primary"] = "PRIMARY";
    ImageImageTypeEnum["Gallery"] = "GALLERY";
})(ImageImageTypeEnum || (ImageImageTypeEnum = {}));
/**
 * @export
 * @enum {string}
 */
var PricePriceTypeEnum;
(function (PricePriceTypeEnum) {
    PricePriceTypeEnum["Buy"] = "BUY";
    PricePriceTypeEnum["From"] = "FROM";
})(PricePriceTypeEnum || (PricePriceTypeEnum = {}));
/**
 * AddressApi - axios parameter creator
 * @export
 */
var AddressApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Creates a new address.
         * @summary Creates a new address.
         * @param {string} baseSiteId Base site identifier
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {Address} address Address object.
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAddress: function (baseSiteId, userId, address, fields, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('createAddress', 'baseSiteId', baseSiteId);
                            // verify required parameter 'userId' is not null or undefined
                            assertParamExists('createAddress', 'userId', userId);
                            // verify required parameter 'address' is not null or undefined
                            assertParamExists('createAddress', 'address', address);
                            localVarPath = "/{baseSiteId}/users/{userId}/addresses"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'userId' + "}", encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/xml';
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = serializeDataIfNeeded(address, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Returns detailed information about address with a given id.
         * @summary Get info about address
         * @param {string} addressId Address identifier.
         * @param {string} baseSiteId Base site identifier
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @hrows {RequiredError}
         */
        getAddress: function (addressId, baseSiteId, userId, fields, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'addressId' is not null or undefined
                            assertParamExists('getAddress', 'addressId', addressId);
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('getAddress', 'baseSiteId', baseSiteId);
                            // verify required parameter 'userId' is not null or undefined
                            assertParamExists('getAddress', 'userId', userId);
                            localVarPath = "/{baseSiteId}/users/{userId}/addresses/{addressId}"
                                .replace("{" + 'addressId' + "}", encodeURIComponent(String(addressId)))
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'userId' + "}", encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Returns customer\'s addresses.
         * @summary Get customer\'s addresses
         * @param {string} baseSiteId Base site identifier
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddresses: function (baseSiteId, userId, fields, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('getAddresses', 'baseSiteId', baseSiteId);
                            // verify required parameter 'userId' is not null or undefined
                            assertParamExists('getAddresses', 'userId', userId);
                            localVarPath = "/{baseSiteId}/users/{userId}/addresses"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'userId' + "}", encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Removes customer\'s address.
         * @summary Delete customer\'s address.
         * @param {string} addressId Address identifier.
         * @param {string} baseSiteId Base site identifier
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeAddress: function (addressId, baseSiteId, userId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'addressId' is not null or undefined
                            assertParamExists('removeAddress', 'addressId', addressId);
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('removeAddress', 'baseSiteId', baseSiteId);
                            // verify required parameter 'userId' is not null or undefined
                            assertParamExists('removeAddress', 'userId', userId);
                            localVarPath = "/{baseSiteId}/users/{userId}/addresses/{addressId}"
                                .replace("{" + 'addressId' + "}", encodeURIComponent(String(addressId)))
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'userId' + "}", encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Updates the address. Attributes not provided in the request will be defined again (set to null or default).
         * @summary Updates the address
         * @param {string} addressId Address identifier.
         * @param {string} baseSiteId Base site identifier
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {Address} address Address object.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceAddress: function (addressId, baseSiteId, userId, address, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'addressId' is not null or undefined
                            assertParamExists('replaceAddress', 'addressId', addressId);
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('replaceAddress', 'baseSiteId', baseSiteId);
                            // verify required parameter 'userId' is not null or undefined
                            assertParamExists('replaceAddress', 'userId', userId);
                            // verify required parameter 'address' is not null or undefined
                            assertParamExists('replaceAddress', 'address', address);
                            localVarPath = "/{baseSiteId}/users/{userId}/addresses/{addressId}"
                                .replace("{" + 'addressId' + "}", encodeURIComponent(String(addressId)))
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'userId' + "}", encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/xml';
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = serializeDataIfNeeded(address, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Updates the address. Only attributes provided in the request body will be changed.
         * @summary Updates the address
         * @param {string} addressId Address identifier.
         * @param {string} baseSiteId Base site identifier
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {Address} address Address object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAddress: function (addressId, baseSiteId, userId, address, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'addressId' is not null or undefined
                            assertParamExists('updateAddress', 'addressId', addressId);
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('updateAddress', 'baseSiteId', baseSiteId);
                            // verify required parameter 'userId' is not null or undefined
                            assertParamExists('updateAddress', 'userId', userId);
                            // verify required parameter 'address' is not null or undefined
                            assertParamExists('updateAddress', 'address', address);
                            localVarPath = "/{baseSiteId}/users/{userId}/addresses/{addressId}"
                                .replace("{" + 'addressId' + "}", encodeURIComponent(String(addressId)))
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'userId' + "}", encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/xml';
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = serializeDataIfNeeded(address, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Verifies address.
         * @summary Verifies address.
         * @param {string} baseSiteId Base site identifier
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {Address} address Address object.
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateAddress: function (baseSiteId, userId, address, fields, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('validateAddress', 'baseSiteId', baseSiteId);
                            // verify required parameter 'userId' is not null or undefined
                            assertParamExists('validateAddress', 'userId', userId);
                            // verify required parameter 'address' is not null or undefined
                            assertParamExists('validateAddress', 'address', address);
                            localVarPath = "/{baseSiteId}/users/{userId}/addresses/verification"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'userId' + "}", encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/xml';
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = serializeDataIfNeeded(address, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        }
    };
};
/**
 * AddressApi - functional programming interface
 * @export
 */
var AddressApiFp = function (configuration) {
    var localVarAxiosParamCreator = AddressApiAxiosParamCreator(configuration);
    return {
        /**
         * Creates a new address.
         * @summary Creates a new address.
         * @param {string} baseSiteId Base site identifier
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {Address} address Address object.
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAddress: function (baseSiteId, userId, address, fields, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createAddress(baseSiteId, userId, address, fields, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns detailed information about address with a given id.
         * @summary Get info about address
         * @param {string} addressId Address identifier.
         * @param {string} baseSiteId Base site identifier
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddress: function (addressId, baseSiteId, userId, fields, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAddress(addressId, baseSiteId, userId, fields, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns customer\'s addresses.
         * @summary Get customer\'s addresses
         * @param {string} baseSiteId Base site identifier
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddresses: function (baseSiteId, userId, fields, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAddresses(baseSiteId, userId, fields, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Removes customer\'s address.
         * @summary Delete customer\'s address.
         * @param {string} addressId Address identifier.
         * @param {string} baseSiteId Base site identifier
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeAddress: function (addressId, baseSiteId, userId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.removeAddress(addressId, baseSiteId, userId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Updates the address. Attributes not provided in the request will be defined again (set to null or default).
         * @summary Updates the address
         * @param {string} addressId Address identifier.
         * @param {string} baseSiteId Base site identifier
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {Address} address Address object.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceAddress: function (addressId, baseSiteId, userId, address, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.replaceAddress(addressId, baseSiteId, userId, address, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Updates the address. Only attributes provided in the request body will be changed.
         * @summary Updates the address
         * @param {string} addressId Address identifier.
         * @param {string} baseSiteId Base site identifier
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {Address} address Address object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAddress: function (addressId, baseSiteId, userId, address, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateAddress(addressId, baseSiteId, userId, address, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Verifies address.
         * @summary Verifies address.
         * @param {string} baseSiteId Base site identifier
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {Address} address Address object.
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateAddress: function (baseSiteId, userId, address, fields, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.validateAddress(baseSiteId, userId, address, fields, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        }
    };
};
/**
 * AddressApi - factory interface
 * @export
 */
var AddressApiFactory = function (configuration, basePath, axios) {
    var localVarFp = AddressApiFp(configuration);
    return {
        /**
         * Creates a new address.
         * @summary Creates a new address.
         * @param {string} baseSiteId Base site identifier
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {Address} address Address object.
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAddress: function (baseSiteId, userId, address, fields, options) {
            return localVarFp
                .createAddress(baseSiteId, userId, address, fields, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns detailed information about address with a given id.
         * @summary Get info about address
         * @param {string} addressId Address identifier.
         * @param {string} baseSiteId Base site identifier
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddress: function (addressId, baseSiteId, userId, fields, options) {
            return localVarFp
                .getAddress(addressId, baseSiteId, userId, fields, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns customer\'s addresses.
         * @summary Get customer\'s addresses
         * @param {string} baseSiteId Base site identifier
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddresses: function (baseSiteId, userId, fields, options) {
            return localVarFp
                .getAddresses(baseSiteId, userId, fields, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Removes customer\'s address.
         * @summary Delete customer\'s address.
         * @param {string} addressId Address identifier.
         * @param {string} baseSiteId Base site identifier
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeAddress: function (addressId, baseSiteId, userId, options) {
            return localVarFp
                .removeAddress(addressId, baseSiteId, userId, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Updates the address. Attributes not provided in the request will be defined again (set to null or default).
         * @summary Updates the address
         * @param {string} addressId Address identifier.
         * @param {string} baseSiteId Base site identifier
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {Address} address Address object.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceAddress: function (addressId, baseSiteId, userId, address, options) {
            return localVarFp
                .replaceAddress(addressId, baseSiteId, userId, address, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Updates the address. Only attributes provided in the request body will be changed.
         * @summary Updates the address
         * @param {string} addressId Address identifier.
         * @param {string} baseSiteId Base site identifier
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {Address} address Address object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAddress: function (addressId, baseSiteId, userId, address, options) {
            return localVarFp
                .updateAddress(addressId, baseSiteId, userId, address, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Verifies address.
         * @summary Verifies address.
         * @param {string} baseSiteId Base site identifier
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {Address} address Address object.
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateAddress: function (baseSiteId, userId, address, fields, options) {
            return localVarFp
                .validateAddress(baseSiteId, userId, address, fields, options)
                .then(function (request) { return request(axios, basePath); });
        }
    };
};
/**
 * AddressApi - object-oriented interface
 * @export
 * @class AddressApi
 * @extends {BaseAPI}
 */
var AddressApi = /** @class */ (function (_super) {
    __extends(AddressApi, _super);
    function AddressApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Creates a new address.
     * @summary Creates a new address.
     * @param {string} baseSiteId Base site identifier
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {Address} address Address object.
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressApi
     */
    AddressApi.prototype.createAddress = function (baseSiteId, userId, address, fields, options) {
        var _this = this;
        return AddressApiFp(this.configuration)
            .createAddress(baseSiteId, userId, address, fields, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns detailed information about address with a given id.
     * @summary Get info about address
     * @param {string} addressId Address identifier.
     * @param {string} baseSiteId Base site identifier
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressApi
     */
    AddressApi.prototype.getAddress = function (addressId, baseSiteId, userId, fields, options) {
        var _this = this;
        return AddressApiFp(this.configuration)
            .getAddress(addressId, baseSiteId, userId, fields, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns customer\'s addresses.
     * @summary Get customer\'s addresses
     * @param {string} baseSiteId Base site identifier
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressApi
     */
    AddressApi.prototype.getAddresses = function (baseSiteId, userId, fields, options) {
        var _this = this;
        return AddressApiFp(this.configuration)
            .getAddresses(baseSiteId, userId, fields, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Removes customer\'s address.
     * @summary Delete customer\'s address.
     * @param {string} addressId Address identifier.
     * @param {string} baseSiteId Base site identifier
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressApi
     */
    AddressApi.prototype.removeAddress = function (addressId, baseSiteId, userId, options) {
        var _this = this;
        return AddressApiFp(this.configuration)
            .removeAddress(addressId, baseSiteId, userId, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Updates the address. Attributes not provided in the request will be defined again (set to null or default).
     * @summary Updates the address
     * @param {string} addressId Address identifier.
     * @param {string} baseSiteId Base site identifier
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {Address} address Address object.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressApi
     */
    AddressApi.prototype.replaceAddress = function (addressId, baseSiteId, userId, address, options) {
        var _this = this;
        return AddressApiFp(this.configuration)
            .replaceAddress(addressId, baseSiteId, userId, address, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Updates the address. Only attributes provided in the request body will be changed.
     * @summary Updates the address
     * @param {string} addressId Address identifier.
     * @param {string} baseSiteId Base site identifier
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {Address} address Address object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressApi
     */
    AddressApi.prototype.updateAddress = function (addressId, baseSiteId, userId, address, options) {
        var _this = this;
        return AddressApiFp(this.configuration)
            .updateAddress(addressId, baseSiteId, userId, address, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Verifies address.
     * @summary Verifies address.
     * @param {string} baseSiteId Base site identifier
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {Address} address Address object.
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressApi
     */
    AddressApi.prototype.validateAddress = function (baseSiteId, userId, address, fields, options) {
        var _this = this;
        return AddressApiFp(this.configuration)
            .validateAddress(baseSiteId, userId, address, fields, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return AddressApi;
}(BaseAPI));
/**
 * BaseSitesApi - axios parameter creator
 * @export
 */
var BaseSitesApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Get all base sites with corresponding base stores details in FULL mode.
         * @summary Get all base sites.
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBaseSites: function (fields, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/basesites";
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        }
    };
};
/**
 * BaseSitesApi - functional programming interface
 * @export
 */
var BaseSitesApiFp = function (configuration) {
    var localVarAxiosParamCreator = BaseSitesApiAxiosParamCreator(configuration);
    return {
        /**
         * Get all base sites with corresponding base stores details in FULL mode.
         * @summary Get all base sites.
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBaseSites: function (fields, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getBaseSites(fields, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        }
    };
};
/**
 * BaseSitesApi - factory interface
 * @export
 */
var BaseSitesApiFactory = function (configuration, basePath, axios) {
    var localVarFp = BaseSitesApiFp(configuration);
    return {
        /**
         * Get all base sites with corresponding base stores details in FULL mode.
         * @summary Get all base sites.
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBaseSites: function (fields, options) {
            return localVarFp
                .getBaseSites(fields, options)
                .then(function (request) { return request(axios, basePath); });
        }
    };
};
/**
 * BaseSitesApi - object-oriented interface
 * @export
 * @class BaseSitesApi
 * @extends {BaseAPI}
 */
var BaseSitesApi = /** @class */ (function (_super) {
    __extends(BaseSitesApi, _super);
    function BaseSitesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Get all base sites with corresponding base stores details in FULL mode.
     * @summary Get all base sites.
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseSitesApi
     */
    BaseSitesApi.prototype.getBaseSites = function (fields, options) {
        var _this = this;
        return BaseSitesApiFp(this.configuration)
            .getBaseSites(fields, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return BaseSitesApi;
}(BaseAPI));
/**
 * BaseStoresApi - axios parameter creator
 * @export
 */
var BaseStoresApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Returns details of a specific base store based on its identifier. The response contains detailed base store information.
         * @summary Get a base store.
         * @param {string} baseSiteId Base site identifier
         * @param {string} baseStoreUid Base store name
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBaseStore: function (baseSiteId, baseStoreUid, fields, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('getBaseStore', 'baseSiteId', baseSiteId);
                            // verify required parameter 'baseStoreUid' is not null or undefined
                            assertParamExists('getBaseStore', 'baseStoreUid', baseStoreUid);
                            localVarPath = "/{baseSiteId}/basestores/{baseStoreUid}"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'baseStoreUid' + "}", encodeURIComponent(String(baseStoreUid)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        }
    };
};
/**
 * BaseStoresApi - functional programming interface
 * @export
 */
var BaseStoresApiFp = function (configuration) {
    var localVarAxiosParamCreator = BaseStoresApiAxiosParamCreator(configuration);
    return {
        /**
         * Returns details of a specific base store based on its identifier. The response contains detailed base store information.
         * @summary Get a base store.
         * @param {string} baseSiteId Base site identifier
         * @param {string} baseStoreUid Base store name
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBaseStore: function (baseSiteId, baseStoreUid, fields, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getBaseStore(baseSiteId, baseStoreUid, fields, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        }
    };
};
/**
 * BaseStoresApi - factory interface
 * @export
 */
var BaseStoresApiFactory = function (configuration, basePath, axios) {
    var localVarFp = BaseStoresApiFp(configuration);
    return {
        /**
         * Returns details of a specific base store based on its identifier. The response contains detailed base store information.
         * @summary Get a base store.
         * @param {string} baseSiteId Base site identifier
         * @param {string} baseStoreUid Base store name
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBaseStore: function (baseSiteId, baseStoreUid, fields, options) {
            return localVarFp
                .getBaseStore(baseSiteId, baseStoreUid, fields, options)
                .then(function (request) { return request(axios, basePath); });
        }
    };
};
/**
 * BaseStoresApi - object-oriented interface
 * @export
 * @class BaseStoresApi
 * @extends {BaseAPI}
 */
var BaseStoresApi = /** @class */ (function (_super) {
    __extends(BaseStoresApi, _super);
    function BaseStoresApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Returns details of a specific base store based on its identifier. The response contains detailed base store information.
     * @summary Get a base store.
     * @param {string} baseSiteId Base site identifier
     * @param {string} baseStoreUid Base store name
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseStoresApi
     */
    BaseStoresApi.prototype.getBaseStore = function (baseSiteId, baseStoreUid, fields, options) {
        var _this = this;
        return BaseStoresApiFp(this.configuration)
            .getBaseStore(baseSiteId, baseStoreUid, fields, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return BaseStoresApi;
}(BaseAPI));
/**
 * CartsApi - axios parameter creator
 * @export
 */
var CartsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Creates a new cart or restores an anonymous cart as a user\'s cart (if an old Cart Id is given in the request).
         * @summary Creates or restore a cart for a user.
         * @param {string} baseSiteId Base site identifier
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {'BASIC' | 'DEFAULT' | 'FULL'} [fields] Response configuration. This is the list of fields that should be returned in the response body.
         * @param {string} [oldCartId] Anonymous cart GUID.
         * @param {string} [toMergeCartGuid] The GUID of the user\&#39;s cart that will be merged with the anonymous cart.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCart: function (baseSiteId, userId, fields, oldCartId, toMergeCartGuid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('createCart', 'baseSiteId', baseSiteId);
                            // verify required parameter 'userId' is not null or undefined
                            assertParamExists('createCart', 'userId', userId);
                            localVarPath = "/{baseSiteId}/users/{userId}/carts"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'userId' + "}", encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            if (oldCartId !== undefined) {
                                localVarQueryParameter['oldCartId'] = oldCartId;
                            }
                            if (toMergeCartGuid !== undefined) {
                                localVarQueryParameter['toMergeCartGuid'] = toMergeCartGuid;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Creates an address and assigns it to the cart as the delivery address.
         * @summary Creates a delivery address for the cart.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {Address} address Request body parameter that contains details such as the customer\&#39;s first name (firstName), the customer\&#39;s last name (lastName), the customer\&#39;s title (titleCode), the customer\&#39;s phone (phone), the country (country.isocode), the first part of the address (line1), the second part of the address (line2), the town (town), the postal code (postalCode), and the region (region.isocode).  The DTO is in XML or .json format.
         * @param {'BASIC' | 'DEFAULT' | 'FULL'} [fields] Response configuration. This is the list of fields that should be returned in the response body.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCartDeliveryAddress: function (baseSiteId, cartId, userId, address, fields, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('createCartDeliveryAddress', 'baseSiteId', baseSiteId);
                            // verify required parameter 'cartId' is not null or undefined
                            assertParamExists('createCartDeliveryAddress', 'cartId', cartId);
                            // verify required parameter 'userId' is not null or undefined
                            assertParamExists('createCartDeliveryAddress', 'userId', userId);
                            // verify required parameter 'address' is not null or undefined
                            assertParamExists('createCartDeliveryAddress', 'address', address);
                            localVarPath = "/{baseSiteId}/users/{userId}/carts/{cartId}/addresses/delivery"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'cartId' + "}", encodeURIComponent(String(cartId)))
                                .replace("{" + 'userId' + "}", encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/xml';
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = serializeDataIfNeeded(address, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Adds a product to the cart.
         * @summary Adds a product to the cart.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {OrderEntry} entry Request body parameter that contains details such as the product code (product.code), the quantity of product (quantity), and the pickup store name (deliveryPointOfService.name).  The DTO is in XML or .json format.
         * @param {'BASIC' | 'DEFAULT' | 'FULL'} [fields] Response configuration. This is the list of fields that should be returned in the response body.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCartEntry: function (baseSiteId, cartId, userId, entry, fields, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('createCartEntry', 'baseSiteId', baseSiteId);
                            // verify required parameter 'cartId' is not null or undefined
                            assertParamExists('createCartEntry', 'cartId', cartId);
                            // verify required parameter 'userId' is not null or undefined
                            assertParamExists('createCartEntry', 'userId', userId);
                            // verify required parameter 'entry' is not null or undefined
                            assertParamExists('createCartEntry', 'entry', entry);
                            localVarPath = "/{baseSiteId}/users/{userId}/carts/{cartId}/entries"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'cartId' + "}", encodeURIComponent(String(cartId)))
                                .replace("{" + 'userId' + "}", encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/xml';
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = serializeDataIfNeeded(entry, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Defines the details of a new credit card, and assigns this payment option to the cart.
         * @summary Defines and assigns details of a new credit card payment to the cart.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {PaymentDetails} paymentDetails Request body parameter that contains details such as the name on the card (accountHolderName), the card number (cardNumber), the card type (cardType.code), the month of the expiry date (expiryMonth), the year of the expiry date (expiryYear), whether the payment details should be saved (saved), whether the payment details should be set as default (defaultPaymentInfo), and the billing address (billingAddress.firstName, billingAddress.lastName, billingAddress.titleCode, billingAddress.country.isocode, billingAddress.line1, billingAddress.line2, billingAddress.town, billingAddress.postalCode, billingAddress.region.isocode)  The DTO is in XML or .json format.
         * @param {'BASIC' | 'DEFAULT' | 'FULL'} [fields] Response configuration. This is the list of fields that should be returned in the response body.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCartPaymentDetails: function (baseSiteId, cartId, userId, paymentDetails, fields, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('createCartPaymentDetails', 'baseSiteId', baseSiteId);
                            // verify required parameter 'cartId' is not null or undefined
                            assertParamExists('createCartPaymentDetails', 'cartId', cartId);
                            // verify required parameter 'userId' is not null or undefined
                            assertParamExists('createCartPaymentDetails', 'userId', userId);
                            // verify required parameter 'paymentDetails' is not null or undefined
                            assertParamExists('createCartPaymentDetails', 'paymentDetails', paymentDetails);
                            localVarPath = "/{baseSiteId}/users/{userId}/carts/{cartId}/paymentdetails"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'cartId' + "}", encodeURIComponent(String(cartId)))
                                .replace("{" + 'userId' + "}", encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/xml';
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = serializeDataIfNeeded(paymentDetails, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Enables a promotion for the order based on the promotionId defined for the cart. Requests pertaining to promotions have been developed for the previous version of promotions and vouchers, and as a result, some of them are currently not compatible with the new promotions engine.
         * @summary Enables promotions based on the promotionsId of the cart.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} promotionId Promotion identifier (code)
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doApplyCartPromotion: function (baseSiteId, cartId, promotionId, userId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('doApplyCartPromotion', 'baseSiteId', baseSiteId);
                            // verify required parameter 'cartId' is not null or undefined
                            assertParamExists('doApplyCartPromotion', 'cartId', cartId);
                            // verify required parameter 'promotionId' is not null or undefined
                            assertParamExists('doApplyCartPromotion', 'promotionId', promotionId);
                            // verify required parameter 'userId' is not null or undefined
                            assertParamExists('doApplyCartPromotion', 'userId', userId);
                            localVarPath = "/{baseSiteId}/users/{userId}/carts/{cartId}/promotions"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'cartId' + "}", encodeURIComponent(String(cartId)))
                                .replace("{" + 'userId' + "}", encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (promotionId !== undefined) {
                                localVarQueryParameter['promotionId'] = promotionId;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Applies a voucher based on the voucherId defined for the cart.
         * @summary Applies a voucher based on the voucherId defined for the cart.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {string} voucherId Voucher identifier (code)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doApplyCartVoucher: function (baseSiteId, cartId, userId, voucherId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('doApplyCartVoucher', 'baseSiteId', baseSiteId);
                            // verify required parameter 'cartId' is not null or undefined
                            assertParamExists('doApplyCartVoucher', 'cartId', cartId);
                            // verify required parameter 'userId' is not null or undefined
                            assertParamExists('doApplyCartVoucher', 'userId', userId);
                            // verify required parameter 'voucherId' is not null or undefined
                            assertParamExists('doApplyCartVoucher', 'voucherId', voucherId);
                            localVarPath = "/{baseSiteId}/users/{userId}/carts/{cartId}/vouchers"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'cartId' + "}", encodeURIComponent(String(cartId)))
                                .replace("{" + 'userId' + "}", encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (voucherId !== undefined) {
                                localVarQueryParameter['voucherId'] = voucherId;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Returns the cart with a given identifier.
         * @summary Get a cart with a given identifier.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {'BASIC' | 'DEFAULT' | 'FULL'} [fields] Response configuration. This is the list of fields that should be returned in the response body.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCart: function (baseSiteId, cartId, userId, fields, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('getCart', 'baseSiteId', baseSiteId);
                            // verify required parameter 'cartId' is not null or undefined
                            assertParamExists('getCart', 'cartId', cartId);
                            // verify required parameter 'userId' is not null or undefined
                            assertParamExists('getCart', 'userId', userId);
                            localVarPath = "/{baseSiteId}/users/{userId}/carts/{cartId}"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'cartId' + "}", encodeURIComponent(String(cartId)))
                                .replace("{" + 'userId' + "}", encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Returns the delivery mode selected for the cart.
         * @summary Get the delivery mode selected for the cart.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {'BASIC' | 'DEFAULT' | 'FULL'} [fields] Response configuration. This is the list of fields that should be returned in the response body.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCartDeliveryMode: function (baseSiteId, cartId, userId, fields, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('getCartDeliveryMode', 'baseSiteId', baseSiteId);
                            // verify required parameter 'cartId' is not null or undefined
                            assertParamExists('getCartDeliveryMode', 'cartId', cartId);
                            // verify required parameter 'userId' is not null or undefined
                            assertParamExists('getCartDeliveryMode', 'userId', userId);
                            localVarPath = "/{baseSiteId}/users/{userId}/carts/{cartId}/deliverymode"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'cartId' + "}", encodeURIComponent(String(cartId)))
                                .replace("{" + 'userId' + "}", encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Returns all delivery modes supported for the current base store and cart delivery address. A delivery address must be set for the cart, otherwise an empty list will be returned.
         * @summary Get all delivery modes for the current store and delivery address.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {'BASIC' | 'DEFAULT' | 'FULL'} [fields] Response configuration. This is the list of fields that should be returned in the response body.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCartDeliveryModes: function (baseSiteId, cartId, userId, fields, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('getCartDeliveryModes', 'baseSiteId', baseSiteId);
                            // verify required parameter 'cartId' is not null or undefined
                            assertParamExists('getCartDeliveryModes', 'cartId', cartId);
                            // verify required parameter 'userId' is not null or undefined
                            assertParamExists('getCartDeliveryModes', 'userId', userId);
                            localVarPath = "/{baseSiteId}/users/{userId}/carts/{cartId}/deliverymodes"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'cartId' + "}", encodeURIComponent(String(cartId)))
                                .replace("{" + 'userId' + "}", encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Returns cart entries.
         * @summary Get cart entries.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {'BASIC' | 'DEFAULT' | 'FULL'} [fields] Response configuration. This is the list of fields that should be returned in the response body.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCartEntries: function (baseSiteId, cartId, userId, fields, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('getCartEntries', 'baseSiteId', baseSiteId);
                            // verify required parameter 'cartId' is not null or undefined
                            assertParamExists('getCartEntries', 'cartId', cartId);
                            // verify required parameter 'userId' is not null or undefined
                            assertParamExists('getCartEntries', 'userId', userId);
                            localVarPath = "/{baseSiteId}/users/{userId}/carts/{cartId}/entries"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'cartId' + "}", encodeURIComponent(String(cartId)))
                                .replace("{" + 'userId' + "}", encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Returns the details of the cart entries.
         * @summary Get the details of the cart entries.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {number} entryNumber The entry number. Each entry in a cart has an entry number. Cart entries are numbered in ascending order, starting with zero (0).
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {'BASIC' | 'DEFAULT' | 'FULL'} [fields] Response configuration. This is the list of fields that should be returned in the response body.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCartEntry: function (baseSiteId, cartId, entryNumber, userId, fields, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('getCartEntry', 'baseSiteId', baseSiteId);
                            // verify required parameter 'cartId' is not null or undefined
                            assertParamExists('getCartEntry', 'cartId', cartId);
                            // verify required parameter 'entryNumber' is not null or undefined
                            assertParamExists('getCartEntry', 'entryNumber', entryNumber);
                            // verify required parameter 'userId' is not null or undefined
                            assertParamExists('getCartEntry', 'userId', userId);
                            localVarPath = "/{baseSiteId}/users/{userId}/carts/{cartId}/entries/{entryNumber}"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'cartId' + "}", encodeURIComponent(String(cartId)))
                                .replace("{" + 'entryNumber' + "}", encodeURIComponent(String(entryNumber)))
                                .replace("{" + 'userId' + "}", encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Returns information about a promotion (with a specific promotionId), that has been applied on the cart. Requests pertaining to promotions have been developed for the previous version of promotions and vouchers, and as a result, some of them are currently not compatible with the new promotions engine.
         * @summary Get information about promotion applied on cart.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} promotionId Promotion identifier (code)
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {'BASIC' | 'DEFAULT' | 'FULL'} [fields] Response configuration. This is the list of fields that should be returned in the response body.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCartPromotion: function (baseSiteId, cartId, promotionId, userId, fields, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('getCartPromotion', 'baseSiteId', baseSiteId);
                            // verify required parameter 'cartId' is not null or undefined
                            assertParamExists('getCartPromotion', 'cartId', cartId);
                            // verify required parameter 'promotionId' is not null or undefined
                            assertParamExists('getCartPromotion', 'promotionId', promotionId);
                            // verify required parameter 'userId' is not null or undefined
                            assertParamExists('getCartPromotion', 'userId', userId);
                            localVarPath = "/{baseSiteId}/users/{userId}/carts/{cartId}/promotions/{promotionId}"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'cartId' + "}", encodeURIComponent(String(cartId)))
                                .replace("{" + 'promotionId' + "}", encodeURIComponent(String(promotionId)))
                                .replace("{" + 'userId' + "}", encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Returns information about the promotions applied on the cart. Requests pertaining to promotions have been developed for the previous version of promotions and vouchers, and as a result, some of them are currently not compatible with the new promotions engine.
         * @summary Get information about promotions applied on cart.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {'BASIC' | 'DEFAULT' | 'FULL'} [fields] Response configuration. This is the list of fields that should be returned in the response body.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCartPromotions: function (baseSiteId, cartId, userId, fields, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('getCartPromotions', 'baseSiteId', baseSiteId);
                            // verify required parameter 'cartId' is not null or undefined
                            assertParamExists('getCartPromotions', 'cartId', cartId);
                            // verify required parameter 'userId' is not null or undefined
                            assertParamExists('getCartPromotions', 'userId', userId);
                            localVarPath = "/{baseSiteId}/users/{userId}/carts/{cartId}/promotions"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'cartId' + "}", encodeURIComponent(String(cartId)))
                                .replace("{" + 'userId' + "}", encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Returns a list of vouchers applied to the cart.
         * @summary Get a list of vouchers applied to the cart.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {'BASIC' | 'DEFAULT' | 'FULL'} [fields] Response configuration. This is the list of fields that should be returned in the response body.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCartVouchers: function (baseSiteId, cartId, userId, fields, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('getCartVouchers', 'baseSiteId', baseSiteId);
                            // verify required parameter 'cartId' is not null or undefined
                            assertParamExists('getCartVouchers', 'cartId', cartId);
                            // verify required parameter 'userId' is not null or undefined
                            assertParamExists('getCartVouchers', 'userId', userId);
                            localVarPath = "/{baseSiteId}/users/{userId}/carts/{cartId}/vouchers"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'cartId' + "}", encodeURIComponent(String(cartId)))
                                .replace("{" + 'userId' + "}", encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Lists all customer carts.
         * @summary Get all customer carts.
         * @param {string} baseSiteId Base site identifier
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {number} [currentPage] Optional pagination parameter in case of savedCartsOnly &#x3D;&#x3D; true. Default value 0.
         * @param {'BASIC' | 'DEFAULT' | 'FULL'} [fields] Response configuration. This is the list of fields that should be returned in the response body.
         * @param {number} [pageSize] Optional {@link PaginationData} parameter in case of savedCartsOnly &#x3D;&#x3D; true. Default value 20.
         * @param {boolean} [savedCartsOnly] Optional parameter. If the parameter is provided and its value is true, only saved carts are returned.
         * @param {string} [sort] Optional sort criterion in case of savedCartsOnly &#x3D;&#x3D; true. No default value.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCarts: function (baseSiteId, userId, currentPage, fields, pageSize, savedCartsOnly, sort, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('getCarts', 'baseSiteId', baseSiteId);
                            // verify required parameter 'userId' is not null or undefined
                            assertParamExists('getCarts', 'userId', userId);
                            localVarPath = "/{baseSiteId}/users/{userId}/carts"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'userId' + "}", encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (currentPage !== undefined) {
                                localVarQueryParameter['currentPage'] = currentPage;
                            }
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['pageSize'] = pageSize;
                            }
                            if (savedCartsOnly !== undefined) {
                                localVarQueryParameter['savedCartsOnly'] = savedCartsOnly;
                            }
                            if (sort !== undefined) {
                                localVarQueryParameter['sort'] = sort;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Deletes a cart with a given cart id.
         * @summary Deletes a cart with a given cart id.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeCart: function (baseSiteId, cartId, userId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('removeCart', 'baseSiteId', baseSiteId);
                            // verify required parameter 'cartId' is not null or undefined
                            assertParamExists('removeCart', 'cartId', cartId);
                            // verify required parameter 'userId' is not null or undefined
                            assertParamExists('removeCart', 'userId', userId);
                            localVarPath = "/{baseSiteId}/users/{userId}/carts/{cartId}"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'cartId' + "}", encodeURIComponent(String(cartId)))
                                .replace("{" + 'userId' + "}", encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Deletes the delivery address from the cart.
         * @summary Deletes the delivery address from the cart.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeCartDeliveryAddress: function (baseSiteId, cartId, userId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('removeCartDeliveryAddress', 'baseSiteId', baseSiteId);
                            // verify required parameter 'cartId' is not null or undefined
                            assertParamExists('removeCartDeliveryAddress', 'cartId', cartId);
                            // verify required parameter 'userId' is not null or undefined
                            assertParamExists('removeCartDeliveryAddress', 'userId', userId);
                            localVarPath = "/{baseSiteId}/users/{userId}/carts/{cartId}/addresses/delivery"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'cartId' + "}", encodeURIComponent(String(cartId)))
                                .replace("{" + 'userId' + "}", encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Deletes the delivery mode from the cart.
         * @summary Deletes the delivery mode from the cart.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeCartDeliveryMode: function (baseSiteId, cartId, userId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('removeCartDeliveryMode', 'baseSiteId', baseSiteId);
                            // verify required parameter 'cartId' is not null or undefined
                            assertParamExists('removeCartDeliveryMode', 'cartId', cartId);
                            // verify required parameter 'userId' is not null or undefined
                            assertParamExists('removeCartDeliveryMode', 'userId', userId);
                            localVarPath = "/{baseSiteId}/users/{userId}/carts/{cartId}/deliverymode"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'cartId' + "}", encodeURIComponent(String(cartId)))
                                .replace("{" + 'userId' + "}", encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Deletes cart entry.
         * @summary Deletes cart entry.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {number} entryNumber The entry number. Each entry in a cart has an entry number. Cart entries are numbered in ascending order, starting with zero (0).
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeCartEntry: function (baseSiteId, cartId, entryNumber, userId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('removeCartEntry', 'baseSiteId', baseSiteId);
                            // verify required parameter 'cartId' is not null or undefined
                            assertParamExists('removeCartEntry', 'cartId', cartId);
                            // verify required parameter 'entryNumber' is not null or undefined
                            assertParamExists('removeCartEntry', 'entryNumber', entryNumber);
                            // verify required parameter 'userId' is not null or undefined
                            assertParamExists('removeCartEntry', 'userId', userId);
                            localVarPath = "/{baseSiteId}/users/{userId}/carts/{cartId}/entries/{entryNumber}"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'cartId' + "}", encodeURIComponent(String(cartId)))
                                .replace("{" + 'entryNumber' + "}", encodeURIComponent(String(entryNumber)))
                                .replace("{" + 'userId' + "}", encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Disables the promotion for the order based on the promotionId defined for the cart. Requests pertaining to promotions have been developed for the previous version of promotions and vouchers, and as a result, some of them are currently not compatible with the new promotions engine.
         * @summary Disables the promotion based on the promotionsId of the cart.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} promotionId Promotion identifier (code)
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeCartPromotion: function (baseSiteId, cartId, promotionId, userId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('removeCartPromotion', 'baseSiteId', baseSiteId);
                            // verify required parameter 'cartId' is not null or undefined
                            assertParamExists('removeCartPromotion', 'cartId', cartId);
                            // verify required parameter 'promotionId' is not null or undefined
                            assertParamExists('removeCartPromotion', 'promotionId', promotionId);
                            // verify required parameter 'userId' is not null or undefined
                            assertParamExists('removeCartPromotion', 'userId', userId);
                            localVarPath = "/{baseSiteId}/users/{userId}/carts/{cartId}/promotions/{promotionId}"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'cartId' + "}", encodeURIComponent(String(cartId)))
                                .replace("{" + 'promotionId' + "}", encodeURIComponent(String(promotionId)))
                                .replace("{" + 'userId' + "}", encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Deletes a voucher based on the voucherId defined for the current cart.
         * @summary Deletes a voucher defined for the current cart.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {string} voucherId Voucher identifier (code)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeCartVoucher: function (baseSiteId, cartId, userId, voucherId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('removeCartVoucher', 'baseSiteId', baseSiteId);
                            // verify required parameter 'cartId' is not null or undefined
                            assertParamExists('removeCartVoucher', 'cartId', cartId);
                            // verify required parameter 'userId' is not null or undefined
                            assertParamExists('removeCartVoucher', 'userId', userId);
                            // verify required parameter 'voucherId' is not null or undefined
                            assertParamExists('removeCartVoucher', 'voucherId', voucherId);
                            localVarPath = "/{baseSiteId}/users/{userId}/carts/{cartId}/vouchers/{voucherId}"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'cartId' + "}", encodeURIComponent(String(cartId)))
                                .replace("{" + 'userId' + "}", encodeURIComponent(String(userId)))
                                .replace("{" + 'voucherId' + "}", encodeURIComponent(String(voucherId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Sets a delivery address for the cart. The address country must be placed among the delivery countries of the current base store.
         * @summary Sets a delivery address for the cart.
         * @param {string} addressId Address identifier
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceCartDeliveryAddress: function (addressId, baseSiteId, cartId, userId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'addressId' is not null or undefined
                            assertParamExists('replaceCartDeliveryAddress', 'addressId', addressId);
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('replaceCartDeliveryAddress', 'baseSiteId', baseSiteId);
                            // verify required parameter 'cartId' is not null or undefined
                            assertParamExists('replaceCartDeliveryAddress', 'cartId', cartId);
                            // verify required parameter 'userId' is not null or undefined
                            assertParamExists('replaceCartDeliveryAddress', 'userId', userId);
                            localVarPath = "/{baseSiteId}/users/{userId}/carts/{cartId}/addresses/delivery"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'cartId' + "}", encodeURIComponent(String(cartId)))
                                .replace("{" + 'userId' + "}", encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (addressId !== undefined) {
                                localVarQueryParameter['addressId'] = addressId;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Sets the delivery mode with a given identifier for the cart.
         * @summary Sets the delivery mode for a cart.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} deliveryModeId Delivery mode identifier (code)
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceCartDeliveryMode: function (baseSiteId, cartId, deliveryModeId, userId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('replaceCartDeliveryMode', 'baseSiteId', baseSiteId);
                            // verify required parameter 'cartId' is not null or undefined
                            assertParamExists('replaceCartDeliveryMode', 'cartId', cartId);
                            // verify required parameter 'deliveryModeId' is not null or undefined
                            assertParamExists('replaceCartDeliveryMode', 'deliveryModeId', deliveryModeId);
                            // verify required parameter 'userId' is not null or undefined
                            assertParamExists('replaceCartDeliveryMode', 'userId', userId);
                            localVarPath = "/{baseSiteId}/users/{userId}/carts/{cartId}/deliverymode"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'cartId' + "}", encodeURIComponent(String(cartId)))
                                .replace("{" + 'userId' + "}", encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (deliveryModeId !== undefined) {
                                localVarQueryParameter['deliveryModeId'] = deliveryModeId;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Updates the quantity of a single cart entry and the details of the store where the cart entry will be picked up. Attributes not provided in request will be defined again (set to null or default)
         * @summary Set quantity and store details of a cart entry.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {number} entryNumber The entry number. Each entry in a cart has an entry number. Cart entries are numbered in ascending order, starting with zero (0).
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {OrderEntry} entry Request body parameter that contains details such as the quantity of product (quantity), and the pickup store name (deliveryPointOfService.name)  The DTO is in XML or .json format.
         * @param {'BASIC' | 'DEFAULT' | 'FULL'} [fields] Response configuration. This is the list of fields that should be returned in the response body.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceCartEntry: function (baseSiteId, cartId, entryNumber, userId, entry, fields, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('replaceCartEntry', 'baseSiteId', baseSiteId);
                            // verify required parameter 'cartId' is not null or undefined
                            assertParamExists('replaceCartEntry', 'cartId', cartId);
                            // verify required parameter 'entryNumber' is not null or undefined
                            assertParamExists('replaceCartEntry', 'entryNumber', entryNumber);
                            // verify required parameter 'userId' is not null or undefined
                            assertParamExists('replaceCartEntry', 'userId', userId);
                            // verify required parameter 'entry' is not null or undefined
                            assertParamExists('replaceCartEntry', 'entry', entry);
                            localVarPath = "/{baseSiteId}/users/{userId}/carts/{cartId}/entries/{entryNumber}"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'cartId' + "}", encodeURIComponent(String(cartId)))
                                .replace("{" + 'entryNumber' + "}", encodeURIComponent(String(entryNumber)))
                                .replace("{" + 'userId' + "}", encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/xml';
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = serializeDataIfNeeded(entry, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Assigns an email to the cart. This step is required to make a guest checkout.
         * @summary Assigns an email to the cart.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} email Email of the guest user. It will be used during the checkout process.
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceCartGuestUser: function (baseSiteId, cartId, email, userId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('replaceCartGuestUser', 'baseSiteId', baseSiteId);
                            // verify required parameter 'cartId' is not null or undefined
                            assertParamExists('replaceCartGuestUser', 'cartId', cartId);
                            // verify required parameter 'email' is not null or undefined
                            assertParamExists('replaceCartGuestUser', 'email', email);
                            // verify required parameter 'userId' is not null or undefined
                            assertParamExists('replaceCartGuestUser', 'userId', userId);
                            localVarPath = "/{baseSiteId}/users/{userId}/carts/{cartId}/email"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'cartId' + "}", encodeURIComponent(String(cartId)))
                                .replace("{" + 'userId' + "}", encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (email !== undefined) {
                                localVarQueryParameter['email'] = email;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Sets credit card payment details for the cart.
         * @summary Sets credit card payment details for the cart.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} paymentDetailsId Payment details identifier.
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceCartPaymentDetails: function (baseSiteId, cartId, paymentDetailsId, userId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('replaceCartPaymentDetails', 'baseSiteId', baseSiteId);
                            // verify required parameter 'cartId' is not null or undefined
                            assertParamExists('replaceCartPaymentDetails', 'cartId', cartId);
                            // verify required parameter 'paymentDetailsId' is not null or undefined
                            assertParamExists('replaceCartPaymentDetails', 'paymentDetailsId', paymentDetailsId);
                            // verify required parameter 'userId' is not null or undefined
                            assertParamExists('replaceCartPaymentDetails', 'userId', userId);
                            localVarPath = "/{baseSiteId}/users/{userId}/carts/{cartId}/paymentdetails"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'cartId' + "}", encodeURIComponent(String(cartId)))
                                .replace("{" + 'userId' + "}", encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (paymentDetailsId !== undefined) {
                                localVarQueryParameter['paymentDetailsId'] = paymentDetailsId;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Updates the quantity of a single cart entry and the details of the store where the cart entry will be picked up.
         * @summary Update quantity and store details of a cart entry.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {number} entryNumber The entry number. Each entry in a cart has an entry number. Cart entries are numbered in ascending order, starting with zero (0).
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {OrderEntry} entry Request body parameter that contains details such as the quantity of product (quantity), and the pickup store name (deliveryPointOfService.name)  The DTO is in XML or .json format.
         * @param {'BASIC' | 'DEFAULT' | 'FULL'} [fields] Response configuration. This is the list of fields that should be returned in the response body.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCartEntry: function (baseSiteId, cartId, entryNumber, userId, entry, fields, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('updateCartEntry', 'baseSiteId', baseSiteId);
                            // verify required parameter 'cartId' is not null or undefined
                            assertParamExists('updateCartEntry', 'cartId', cartId);
                            // verify required parameter 'entryNumber' is not null or undefined
                            assertParamExists('updateCartEntry', 'entryNumber', entryNumber);
                            // verify required parameter 'userId' is not null or undefined
                            assertParamExists('updateCartEntry', 'userId', userId);
                            // verify required parameter 'entry' is not null or undefined
                            assertParamExists('updateCartEntry', 'entry', entry);
                            localVarPath = "/{baseSiteId}/users/{userId}/carts/{cartId}/entries/{entryNumber}"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'cartId' + "}", encodeURIComponent(String(cartId)))
                                .replace("{" + 'entryNumber' + "}", encodeURIComponent(String(entryNumber)))
                                .replace("{" + 'userId' + "}", encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/xml';
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = serializeDataIfNeeded(entry, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        }
    };
};
/**
 * CartsApi - functional programming interface
 * @export
 */
var CartsApiFp = function (configuration) {
    var localVarAxiosParamCreator = CartsApiAxiosParamCreator(configuration);
    return {
        /**
         * Creates a new cart or restores an anonymous cart as a user\'s cart (if an old Cart Id is given in the request).
         * @summary Creates or restore a cart for a user.
         * @param {string} baseSiteId Base site identifier
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {'BASIC' | 'DEFAULT' | 'FULL'} [fields] Response configuration. This is the list of fields that should be returned in the response body.
         * @param {string} [oldCartId] Anonymous cart GUID.
         * @param {string} [toMergeCartGuid] The GUID of the user\&#39;s cart that will be merged with the anonymous cart.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCart: function (baseSiteId, userId, fields, oldCartId, toMergeCartGuid, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createCart(baseSiteId, userId, fields, oldCartId, toMergeCartGuid, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Creates an address and assigns it to the cart as the delivery address.
         * @summary Creates a delivery address for the cart.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {Address} address Request body parameter that contains details such as the customer\&#39;s first name (firstName), the customer\&#39;s last name (lastName), the customer\&#39;s title (titleCode), the customer\&#39;s phone (phone), the country (country.isocode), the first part of the address (line1), the second part of the address (line2), the town (town), the postal code (postalCode), and the region (region.isocode).  The DTO is in XML or .json format.
         * @param {'BASIC' | 'DEFAULT' | 'FULL'} [fields] Response configuration. This is the list of fields that should be returned in the response body.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCartDeliveryAddress: function (baseSiteId, cartId, userId, address, fields, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createCartDeliveryAddress(baseSiteId, cartId, userId, address, fields, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Adds a product to the cart.
         * @summary Adds a product to the cart.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {OrderEntry} entry Request body parameter that contains details such as the product code (product.code), the quantity of product (quantity), and the pickup store name (deliveryPointOfService.name).  The DTO is in XML or .json format.
         * @param {'BASIC' | 'DEFAULT' | 'FULL'} [fields] Response configuration. This is the list of fields that should be returned in the response body.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCartEntry: function (baseSiteId, cartId, userId, entry, fields, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createCartEntry(baseSiteId, cartId, userId, entry, fields, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Defines the details of a new credit card, and assigns this payment option to the cart.
         * @summary Defines and assigns details of a new credit card payment to the cart.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {PaymentDetails} paymentDetails Request body parameter that contains details such as the name on the card (accountHolderName), the card number (cardNumber), the card type (cardType.code), the month of the expiry date (expiryMonth), the year of the expiry date (expiryYear), whether the payment details should be saved (saved), whether the payment details should be set as default (defaultPaymentInfo), and the billing address (billingAddress.firstName, billingAddress.lastName, billingAddress.titleCode, billingAddress.country.isocode, billingAddress.line1, billingAddress.line2, billingAddress.town, billingAddress.postalCode, billingAddress.region.isocode)  The DTO is in XML or .json format.
         * @param {'BASIC' | 'DEFAULT' | 'FULL'} [fields] Response configuration. This is the list of fields that should be returned in the response body.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCartPaymentDetails: function (baseSiteId, cartId, userId, paymentDetails, fields, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createCartPaymentDetails(baseSiteId, cartId, userId, paymentDetails, fields, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Enables a promotion for the order based on the promotionId defined for the cart. Requests pertaining to promotions have been developed for the previous version of promotions and vouchers, and as a result, some of them are currently not compatible with the new promotions engine.
         * @summary Enables promotions based on the promotionsId of the cart.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} promotionId Promotion identifier (code)
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doApplyCartPromotion: function (baseSiteId, cartId, promotionId, userId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.doApplyCartPromotion(baseSiteId, cartId, promotionId, userId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Applies a voucher based on the voucherId defined for the cart.
         * @summary Applies a voucher based on the voucherId defined for the cart.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {string} voucherId Voucher identifier (code)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doApplyCartVoucher: function (baseSiteId, cartId, userId, voucherId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.doApplyCartVoucher(baseSiteId, cartId, userId, voucherId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns the cart with a given identifier.
         * @summary Get a cart with a given identifier.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {'BASIC' | 'DEFAULT' | 'FULL'} [fields] Response configuration. This is the list of fields that should be returned in the response body.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCart: function (baseSiteId, cartId, userId, fields, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getCart(baseSiteId, cartId, userId, fields, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns the delivery mode selected for the cart.
         * @summary Get the delivery mode selected for the cart.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {'BASIC' | 'DEFAULT' | 'FULL'} [fields] Response configuration. This is the list of fields that should be returned in the response body.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCartDeliveryMode: function (baseSiteId, cartId, userId, fields, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getCartDeliveryMode(baseSiteId, cartId, userId, fields, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns all delivery modes supported for the current base store and cart delivery address. A delivery address must be set for the cart, otherwise an empty list will be returned.
         * @summary Get all delivery modes for the current store and delivery address.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {'BASIC' | 'DEFAULT' | 'FULL'} [fields] Response configuration. This is the list of fields that should be returned in the response body.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCartDeliveryModes: function (baseSiteId, cartId, userId, fields, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getCartDeliveryModes(baseSiteId, cartId, userId, fields, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns cart entries.
         * @summary Get cart entries.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {'BASIC' | 'DEFAULT' | 'FULL'} [fields] Response configuration. This is the list of fields that should be returned in the response body.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCartEntries: function (baseSiteId, cartId, userId, fields, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getCartEntries(baseSiteId, cartId, userId, fields, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns the details of the cart entries.
         * @summary Get the details of the cart entries.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {number} entryNumber The entry number. Each entry in a cart has an entry number. Cart entries are numbered in ascending order, starting with zero (0).
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {'BASIC' | 'DEFAULT' | 'FULL'} [fields] Response configuration. This is the list of fields that should be returned in the response body.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCartEntry: function (baseSiteId, cartId, entryNumber, userId, fields, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getCartEntry(baseSiteId, cartId, entryNumber, userId, fields, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns information about a promotion (with a specific promotionId), that has been applied on the cart. Requests pertaining to promotions have been developed for the previous version of promotions and vouchers, and as a result, some of them are currently not compatible with the new promotions engine.
         * @summary Get information about promotion applied on cart.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} promotionId Promotion identifier (code)
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {'BASIC' | 'DEFAULT' | 'FULL'} [fields] Response configuration. This is the list of fields that should be returned in the response body.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCartPromotion: function (baseSiteId, cartId, promotionId, userId, fields, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getCartPromotion(baseSiteId, cartId, promotionId, userId, fields, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns information about the promotions applied on the cart. Requests pertaining to promotions have been developed for the previous version of promotions and vouchers, and as a result, some of them are currently not compatible with the new promotions engine.
         * @summary Get information about promotions applied on cart.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {'BASIC' | 'DEFAULT' | 'FULL'} [fields] Response configuration. This is the list of fields that should be returned in the response body.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCartPromotions: function (baseSiteId, cartId, userId, fields, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getCartPromotions(baseSiteId, cartId, userId, fields, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns a list of vouchers applied to the cart.
         * @summary Get a list of vouchers applied to the cart.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {'BASIC' | 'DEFAULT' | 'FULL'} [fields] Response configuration. This is the list of fields that should be returned in the response body.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCartVouchers: function (baseSiteId, cartId, userId, fields, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getCartVouchers(baseSiteId, cartId, userId, fields, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Lists all customer carts.
         * @summary Get all customer carts.
         * @param {string} baseSiteId Base site identifier
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {number} [currentPage] Optional pagination parameter in case of savedCartsOnly &#x3D;&#x3D; true. Default value 0.
         * @param {'BASIC' | 'DEFAULT' | 'FULL'} [fields] Response configuration. This is the list of fields that should be returned in the response body.
         * @param {number} [pageSize] Optional {@link PaginationData} parameter in case of savedCartsOnly &#x3D;&#x3D; true. Default value 20.
         * @param {boolean} [savedCartsOnly] Optional parameter. If the parameter is provided and its value is true, only saved carts are returned.
         * @param {string} [sort] Optional sort criterion in case of savedCartsOnly &#x3D;&#x3D; true. No default value.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCarts: function (baseSiteId, userId, currentPage, fields, pageSize, savedCartsOnly, sort, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getCarts(baseSiteId, userId, currentPage, fields, pageSize, savedCartsOnly, sort, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Deletes a cart with a given cart id.
         * @summary Deletes a cart with a given cart id.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeCart: function (baseSiteId, cartId, userId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.removeCart(baseSiteId, cartId, userId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Deletes the delivery address from the cart.
         * @summary Deletes the delivery address from the cart.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeCartDeliveryAddress: function (baseSiteId, cartId, userId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.removeCartDeliveryAddress(baseSiteId, cartId, userId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Deletes the delivery mode from the cart.
         * @summary Deletes the delivery mode from the cart.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeCartDeliveryMode: function (baseSiteId, cartId, userId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.removeCartDeliveryMode(baseSiteId, cartId, userId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Deletes cart entry.
         * @summary Deletes cart entry.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {number} entryNumber The entry number. Each entry in a cart has an entry number. Cart entries are numbered in ascending order, starting with zero (0).
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeCartEntry: function (baseSiteId, cartId, entryNumber, userId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.removeCartEntry(baseSiteId, cartId, entryNumber, userId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Disables the promotion for the order based on the promotionId defined for the cart. Requests pertaining to promotions have been developed for the previous version of promotions and vouchers, and as a result, some of them are currently not compatible with the new promotions engine.
         * @summary Disables the promotion based on the promotionsId of the cart.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} promotionId Promotion identifier (code)
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeCartPromotion: function (baseSiteId, cartId, promotionId, userId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.removeCartPromotion(baseSiteId, cartId, promotionId, userId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Deletes a voucher based on the voucherId defined for the current cart.
         * @summary Deletes a voucher defined for the current cart.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {string} voucherId Voucher identifier (code)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeCartVoucher: function (baseSiteId, cartId, userId, voucherId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.removeCartVoucher(baseSiteId, cartId, userId, voucherId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Sets a delivery address for the cart. The address country must be placed among the delivery countries of the current base store.
         * @summary Sets a delivery address for the cart.
         * @param {string} addressId Address identifier
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceCartDeliveryAddress: function (addressId, baseSiteId, cartId, userId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.replaceCartDeliveryAddress(addressId, baseSiteId, cartId, userId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Sets the delivery mode with a given identifier for the cart.
         * @summary Sets the delivery mode for a cart.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} deliveryModeId Delivery mode identifier (code)
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceCartDeliveryMode: function (baseSiteId, cartId, deliveryModeId, userId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.replaceCartDeliveryMode(baseSiteId, cartId, deliveryModeId, userId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Updates the quantity of a single cart entry and the details of the store where the cart entry will be picked up. Attributes not provided in request will be defined again (set to null or default)
         * @summary Set quantity and store details of a cart entry.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {number} entryNumber The entry number. Each entry in a cart has an entry number. Cart entries are numbered in ascending order, starting with zero (0).
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {OrderEntry} entry Request body parameter that contains details such as the quantity of product (quantity), and the pickup store name (deliveryPointOfService.name)  The DTO is in XML or .json format.
         * @param {'BASIC' | 'DEFAULT' | 'FULL'} [fields] Response configuration. This is the list of fields that should be returned in the response body.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceCartEntry: function (baseSiteId, cartId, entryNumber, userId, entry, fields, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.replaceCartEntry(baseSiteId, cartId, entryNumber, userId, entry, fields, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Assigns an email to the cart. This step is required to make a guest checkout.
         * @summary Assigns an email to the cart.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} email Email of the guest user. It will be used during the checkout process.
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceCartGuestUser: function (baseSiteId, cartId, email, userId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.replaceCartGuestUser(baseSiteId, cartId, email, userId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Sets credit card payment details for the cart.
         * @summary Sets credit card payment details for the cart.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} paymentDetailsId Payment details identifier.
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceCartPaymentDetails: function (baseSiteId, cartId, paymentDetailsId, userId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.replaceCartPaymentDetails(baseSiteId, cartId, paymentDetailsId, userId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Updates the quantity of a single cart entry and the details of the store where the cart entry will be picked up.
         * @summary Update quantity and store details of a cart entry.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {number} entryNumber The entry number. Each entry in a cart has an entry number. Cart entries are numbered in ascending order, starting with zero (0).
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {OrderEntry} entry Request body parameter that contains details such as the quantity of product (quantity), and the pickup store name (deliveryPointOfService.name)  The DTO is in XML or .json format.
         * @param {'BASIC' | 'DEFAULT' | 'FULL'} [fields] Response configuration. This is the list of fields that should be returned in the response body.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCartEntry: function (baseSiteId, cartId, entryNumber, userId, entry, fields, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateCartEntry(baseSiteId, cartId, entryNumber, userId, entry, fields, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        }
    };
};
/**
 * CartsApi - factory interface
 * @export
 */
var CartsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = CartsApiFp(configuration);
    return {
        /**
         * Creates a new cart or restores an anonymous cart as a user\'s cart (if an old Cart Id is given in the request).
         * @summary Creates or restore a cart for a user.
         * @param {string} baseSiteId Base site identifier
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {'BASIC' | 'DEFAULT' | 'FULL'} [fields] Response configuration. This is the list of fields that should be returned in the response body.
         * @param {string} [oldCartId] Anonymous cart GUID.
         * @param {string} [toMergeCartGuid] The GUID of the user\&#39;s cart that will be merged with the anonymous cart.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCart: function (baseSiteId, userId, fields, oldCartId, toMergeCartGuid, options) {
            return localVarFp
                .createCart(baseSiteId, userId, fields, oldCartId, toMergeCartGuid, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Creates an address and assigns it to the cart as the delivery address.
         * @summary Creates a delivery address for the cart.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {Address} address Request body parameter that contains details such as the customer\&#39;s first name (firstName), the customer\&#39;s last name (lastName), the customer\&#39;s title (titleCode), the customer\&#39;s phone (phone), the country (country.isocode), the first part of the address (line1), the second part of the address (line2), the town (town), the postal code (postalCode), and the region (region.isocode).  The DTO is in XML or .json format.
         * @param {'BASIC' | 'DEFAULT' | 'FULL'} [fields] Response configuration. This is the list of fields that should be returned in the response body.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCartDeliveryAddress: function (baseSiteId, cartId, userId, address, fields, options) {
            return localVarFp
                .createCartDeliveryAddress(baseSiteId, cartId, userId, address, fields, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Adds a product to the cart.
         * @summary Adds a product to the cart.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {OrderEntry} entry Request body parameter that contains details such as the product code (product.code), the quantity of product (quantity), and the pickup store name (deliveryPointOfService.name).  The DTO is in XML or .json format.
         * @param {'BASIC' | 'DEFAULT' | 'FULL'} [fields] Response configuration. This is the list of fields that should be returned in the response body.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCartEntry: function (baseSiteId, cartId, userId, entry, fields, options) {
            return localVarFp
                .createCartEntry(baseSiteId, cartId, userId, entry, fields, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Defines the details of a new credit card, and assigns this payment option to the cart.
         * @summary Defines and assigns details of a new credit card payment to the cart.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {PaymentDetails} paymentDetails Request body parameter that contains details such as the name on the card (accountHolderName), the card number (cardNumber), the card type (cardType.code), the month of the expiry date (expiryMonth), the year of the expiry date (expiryYear), whether the payment details should be saved (saved), whether the payment details should be set as default (defaultPaymentInfo), and the billing address (billingAddress.firstName, billingAddress.lastName, billingAddress.titleCode, billingAddress.country.isocode, billingAddress.line1, billingAddress.line2, billingAddress.town, billingAddress.postalCode, billingAddress.region.isocode)  The DTO is in XML or .json format.
         * @param {'BASIC' | 'DEFAULT' | 'FULL'} [fields] Response configuration. This is the list of fields that should be returned in the response body.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCartPaymentDetails: function (baseSiteId, cartId, userId, paymentDetails, fields, options) {
            return localVarFp
                .createCartPaymentDetails(baseSiteId, cartId, userId, paymentDetails, fields, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Enables a promotion for the order based on the promotionId defined for the cart. Requests pertaining to promotions have been developed for the previous version of promotions and vouchers, and as a result, some of them are currently not compatible with the new promotions engine.
         * @summary Enables promotions based on the promotionsId of the cart.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} promotionId Promotion identifier (code)
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doApplyCartPromotion: function (baseSiteId, cartId, promotionId, userId, options) {
            return localVarFp
                .doApplyCartPromotion(baseSiteId, cartId, promotionId, userId, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Applies a voucher based on the voucherId defined for the cart.
         * @summary Applies a voucher based on the voucherId defined for the cart.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {string} voucherId Voucher identifier (code)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doApplyCartVoucher: function (baseSiteId, cartId, userId, voucherId, options) {
            return localVarFp
                .doApplyCartVoucher(baseSiteId, cartId, userId, voucherId, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns the cart with a given identifier.
         * @summary Get a cart with a given identifier.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {'BASIC' | 'DEFAULT' | 'FULL'} [fields] Response configuration. This is the list of fields that should be returned in the response body.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCart: function (baseSiteId, cartId, userId, fields, options) {
            return localVarFp
                .getCart(baseSiteId, cartId, userId, fields, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns the delivery mode selected for the cart.
         * @summary Get the delivery mode selected for the cart.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {'BASIC' | 'DEFAULT' | 'FULL'} [fields] Response configuration. This is the list of fields that should be returned in the response body.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCartDeliveryMode: function (baseSiteId, cartId, userId, fields, options) {
            return localVarFp
                .getCartDeliveryMode(baseSiteId, cartId, userId, fields, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns all delivery modes supported for the current base store and cart delivery address. A delivery address must be set for the cart, otherwise an empty list will be returned.
         * @summary Get all delivery modes for the current store and delivery address.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {'BASIC' | 'DEFAULT' | 'FULL'} [fields] Response configuration. This is the list of fields that should be returned in the response body.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCartDeliveryModes: function (baseSiteId, cartId, userId, fields, options) {
            return localVarFp
                .getCartDeliveryModes(baseSiteId, cartId, userId, fields, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns cart entries.
         * @summary Get cart entries.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {'BASIC' | 'DEFAULT' | 'FULL'} [fields] Response configuration. This is the list of fields that should be returned in the response body.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCartEntries: function (baseSiteId, cartId, userId, fields, options) {
            return localVarFp
                .getCartEntries(baseSiteId, cartId, userId, fields, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns the details of the cart entries.
         * @summary Get the details of the cart entries.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {number} entryNumber The entry number. Each entry in a cart has an entry number. Cart entries are numbered in ascending order, starting with zero (0).
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {'BASIC' | 'DEFAULT' | 'FULL'} [fields] Response configuration. This is the list of fields that should be returned in the response body.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCartEntry: function (baseSiteId, cartId, entryNumber, userId, fields, options) {
            return localVarFp
                .getCartEntry(baseSiteId, cartId, entryNumber, userId, fields, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns information about a promotion (with a specific promotionId), that has been applied on the cart. Requests pertaining to promotions have been developed for the previous version of promotions and vouchers, and as a result, some of them are currently not compatible with the new promotions engine.
         * @summary Get information about promotion applied on cart.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} promotionId Promotion identifier (code)
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {'BASIC' | 'DEFAULT' | 'FULL'} [fields] Response configuration. This is the list of fields that should be returned in the response body.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCartPromotion: function (baseSiteId, cartId, promotionId, userId, fields, options) {
            return localVarFp
                .getCartPromotion(baseSiteId, cartId, promotionId, userId, fields, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns information about the promotions applied on the cart. Requests pertaining to promotions have been developed for the previous version of promotions and vouchers, and as a result, some of them are currently not compatible with the new promotions engine.
         * @summary Get information about promotions applied on cart.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {'BASIC' | 'DEFAULT' | 'FULL'} [fields] Response configuration. This is the list of fields that should be returned in the response body.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCartPromotions: function (baseSiteId, cartId, userId, fields, options) {
            return localVarFp
                .getCartPromotions(baseSiteId, cartId, userId, fields, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns a list of vouchers applied to the cart.
         * @summary Get a list of vouchers applied to the cart.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {'BASIC' | 'DEFAULT' | 'FULL'} [fields] Response configuration. This is the list of fields that should be returned in the response body.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCartVouchers: function (baseSiteId, cartId, userId, fields, options) {
            return localVarFp
                .getCartVouchers(baseSiteId, cartId, userId, fields, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Lists all customer carts.
         * @summary Get all customer carts.
         * @param {string} baseSiteId Base site identifier
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {number} [currentPage] Optional pagination parameter in case of savedCartsOnly &#x3D;&#x3D; true. Default value 0.
         * @param {'BASIC' | 'DEFAULT' | 'FULL'} [fields] Response configuration. This is the list of fields that should be returned in the response body.
         * @param {number} [pageSize] Optional {@link PaginationData} parameter in case of savedCartsOnly &#x3D;&#x3D; true. Default value 20.
         * @param {boolean} [savedCartsOnly] Optional parameter. If the parameter is provided and its value is true, only saved carts are returned.
         * @param {string} [sort] Optional sort criterion in case of savedCartsOnly &#x3D;&#x3D; true. No default value.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCarts: function (baseSiteId, userId, currentPage, fields, pageSize, savedCartsOnly, sort, options) {
            return localVarFp
                .getCarts(baseSiteId, userId, currentPage, fields, pageSize, savedCartsOnly, sort, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Deletes a cart with a given cart id.
         * @summary Deletes a cart with a given cart id.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeCart: function (baseSiteId, cartId, userId, options) {
            return localVarFp
                .removeCart(baseSiteId, cartId, userId, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Deletes the delivery address from the cart.
         * @summary Deletes the delivery address from the cart.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeCartDeliveryAddress: function (baseSiteId, cartId, userId, options) {
            return localVarFp
                .removeCartDeliveryAddress(baseSiteId, cartId, userId, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Deletes the delivery mode from the cart.
         * @summary Deletes the delivery mode from the cart.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeCartDeliveryMode: function (baseSiteId, cartId, userId, options) {
            return localVarFp
                .removeCartDeliveryMode(baseSiteId, cartId, userId, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Deletes cart entry.
         * @summary Deletes cart entry.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {number} entryNumber The entry number. Each entry in a cart has an entry number. Cart entries are numbered in ascending order, starting with zero (0).
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeCartEntry: function (baseSiteId, cartId, entryNumber, userId, options) {
            return localVarFp
                .removeCartEntry(baseSiteId, cartId, entryNumber, userId, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Disables the promotion for the order based on the promotionId defined for the cart. Requests pertaining to promotions have been developed for the previous version of promotions and vouchers, and as a result, some of them are currently not compatible with the new promotions engine.
         * @summary Disables the promotion based on the promotionsId of the cart.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} promotionId Promotion identifier (code)
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeCartPromotion: function (baseSiteId, cartId, promotionId, userId, options) {
            return localVarFp
                .removeCartPromotion(baseSiteId, cartId, promotionId, userId, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Deletes a voucher based on the voucherId defined for the current cart.
         * @summary Deletes a voucher defined for the current cart.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {string} voucherId Voucher identifier (code)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeCartVoucher: function (baseSiteId, cartId, userId, voucherId, options) {
            return localVarFp
                .removeCartVoucher(baseSiteId, cartId, userId, voucherId, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Sets a delivery address for the cart. The address country must be placed among the delivery countries of the current base store.
         * @summary Sets a delivery address for the cart.
         * @param {string} addressId Address identifier
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceCartDeliveryAddress: function (addressId, baseSiteId, cartId, userId, options) {
            return localVarFp
                .replaceCartDeliveryAddress(addressId, baseSiteId, cartId, userId, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Sets the delivery mode with a given identifier for the cart.
         * @summary Sets the delivery mode for a cart.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} deliveryModeId Delivery mode identifier (code)
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceCartDeliveryMode: function (baseSiteId, cartId, deliveryModeId, userId, options) {
            return localVarFp
                .replaceCartDeliveryMode(baseSiteId, cartId, deliveryModeId, userId, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Updates the quantity of a single cart entry and the details of the store where the cart entry will be picked up. Attributes not provided in request will be defined again (set to null or default)
         * @summary Set quantity and store details of a cart entry.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {number} entryNumber The entry number. Each entry in a cart has an entry number. Cart entries are numbered in ascending order, starting with zero (0).
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {OrderEntry} entry Request body parameter that contains details such as the quantity of product (quantity), and the pickup store name (deliveryPointOfService.name)  The DTO is in XML or .json format.
         * @param {'BASIC' | 'DEFAULT' | 'FULL'} [fields] Response configuration. This is the list of fields that should be returned in the response body.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceCartEntry: function (baseSiteId, cartId, entryNumber, userId, entry, fields, options) {
            return localVarFp
                .replaceCartEntry(baseSiteId, cartId, entryNumber, userId, entry, fields, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Assigns an email to the cart. This step is required to make a guest checkout.
         * @summary Assigns an email to the cart.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} email Email of the guest user. It will be used during the checkout process.
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceCartGuestUser: function (baseSiteId, cartId, email, userId, options) {
            return localVarFp
                .replaceCartGuestUser(baseSiteId, cartId, email, userId, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Sets credit card payment details for the cart.
         * @summary Sets credit card payment details for the cart.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} paymentDetailsId Payment details identifier.
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceCartPaymentDetails: function (baseSiteId, cartId, paymentDetailsId, userId, options) {
            return localVarFp
                .replaceCartPaymentDetails(baseSiteId, cartId, paymentDetailsId, userId, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Updates the quantity of a single cart entry and the details of the store where the cart entry will be picked up.
         * @summary Update quantity and store details of a cart entry.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {number} entryNumber The entry number. Each entry in a cart has an entry number. Cart entries are numbered in ascending order, starting with zero (0).
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {OrderEntry} entry Request body parameter that contains details such as the quantity of product (quantity), and the pickup store name (deliveryPointOfService.name)  The DTO is in XML or .json format.
         * @param {'BASIC' | 'DEFAULT' | 'FULL'} [fields] Response configuration. This is the list of fields that should be returned in the response body.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCartEntry: function (baseSiteId, cartId, entryNumber, userId, entry, fields, options) {
            return localVarFp
                .updateCartEntry(baseSiteId, cartId, entryNumber, userId, entry, fields, options)
                .then(function (request) { return request(axios, basePath); });
        }
    };
};
/**
 * CartsApi - object-oriented interface
 * @export
 * @class CartsApi
 * @extends {BaseAPI}
 */
var CartsApi = /** @class */ (function (_super) {
    __extends(CartsApi, _super);
    function CartsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Creates a new cart or restores an anonymous cart as a user\'s cart (if an old Cart Id is given in the request).
     * @summary Creates or restore a cart for a user.
     * @param {string} baseSiteId Base site identifier
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {'BASIC' | 'DEFAULT' | 'FULL'} [fields] Response configuration. This is the list of fields that should be returned in the response body.
     * @param {string} [oldCartId] Anonymous cart GUID.
     * @param {string} [toMergeCartGuid] The GUID of the user\&#39;s cart that will be merged with the anonymous cart.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartsApi
     */
    CartsApi.prototype.createCart = function (baseSiteId, userId, fields, oldCartId, toMergeCartGuid, options) {
        var _this = this;
        return CartsApiFp(this.configuration)
            .createCart(baseSiteId, userId, fields, oldCartId, toMergeCartGuid, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Creates an address and assigns it to the cart as the delivery address.
     * @summary Creates a delivery address for the cart.
     * @param {string} baseSiteId Base site identifier
     * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {Address} address Request body parameter that contains details such as the customer\&#39;s first name (firstName), the customer\&#39;s last name (lastName), the customer\&#39;s title (titleCode), the customer\&#39;s phone (phone), the country (country.isocode), the first part of the address (line1), the second part of the address (line2), the town (town), the postal code (postalCode), and the region (region.isocode).  The DTO is in XML or .json format.
     * @param {'BASIC' | 'DEFAULT' | 'FULL'} [fields] Response configuration. This is the list of fields that should be returned in the response body.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartsApi
     */
    CartsApi.prototype.createCartDeliveryAddress = function (baseSiteId, cartId, userId, address, fields, options) {
        var _this = this;
        return CartsApiFp(this.configuration)
            .createCartDeliveryAddress(baseSiteId, cartId, userId, address, fields, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Adds a product to the cart.
     * @summary Adds a product to the cart.
     * @param {string} baseSiteId Base site identifier
     * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {OrderEntry} entry Request body parameter that contains details such as the product code (product.code), the quantity of product (quantity), and the pickup store name (deliveryPointOfService.name).  The DTO is in XML or .json format.
     * @param {'BASIC' | 'DEFAULT' | 'FULL'} [fields] Response configuration. This is the list of fields that should be returned in the response body.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartsApi
     */
    CartsApi.prototype.createCartEntry = function (baseSiteId, cartId, userId, entry, fields, options) {
        var _this = this;
        return CartsApiFp(this.configuration)
            .createCartEntry(baseSiteId, cartId, userId, entry, fields, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Defines the details of a new credit card, and assigns this payment option to the cart.
     * @summary Defines and assigns details of a new credit card payment to the cart.
     * @param {string} baseSiteId Base site identifier
     * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {PaymentDetails} paymentDetails Request body parameter that contains details such as the name on the card (accountHolderName), the card number (cardNumber), the card type (cardType.code), the month of the expiry date (expiryMonth), the year of the expiry date (expiryYear), whether the payment details should be saved (saved), whether the payment details should be set as default (defaultPaymentInfo), and the billing address (billingAddress.firstName, billingAddress.lastName, billingAddress.titleCode, billingAddress.country.isocode, billingAddress.line1, billingAddress.line2, billingAddress.town, billingAddress.postalCode, billingAddress.region.isocode)  The DTO is in XML or .json format.
     * @param {'BASIC' | 'DEFAULT' | 'FULL'} [fields] Response configuration. This is the list of fields that should be returned in the response body.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartsApi
     */
    CartsApi.prototype.createCartPaymentDetails = function (baseSiteId, cartId, userId, paymentDetails, fields, options) {
        var _this = this;
        return CartsApiFp(this.configuration)
            .createCartPaymentDetails(baseSiteId, cartId, userId, paymentDetails, fields, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Enables a promotion for the order based on the promotionId defined for the cart. Requests pertaining to promotions have been developed for the previous version of promotions and vouchers, and as a result, some of them are currently not compatible with the new promotions engine.
     * @summary Enables promotions based on the promotionsId of the cart.
     * @param {string} baseSiteId Base site identifier
     * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
     * @param {string} promotionId Promotion identifier (code)
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartsApi
     */
    CartsApi.prototype.doApplyCartPromotion = function (baseSiteId, cartId, promotionId, userId, options) {
        var _this = this;
        return CartsApiFp(this.configuration)
            .doApplyCartPromotion(baseSiteId, cartId, promotionId, userId, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Applies a voucher based on the voucherId defined for the cart.
     * @summary Applies a voucher based on the voucherId defined for the cart.
     * @param {string} baseSiteId Base site identifier
     * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {string} voucherId Voucher identifier (code)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartsApi
     */
    CartsApi.prototype.doApplyCartVoucher = function (baseSiteId, cartId, userId, voucherId, options) {
        var _this = this;
        return CartsApiFp(this.configuration)
            .doApplyCartVoucher(baseSiteId, cartId, userId, voucherId, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns the cart with a given identifier.
     * @summary Get a cart with a given identifier.
     * @param {string} baseSiteId Base site identifier
     * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {'BASIC' | 'DEFAULT' | 'FULL'} [fields] Response configuration. This is the list of fields that should be returned in the response body.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartsApi
     */
    CartsApi.prototype.getCart = function (baseSiteId, cartId, userId, fields, options) {
        var _this = this;
        return CartsApiFp(this.configuration)
            .getCart(baseSiteId, cartId, userId, fields, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns the delivery mode selected for the cart.
     * @summary Get the delivery mode selected for the cart.
     * @param {string} baseSiteId Base site identifier
     * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {'BASIC' | 'DEFAULT' | 'FULL'} [fields] Response configuration. This is the list of fields that should be returned in the response body.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartsApi
     */
    CartsApi.prototype.getCartDeliveryMode = function (baseSiteId, cartId, userId, fields, options) {
        var _this = this;
        return CartsApiFp(this.configuration)
            .getCartDeliveryMode(baseSiteId, cartId, userId, fields, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns all delivery modes supported for the current base store and cart delivery address. A delivery address must be set for the cart, otherwise an empty list will be returned.
     * @summary Get all delivery modes for the current store and delivery address.
     * @param {string} baseSiteId Base site identifier
     * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {'BASIC' | 'DEFAULT' | 'FULL'} [fields] Response configuration. This is the list of fields that should be returned in the response body.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartsApi
     */
    CartsApi.prototype.getCartDeliveryModes = function (baseSiteId, cartId, userId, fields, options) {
        var _this = this;
        return CartsApiFp(this.configuration)
            .getCartDeliveryModes(baseSiteId, cartId, userId, fields, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns cart entries.
     * @summary Get cart entries.
     * @param {string} baseSiteId Base site identifier
     * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {'BASIC' | 'DEFAULT' | 'FULL'} [fields] Response configuration. This is the list of fields that should be returned in the response body.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartsApi
     */
    CartsApi.prototype.getCartEntries = function (baseSiteId, cartId, userId, fields, options) {
        var _this = this;
        return CartsApiFp(this.configuration)
            .getCartEntries(baseSiteId, cartId, userId, fields, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns the details of the cart entries.
     * @summary Get the details of the cart entries.
     * @param {string} baseSiteId Base site identifier
     * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
     * @param {number} entryNumber The entry number. Each entry in a cart has an entry number. Cart entries are numbered in ascending order, starting with zero (0).
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {'BASIC' | 'DEFAULT' | 'FULL'} [fields] Response configuration. This is the list of fields that should be returned in the response body.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartsApi
     */
    CartsApi.prototype.getCartEntry = function (baseSiteId, cartId, entryNumber, userId, fields, options) {
        var _this = this;
        return CartsApiFp(this.configuration)
            .getCartEntry(baseSiteId, cartId, entryNumber, userId, fields, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns information about a promotion (with a specific promotionId), that has been applied on the cart. Requests pertaining to promotions have been developed for the previous version of promotions and vouchers, and as a result, some of them are currently not compatible with the new promotions engine.
     * @summary Get information about promotion applied on cart.
     * @param {string} baseSiteId Base site identifier
     * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
     * @param {string} promotionId Promotion identifier (code)
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {'BASIC' | 'DEFAULT' | 'FULL'} [fields] Response configuration. This is the list of fields that should be returned in the response body.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartsApi
     */
    CartsApi.prototype.getCartPromotion = function (baseSiteId, cartId, promotionId, userId, fields, options) {
        var _this = this;
        return CartsApiFp(this.configuration)
            .getCartPromotion(baseSiteId, cartId, promotionId, userId, fields, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns information about the promotions applied on the cart. Requests pertaining to promotions have been developed for the previous version of promotions and vouchers, and as a result, some of them are currently not compatible with the new promotions engine.
     * @summary Get information about promotions applied on cart.
     * @param {string} baseSiteId Base site identifier
     * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {'BASIC' | 'DEFAULT' | 'FULL'} [fields] Response configuration. This is the list of fields that should be returned in the response body.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartsApi
     */
    CartsApi.prototype.getCartPromotions = function (baseSiteId, cartId, userId, fields, options) {
        var _this = this;
        return CartsApiFp(this.configuration)
            .getCartPromotions(baseSiteId, cartId, userId, fields, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns a list of vouchers applied to the cart.
     * @summary Get a list of vouchers applied to the cart.
     * @param {string} baseSiteId Base site identifier
     * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {'BASIC' | 'DEFAULT' | 'FULL'} [fields] Response configuration. This is the list of fields that should be returned in the response body.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartsApi
     */
    CartsApi.prototype.getCartVouchers = function (baseSiteId, cartId, userId, fields, options) {
        var _this = this;
        return CartsApiFp(this.configuration)
            .getCartVouchers(baseSiteId, cartId, userId, fields, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Lists all customer carts.
     * @summary Get all customer carts.
     * @param {string} baseSiteId Base site identifier
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {number} [currentPage] Optional pagination parameter in case of savedCartsOnly &#x3D;&#x3D; true. Default value 0.
     * @param {'BASIC' | 'DEFAULT' | 'FULL'} [fields] Response configuration. This is the list of fields that should be returned in the response body.
     * @param {number} [pageSize] Optional {@link PaginationData} parameter in case of savedCartsOnly &#x3D;&#x3D; true. Default value 20.
     * @param {boolean} [savedCartsOnly] Optional parameter. If the parameter is provided and its value is true, only saved carts are returned.
     * @param {string} [sort] Optional sort criterion in case of savedCartsOnly &#x3D;&#x3D; true. No default value.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartsApi
     */
    CartsApi.prototype.getCarts = function (baseSiteId, userId, currentPage, fields, pageSize, savedCartsOnly, sort, options) {
        var _this = this;
        return CartsApiFp(this.configuration)
            .getCarts(baseSiteId, userId, currentPage, fields, pageSize, savedCartsOnly, sort, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Deletes a cart with a given cart id.
     * @summary Deletes a cart with a given cart id.
     * @param {string} baseSiteId Base site identifier
     * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartsApi
     */
    CartsApi.prototype.removeCart = function (baseSiteId, cartId, userId, options) {
        var _this = this;
        return CartsApiFp(this.configuration)
            .removeCart(baseSiteId, cartId, userId, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Deletes the delivery address from the cart.
     * @summary Deletes the delivery address from the cart.
     * @param {string} baseSiteId Base site identifier
     * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartsApi
     */
    CartsApi.prototype.removeCartDeliveryAddress = function (baseSiteId, cartId, userId, options) {
        var _this = this;
        return CartsApiFp(this.configuration)
            .removeCartDeliveryAddress(baseSiteId, cartId, userId, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Deletes the delivery mode from the cart.
     * @summary Deletes the delivery mode from the cart.
     * @param {string} baseSiteId Base site identifier
     * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartsApi
     */
    CartsApi.prototype.removeCartDeliveryMode = function (baseSiteId, cartId, userId, options) {
        var _this = this;
        return CartsApiFp(this.configuration)
            .removeCartDeliveryMode(baseSiteId, cartId, userId, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Deletes cart entry.
     * @summary Deletes cart entry.
     * @param {string} baseSiteId Base site identifier
     * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
     * @param {number} entryNumber The entry number. Each entry in a cart has an entry number. Cart entries are numbered in ascending order, starting with zero (0).
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartsApi
     */
    CartsApi.prototype.removeCartEntry = function (baseSiteId, cartId, entryNumber, userId, options) {
        var _this = this;
        return CartsApiFp(this.configuration)
            .removeCartEntry(baseSiteId, cartId, entryNumber, userId, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Disables the promotion for the order based on the promotionId defined for the cart. Requests pertaining to promotions have been developed for the previous version of promotions and vouchers, and as a result, some of them are currently not compatible with the new promotions engine.
     * @summary Disables the promotion based on the promotionsId of the cart.
     * @param {string} baseSiteId Base site identifier
     * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
     * @param {string} promotionId Promotion identifier (code)
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartsApi
     */
    CartsApi.prototype.removeCartPromotion = function (baseSiteId, cartId, promotionId, userId, options) {
        var _this = this;
        return CartsApiFp(this.configuration)
            .removeCartPromotion(baseSiteId, cartId, promotionId, userId, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Deletes a voucher based on the voucherId defined for the current cart.
     * @summary Deletes a voucher defined for the current cart.
     * @param {string} baseSiteId Base site identifier
     * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {string} voucherId Voucher identifier (code)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartsApi
     */
    CartsApi.prototype.removeCartVoucher = function (baseSiteId, cartId, userId, voucherId, options) {
        var _this = this;
        return CartsApiFp(this.configuration)
            .removeCartVoucher(baseSiteId, cartId, userId, voucherId, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Sets a delivery address for the cart. The address country must be placed among the delivery countries of the current base store.
     * @summary Sets a delivery address for the cart.
     * @param {string} addressId Address identifier
     * @param {string} baseSiteId Base site identifier
     * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartsApi
     */
    CartsApi.prototype.replaceCartDeliveryAddress = function (addressId, baseSiteId, cartId, userId, options) {
        var _this = this;
        return CartsApiFp(this.configuration)
            .replaceCartDeliveryAddress(addressId, baseSiteId, cartId, userId, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Sets the delivery mode with a given identifier for the cart.
     * @summary Sets the delivery mode for a cart.
     * @param {string} baseSiteId Base site identifier
     * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
     * @param {string} deliveryModeId Delivery mode identifier (code)
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartsApi
     */
    CartsApi.prototype.replaceCartDeliveryMode = function (baseSiteId, cartId, deliveryModeId, userId, options) {
        var _this = this;
        return CartsApiFp(this.configuration)
            .replaceCartDeliveryMode(baseSiteId, cartId, deliveryModeId, userId, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Updates the quantity of a single cart entry and the details of the store where the cart entry will be picked up. Attributes not provided in request will be defined again (set to null or default)
     * @summary Set quantity and store details of a cart entry.
     * @param {string} baseSiteId Base site identifier
     * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
     * @param {number} entryNumber The entry number. Each entry in a cart has an entry number. Cart entries are numbered in ascending order, starting with zero (0).
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {OrderEntry} entry Request body parameter that contains details such as the quantity of product (quantity), and the pickup store name (deliveryPointOfService.name)  The DTO is in XML or .json format.
     * @param {'BASIC' | 'DEFAULT' | 'FULL'} [fields] Response configuration. This is the list of fields that should be returned in the response body.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartsApi
     */
    CartsApi.prototype.replaceCartEntry = function (baseSiteId, cartId, entryNumber, userId, entry, fields, options) {
        var _this = this;
        return CartsApiFp(this.configuration)
            .replaceCartEntry(baseSiteId, cartId, entryNumber, userId, entry, fields, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Assigns an email to the cart. This step is required to make a guest checkout.
     * @summary Assigns an email to the cart.
     * @param {string} baseSiteId Base site identifier
     * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
     * @param {string} email Email of the guest user. It will be used during the checkout process.
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartsApi
     */
    CartsApi.prototype.replaceCartGuestUser = function (baseSiteId, cartId, email, userId, options) {
        var _this = this;
        return CartsApiFp(this.configuration)
            .replaceCartGuestUser(baseSiteId, cartId, email, userId, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Sets credit card payment details for the cart.
     * @summary Sets credit card payment details for the cart.
     * @param {string} baseSiteId Base site identifier
     * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
     * @param {string} paymentDetailsId Payment details identifier.
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartsApi
     */
    CartsApi.prototype.replaceCartPaymentDetails = function (baseSiteId, cartId, paymentDetailsId, userId, options) {
        var _this = this;
        return CartsApiFp(this.configuration)
            .replaceCartPaymentDetails(baseSiteId, cartId, paymentDetailsId, userId, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Updates the quantity of a single cart entry and the details of the store where the cart entry will be picked up.
     * @summary Update quantity and store details of a cart entry.
     * @param {string} baseSiteId Base site identifier
     * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
     * @param {number} entryNumber The entry number. Each entry in a cart has an entry number. Cart entries are numbered in ascending order, starting with zero (0).
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {OrderEntry} entry Request body parameter that contains details such as the quantity of product (quantity), and the pickup store name (deliveryPointOfService.name)  The DTO is in XML or .json format.
     * @param {'BASIC' | 'DEFAULT' | 'FULL'} [fields] Response configuration. This is the list of fields that should be returned in the response body.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartsApi
     */
    CartsApi.prototype.updateCartEntry = function (baseSiteId, cartId, entryNumber, userId, entry, fields, options) {
        var _this = this;
        return CartsApiFp(this.configuration)
            .updateCartEntry(baseSiteId, cartId, entryNumber, userId, entry, fields, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return CartsApi;
}(BaseAPI));
/**
 * CatalogsApi - axios parameter creator
 * @export
 */
var CatalogsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Returns information about a catalog based on its ID, along with the versions defined for the current base store.
         * @summary Get a catalog
         * @param {string} baseSiteId Base site identifier
         * @param {string} catalogId Catalog identifier
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatalog: function (baseSiteId, catalogId, fields, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('getCatalog', 'baseSiteId', baseSiteId);
                            // verify required parameter 'catalogId' is not null or undefined
                            assertParamExists('getCatalog', 'catalogId', catalogId);
                            localVarPath = "/{baseSiteId}/catalogs/{catalogId}"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'catalogId' + "}", encodeURIComponent(String(catalogId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Returns information about the catalog version that exists for the current base store.
         * @summary Get information about catalog version
         * @param {string} baseSiteId Base site identifier
         * @param {string} catalogId Catalog identifier
         * @param {string} catalogVersionId Catalog version identifier
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatalogVersion: function (baseSiteId, catalogId, catalogVersionId, fields, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('getCatalogVersion', 'baseSiteId', baseSiteId);
                            // verify required parameter 'catalogId' is not null or undefined
                            assertParamExists('getCatalogVersion', 'catalogId', catalogId);
                            // verify required parameter 'catalogVersionId' is not null or undefined
                            assertParamExists('getCatalogVersion', 'catalogVersionId', catalogVersionId);
                            localVarPath = "/{baseSiteId}/catalogs/{catalogId}/{catalogVersionId}"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'catalogId' + "}", encodeURIComponent(String(catalogId)))
                                .replace("{" + 'catalogVersionId' + "}", encodeURIComponent(String(catalogVersionId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Returns all catalogs with versions defined for the base store.
         * @summary Get a list of catalogs
         * @param {string} baseSiteId Base site identifier
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatalogs: function (baseSiteId, fields, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('getCatalogs', 'baseSiteId', baseSiteId);
                            localVarPath = "/{baseSiteId}/catalogs".replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Returns information about a specified category that exists in a catalog version available for the current base store.
         * @summary Get information about catagory in a catalog version
         * @param {string} baseSiteId Base site identifier
         * @param {string} catalogId Catalog identifier
         * @param {string} catalogVersionId Catalog version identifier
         * @param {string} categoryId Category identifier
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategories: function (baseSiteId, catalogId, catalogVersionId, categoryId, fields, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('getCategories', 'baseSiteId', baseSiteId);
                            // verify required parameter 'catalogId' is not null or undefined
                            assertParamExists('getCategories', 'catalogId', catalogId);
                            // verify required parameter 'catalogVersionId' is not null or undefined
                            assertParamExists('getCategories', 'catalogVersionId', catalogVersionId);
                            // verify required parameter 'categoryId' is not null or undefined
                            assertParamExists('getCategories', 'categoryId', categoryId);
                            localVarPath = "/{baseSiteId}/catalogs/{catalogId}/{catalogVersionId}/categories/{categoryId}"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'catalogId' + "}", encodeURIComponent(String(catalogId)))
                                .replace("{" + 'catalogVersionId' + "}", encodeURIComponent(String(catalogVersionId)))
                                .replace("{" + 'categoryId' + "}", encodeURIComponent(String(categoryId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        }
    };
};
/**
 * CatalogsApi - functional programming interface
 * @export
 */
var CatalogsApiFp = function (configuration) {
    var localVarAxiosParamCreator = CatalogsApiAxiosParamCreator(configuration);
    return {
        /**
         * Returns information about a catalog based on its ID, along with the versions defined for the current base store.
         * @summary Get a catalog
         * @param {string} baseSiteId Base site identifier
         * @param {string} catalogId Catalog identifier
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatalog: function (baseSiteId, catalogId, fields, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getCatalog(baseSiteId, catalogId, fields, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns information about the catalog version that exists for the current base store.
         * @summary Get information about catalog version
         * @param {string} baseSiteId Base site identifier
         * @param {string} catalogId Catalog identifier
         * @param {string} catalogVersionId Catalog version identifier
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatalogVersion: function (baseSiteId, catalogId, catalogVersionId, fields, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getCatalogVersion(baseSiteId, catalogId, catalogVersionId, fields, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns all catalogs with versions defined for the base store.
         * @summary Get a list of catalogs
         * @param {string} baseSiteId Base site identifier
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatalogs: function (baseSiteId, fields, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getCatalogs(baseSiteId, fields, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns information about a specified category that exists in a catalog version available for the current base store.
         * @summary Get information about catagory in a catalog version
         * @param {string} baseSiteId Base site identifier
         * @param {string} catalogId Catalog identifier
         * @param {string} catalogVersionId Catalog version identifier
         * @param {string} categoryId Category identifier
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategories: function (baseSiteId, catalogId, catalogVersionId, categoryId, fields, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getCategories(baseSiteId, catalogId, catalogVersionId, categoryId, fields, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        }
    };
};
/**
 * CatalogsApi - factory interface
 * @export
 */
var CatalogsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = CatalogsApiFp(configuration);
    return {
        /**
         * Returns information about a catalog based on its ID, along with the versions defined for the current base store.
         * @summary Get a catalog
         * @param {string} baseSiteId Base site identifier
         * @param {string} catalogId Catalog identifier
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatalog: function (baseSiteId, catalogId, fields, options) {
            return localVarFp
                .getCatalog(baseSiteId, catalogId, fields, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns information about the catalog version that exists for the current base store.
         * @summary Get information about catalog version
         * @param {string} baseSiteId Base site identifier
         * @param {string} catalogId Catalog identifier
         * @param {string} catalogVersionId Catalog version identifier
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatalogVersion: function (baseSiteId, catalogId, catalogVersionId, fields, options) {
            return localVarFp
                .getCatalogVersion(baseSiteId, catalogId, catalogVersionId, fields, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns all catalogs with versions defined for the base store.
         * @summary Get a list of catalogs
         * @param {string} baseSiteId Base site identifier
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatalogs: function (baseSiteId, fields, options) {
            return localVarFp
                .getCatalogs(baseSiteId, fields, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns information about a specified category that exists in a catalog version available for the current base store.
         * @summary Get information about catagory in a catalog version
         * @param {string} baseSiteId Base site identifier
         * @param {string} catalogId Catalog identifier
         * @param {string} catalogVersionId Catalog version identifier
         * @param {string} categoryId Category identifier
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategories: function (baseSiteId, catalogId, catalogVersionId, categoryId, fields, options) {
            return localVarFp
                .getCategories(baseSiteId, catalogId, catalogVersionId, categoryId, fields, options)
                .then(function (request) { return request(axios, basePath); });
        }
    };
};
/**
 * CatalogsApi - object-oriented interface
 * @export
 * @class CatalogsApi
 * @extends {BaseAPI}
 */
var CatalogsApi = /** @class */ (function (_super) {
    __extends(CatalogsApi, _super);
    function CatalogsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Returns information about a catalog based on its ID, along with the versions defined for the current base store.
     * @summary Get a catalog
     * @param {string} baseSiteId Base site identifier
     * @param {string} catalogId Catalog identifier
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CatalogsApi
     */
    CatalogsApi.prototype.getCatalog = function (baseSiteId, catalogId, fields, options) {
        var _this = this;
        return CatalogsApiFp(this.configuration)
            .getCatalog(baseSiteId, catalogId, fields, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns information about the catalog version that exists for the current base store.
     * @summary Get information about catalog version
     * @param {string} baseSiteId Base site identifier
     * @param {string} catalogId Catalog identifier
     * @param {string} catalogVersionId Catalog version identifier
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CatalogsApi
     */
    CatalogsApi.prototype.getCatalogVersion = function (baseSiteId, catalogId, catalogVersionId, fields, options) {
        var _this = this;
        return CatalogsApiFp(this.configuration)
            .getCatalogVersion(baseSiteId, catalogId, catalogVersionId, fields, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns all catalogs with versions defined for the base store.
     * @summary Get a list of catalogs
     * @param {string} baseSiteId Base site identifier
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CatalogsApi
     */
    CatalogsApi.prototype.getCatalogs = function (baseSiteId, fields, options) {
        var _this = this;
        return CatalogsApiFp(this.configuration)
            .getCatalogs(baseSiteId, fields, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns information about a specified category that exists in a catalog version available for the current base store.
     * @summary Get information about catagory in a catalog version
     * @param {string} baseSiteId Base site identifier
     * @param {string} catalogId Catalog identifier
     * @param {string} catalogVersionId Catalog version identifier
     * @param {string} categoryId Category identifier
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CatalogsApi
     */
    CatalogsApi.prototype.getCategories = function (baseSiteId, catalogId, catalogVersionId, categoryId, fields, options) {
        var _this = this;
        return CatalogsApiFp(this.configuration)
            .getCategories(baseSiteId, catalogId, catalogVersionId, categoryId, fields, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return CatalogsApi;
}(BaseAPI));
/**
 * ComponentApi - axios parameter creator
 * @export
 */
var ComponentApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Given a list of component identifiers, return cms component data.
         * @summary Find component data by id(s)
         * @param {string} baseSiteId Base site identifier
         * @param {string} [catalogCode] Catalog code
         * @param {string} [categoryCode] Category code
         * @param {Array<string>} [componentIds] List of Component identifiers
         * @param {number} [currentPage] Optional pagination parameter. Default value 0.
         * @param {'BASIC' | 'DEFAULT' | 'FULL'} [fields] Response configuration (list of fields, which should be returned in response)
         * @param {number} [pageSize] Optional pagination parameter. Default value 10.
         * @param {string} [productCode] Product code
         * @param {string} [sort] Optional sort criterion. No default value.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findComponentsByIds: function (baseSiteId, catalogCode, categoryCode, componentIds, currentPage, fields, pageSize, productCode, sort, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('findComponentsByIds', 'baseSiteId', baseSiteId);
                            localVarPath = "/{baseSiteId}/cms/components".replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (catalogCode !== undefined) {
                                localVarQueryParameter['catalogCode'] = catalogCode;
                            }
                            if (categoryCode !== undefined) {
                                localVarQueryParameter['categoryCode'] = categoryCode;
                            }
                            if (componentIds) {
                                localVarQueryParameter['componentIds'] = componentIds;
                            }
                            if (currentPage !== undefined) {
                                localVarQueryParameter['currentPage'] = currentPage;
                            }
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['pageSize'] = pageSize;
                            }
                            if (productCode !== undefined) {
                                localVarQueryParameter['productCode'] = productCode;
                            }
                            if (sort !== undefined) {
                                localVarQueryParameter['sort'] = sort;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Given a component identifier, return cms component data.
         * @summary Get component data
         * @param {string} baseSiteId Base site identifier
         * @param {string} componentId Component identifier
         * @param {string} [catalogCode] Catalog code
         * @param {string} [categoryCode] Category code
         * @param {'BASIC' | 'DEFAULT' | 'FULL'} [fields] Response configuration (list of fields, which should be returned in response)
         * @param {string} [productCode] Product code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getComponentById: function (baseSiteId, componentId, catalogCode, categoryCode, fields, productCode, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('getComponentById', 'baseSiteId', baseSiteId);
                            // verify required parameter 'componentId' is not null or undefined
                            assertParamExists('getComponentById', 'componentId', componentId);
                            localVarPath = "/{baseSiteId}/cms/components/{componentId}"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'componentId' + "}", encodeURIComponent(String(componentId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (catalogCode !== undefined) {
                                localVarQueryParameter['catalogCode'] = catalogCode;
                            }
                            if (categoryCode !== undefined) {
                                localVarQueryParameter['categoryCode'] = categoryCode;
                            }
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            if (productCode !== undefined) {
                                localVarQueryParameter['productCode'] = productCode;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Given a list of component identifiers in body, return cms component data.
         * @summary Get components\' data by id given in body
         * @param {string} baseSiteId Base site identifier
         * @param {ComponentIDList} componentIdList List of Component identifiers
         * @param {string} [catalogCode] Catalog code
         * @param {string} [categoryCode] Category code
         * @param {number} [currentPage] Optional pagination parameter. Default value 0.
         * @param {'BASIC' | 'DEFAULT' | 'FULL'} [fields] Response configuration (list of fields, which should be returned in response)
         * @param {number} [pageSize] Optional pagination parameter. Default value 10.
         * @param {string} [productCode] Product code
         * @param {string} [sort] Optional sort criterion. No default value.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchComponentsByIds: function (baseSiteId, componentIdList, catalogCode, categoryCode, currentPage, fields, pageSize, productCode, sort, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('searchComponentsByIds', 'baseSiteId', baseSiteId);
                            // verify required parameter 'componentIdList' is not null or undefined
                            assertParamExists('searchComponentsByIds', 'componentIdList', componentIdList);
                            localVarPath = "/{baseSiteId}/cms/components".replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (catalogCode !== undefined) {
                                localVarQueryParameter['catalogCode'] = catalogCode;
                            }
                            if (categoryCode !== undefined) {
                                localVarQueryParameter['categoryCode'] = categoryCode;
                            }
                            if (currentPage !== undefined) {
                                localVarQueryParameter['currentPage'] = currentPage;
                            }
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['pageSize'] = pageSize;
                            }
                            if (productCode !== undefined) {
                                localVarQueryParameter['productCode'] = productCode;
                            }
                            if (sort !== undefined) {
                                localVarQueryParameter['sort'] = sort;
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = serializeDataIfNeeded(componentIdList, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        }
    };
};
/**
 * ComponentApi - functional programming interface
 * @export
 */
var ComponentApiFp = function (configuration) {
    var localVarAxiosParamCreator = ComponentApiAxiosParamCreator(configuration);
    return {
        /**
         * Given a list of component identifiers, return cms component data.
         * @summary Find component data by id(s)
         * @param {string} baseSiteId Base site identifier
         * @param {string} [catalogCode] Catalog code
         * @param {string} [categoryCode] Category code
         * @param {Array<string>} [componentIds] List of Component identifiers
         * @param {number} [currentPage] Optional pagination parameter. Default value 0.
         * @param {'BASIC' | 'DEFAULT' | 'FULL'} [fields] Response configuration (list of fields, which should be returned in response)
         * @param {number} [pageSize] Optional pagination parameter. Default value 10.
         * @param {string} [productCode] Product code
         * @param {string} [sort] Optional sort criterion. No default value.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findComponentsByIds: function (baseSiteId, catalogCode, categoryCode, componentIds, currentPage, fields, pageSize, productCode, sort, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.findComponentsByIds(baseSiteId, catalogCode, categoryCode, componentIds, currentPage, fields, pageSize, productCode, sort, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Given a component identifier, return cms component data.
         * @summary Get component data
         * @param {string} baseSiteId Base site identifier
         * @param {string} componentId Component identifier
         * @param {string} [catalogCode] Catalog code
         * @param {string} [categoryCode] Category code
         * @param {'BASIC' | 'DEFAULT' | 'FULL'} [fields] Response configuration (list of fields, which should be returned in response)
         * @param {string} [productCode] Product code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getComponentById: function (baseSiteId, componentId, catalogCode, categoryCode, fields, productCode, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getComponentById(baseSiteId, componentId, catalogCode, categoryCode, fields, productCode, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Given a list of component identifiers in body, return cms component data.
         * @summary Get components\' data by id given in body
         * @param {string} baseSiteId Base site identifier
         * @param {ComponentIDList} componentIdList List of Component identifiers
         * @param {string} [catalogCode] Catalog code
         * @param {string} [categoryCode] Category code
         * @param {number} [currentPage] Optional pagination parameter. Default value 0.
         * @param {'BASIC' | 'DEFAULT' | 'FULL'} [fields] Response configuration (list of fields, which should be returned in response)
         * @param {number} [pageSize] Optional pagination parameter. Default value 10.
         * @param {string} [productCode] Product code
         * @param {string} [sort] Optional sort criterion. No default value.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchComponentsByIds: function (baseSiteId, componentIdList, catalogCode, categoryCode, currentPage, fields, pageSize, productCode, sort, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.searchComponentsByIds(baseSiteId, componentIdList, catalogCode, categoryCode, currentPage, fields, pageSize, productCode, sort, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        }
    };
};
/**
 * ComponentApi - factory interface
 * @export
 */
var ComponentApiFactory = function (configuration, basePath, axios) {
    var localVarFp = ComponentApiFp(configuration);
    return {
        /**
         * Given a list of component identifiers, return cms component data.
         * @summary Find component data by id(s)
         * @param {string} baseSiteId Base site identifier
         * @param {string} [catalogCode] Catalog code
         * @param {string} [categoryCode] Category code
         * @param {Array<string>} [componentIds] List of Component identifiers
         * @param {number} [currentPage] Optional pagination parameter. Default value 0.
         * @param {'BASIC' | 'DEFAULT' | 'FULL'} [fields] Response configuration (list of fields, which should be returned in response)
         * @param {number} [pageSize] Optional pagination parameter. Default value 10.
         * @param {string} [productCode] Product code
         * @param {string} [sort] Optional sort criterion. No default value.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findComponentsByIds: function (baseSiteId, catalogCode, categoryCode, componentIds, currentPage, fields, pageSize, productCode, sort, options) {
            return localVarFp
                .findComponentsByIds(baseSiteId, catalogCode, categoryCode, componentIds, currentPage, fields, pageSize, productCode, sort, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Given a component identifier, return cms component data.
         * @summary Get component data
         * @param {string} baseSiteId Base site identifier
         * @param {string} componentId Component identifier
         * @param {string} [catalogCode] Catalog code
         * @param {string} [categoryCode] Category code
         * @param {'BASIC' | 'DEFAULT' | 'FULL'} [fields] Response configuration (list of fields, which should be returned in response)
         * @param {string} [productCode] Product code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getComponentById: function (baseSiteId, componentId, catalogCode, categoryCode, fields, productCode, options) {
            return localVarFp
                .getComponentById(baseSiteId, componentId, catalogCode, categoryCode, fields, productCode, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Given a list of component identifiers in body, return cms component data.
         * @summary Get components\' data by id given in body
         * @param {string} baseSiteId Base site identifier
         * @param {ComponentIDList} componentIdList List of Component identifiers
         * @param {string} [catalogCode] Catalog code
         * @param {string} [categoryCode] Category code
         * @param {number} [currentPage] Optional pagination parameter. Default value 0.
         * @param {'BASIC' | 'DEFAULT' | 'FULL'} [fields] Response configuration (list of fields, which should be returned in response)
         * @param {number} [pageSize] Optional pagination parameter. Default value 10.
         * @param {string} [productCode] Product code
         * @param {string} [sort] Optional sort criterion. No default value.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchComponentsByIds: function (baseSiteId, componentIdList, catalogCode, categoryCode, currentPage, fields, pageSize, productCode, sort, options) {
            return localVarFp
                .searchComponentsByIds(baseSiteId, componentIdList, catalogCode, categoryCode, currentPage, fields, pageSize, productCode, sort, options)
                .then(function (request) { return request(axios, basePath); });
        }
    };
};
/**
 * ComponentApi - object-oriented interface
 * @export
 * @class ComponentApi
 * @extends {BaseAPI}
 */
var ComponentApi = /** @class */ (function (_super) {
    __extends(ComponentApi, _super);
    function ComponentApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Given a list of component identifiers, return cms component data.
     * @summary Find component data by id(s)
     * @param {string} baseSiteId Base site identifier
     * @param {string} [catalogCode] Catalog code
     * @param {string} [categoryCode] Category code
     * @param {Array<string>} [componentIds] List of Component identifiers
     * @param {number} [currentPage] Optional pagination parameter. Default value 0.
     * @param {'BASIC' | 'DEFAULT' | 'FULL'} [fields] Response configuration (list of fields, which should be returned in response)
     * @param {number} [pageSize] Optional pagination parameter. Default value 10.
     * @param {string} [productCode] Product code
     * @param {string} [sort] Optional sort criterion. No default value.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentApi
     */
    ComponentApi.prototype.findComponentsByIds = function (baseSiteId, catalogCode, categoryCode, componentIds, currentPage, fields, pageSize, productCode, sort, options) {
        var _this = this;
        return ComponentApiFp(this.configuration)
            .findComponentsByIds(baseSiteId, catalogCode, categoryCode, componentIds, currentPage, fields, pageSize, productCode, sort, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Given a component identifier, return cms component data.
     * @summary Get component data
     * @param {string} baseSiteId Base site identifier
     * @param {string} componentId Component identifier
     * @param {string} [catalogCode] Catalog code
     * @param {string} [categoryCode] Category code
     * @param {'BASIC' | 'DEFAULT' | 'FULL'} [fields] Response configuration (list of fields, which should be returned in response)
     * @param {string} [productCode] Product code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentApi
     */
    ComponentApi.prototype.getComponentById = function (baseSiteId, componentId, catalogCode, categoryCode, fields, productCode, options) {
        var _this = this;
        return ComponentApiFp(this.configuration)
            .getComponentById(baseSiteId, componentId, catalogCode, categoryCode, fields, productCode, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Given a list of component identifiers in body, return cms component data.
     * @summary Get components\' data by id given in body
     * @param {string} baseSiteId Base site identifier
     * @param {ComponentIDList} componentIdList List of Component identifiers
     * @param {string} [catalogCode] Catalog code
     * @param {string} [categoryCode] Category code
     * @param {number} [currentPage] Optional pagination parameter. Default value 0.
     * @param {'BASIC' | 'DEFAULT' | 'FULL'} [fields] Response configuration (list of fields, which should be returned in response)
     * @param {number} [pageSize] Optional pagination parameter. Default value 10.
     * @param {string} [productCode] Product code
     * @param {string} [sort] Optional sort criterion. No default value.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentApi
     */
    ComponentApi.prototype.searchComponentsByIds = function (baseSiteId, componentIdList, catalogCode, categoryCode, currentPage, fields, pageSize, productCode, sort, options) {
        var _this = this;
        return ComponentApiFp(this.configuration)
            .searchComponentsByIds(baseSiteId, componentIdList, catalogCode, categoryCode, currentPage, fields, pageSize, productCode, sort, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ComponentApi;
}(BaseAPI));
/**
 * ConsentsApi - axios parameter creator
 * @export
 */
var ConsentsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary A user can give consent.
         * @param {string} baseSiteId Base site identifier
         * @param {string} consentTemplateId Consent template ID.
         * @param {number} consentTemplateVersion Consent template version.
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doGiveConsent: function (baseSiteId, consentTemplateId, consentTemplateVersion, userId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('doGiveConsent', 'baseSiteId', baseSiteId);
                            // verify required parameter 'consentTemplateId' is not null or undefined
                            assertParamExists('doGiveConsent', 'consentTemplateId', consentTemplateId);
                            // verify required parameter 'consentTemplateVersion' is not null or undefined
                            assertParamExists('doGiveConsent', 'consentTemplateVersion', consentTemplateVersion);
                            // verify required parameter 'userId' is not null or undefined
                            assertParamExists('doGiveConsent', 'userId', userId);
                            localVarPath = "/{baseSiteId}/users/{userId}/consents"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'userId' + "}", encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (consentTemplateId !== undefined) {
                                localVarQueryParameter['consentTemplateId'] = consentTemplateId;
                            }
                            if (consentTemplateVersion !== undefined) {
                                localVarQueryParameter['consentTemplateVersion'] = consentTemplateVersion;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * If user has not given or withdrawn consent to the template, no given or withdraw date is returned.
         * @summary Fetch the consent.
         * @param {string} baseSiteId Base site identifier
         * @param {string} consentTemplateId Consent template id.
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConsentTemplate: function (baseSiteId, consentTemplateId, userId, fields, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('getConsentTemplate', 'baseSiteId', baseSiteId);
                            // verify required parameter 'consentTemplateId' is not null or undefined
                            assertParamExists('getConsentTemplate', 'consentTemplateId', consentTemplateId);
                            // verify required parameter 'userId' is not null or undefined
                            assertParamExists('getConsentTemplate', 'userId', userId);
                            localVarPath = "/{baseSiteId}/users/{userId}/consenttemplates/{consentTemplateId}"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'consentTemplateId' + "}", encodeURIComponent(String(consentTemplateId)))
                                .replace("{" + 'userId' + "}", encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * If user has not given or withdrawn consent to any of the template, no given or withdraw date is returned.
         * @summary Fetch the list of consents
         * @param {string} baseSiteId Base site identifier
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConsentTemplates: function (baseSiteId, userId, fields, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('getConsentTemplates', 'baseSiteId', baseSiteId);
                            // verify required parameter 'userId' is not null or undefined
                            assertParamExists('getConsentTemplates', 'userId', userId);
                            localVarPath = "/{baseSiteId}/users/{userId}/consenttemplates"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'userId' + "}", encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * If the user consent was given, the consent is withdrawn. If consent was already withdrawn then returns consent already withdrawn error. If there is no such consent then returns not found. If the current user is an anonymous user then returns access denied error.
         * @summary Withdraw the user consent for a given consent code.
         * @param {string} baseSiteId Base site identifier
         * @param {string} consentCode Consent code.
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeConsent: function (baseSiteId, consentCode, userId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('removeConsent', 'baseSiteId', baseSiteId);
                            // verify required parameter 'consentCode' is not null or undefined
                            assertParamExists('removeConsent', 'consentCode', consentCode);
                            // verify required parameter 'userId' is not null or undefined
                            assertParamExists('removeConsent', 'userId', userId);
                            localVarPath = "/{baseSiteId}/users/{userId}/consents/{consentCode}"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'consentCode' + "}", encodeURIComponent(String(consentCode)))
                                .replace("{" + 'userId' + "}", encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        }
    };
};
/**
 * ConsentsApi - functional programming interface
 * @export
 */
var ConsentsApiFp = function (configuration) {
    var localVarAxiosParamCreator = ConsentsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary A user can give consent.
         * @param {string} baseSiteId Base site identifier
         * @param {string} consentTemplateId Consent template ID.
         * @param {number} consentTemplateVersion Consent template version.
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doGiveConsent: function (baseSiteId, consentTemplateId, consentTemplateVersion, userId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.doGiveConsent(baseSiteId, consentTemplateId, consentTemplateVersion, userId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * If user has not given or withdrawn consent to the template, no given or withdraw date is returned.
         * @summary Fetch the consent.
         * @param {string} baseSiteId Base site identifier
         * @param {string} consentTemplateId Consent template id.
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConsentTemplate: function (baseSiteId, consentTemplateId, userId, fields, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getConsentTemplate(baseSiteId, consentTemplateId, userId, fields, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * If user has not given or withdrawn consent to any of the template, no given or withdraw date is returned.
         * @summary Fetch the list of consents
         * @param {string} baseSiteId Base site identifier
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConsentTemplates: function (baseSiteId, userId, fields, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getConsentTemplates(baseSiteId, userId, fields, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * If the user consent was given, the consent is withdrawn. If consent was already withdrawn then returns consent already withdrawn error. If there is no such consent then returns not found. If the current user is an anonymous user then returns access denied error.
         * @summary Withdraw the user consent for a given consent code.
         * @param {string} baseSiteId Base site identifier
         * @param {string} consentCode Consent code.
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeConsent: function (baseSiteId, consentCode, userId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.removeConsent(baseSiteId, consentCode, userId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        }
    };
};
/**
 * ConsentsApi - factory interface
 * @export
 */
var ConsentsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = ConsentsApiFp(configuration);
    return {
        /**
         *
         * @summary A user can give consent.
         * @param {string} baseSiteId Base site identifier
         * @param {string} consentTemplateId Consent template ID.
         * @param {number} consentTemplateVersion Consent template version.
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doGiveConsent: function (baseSiteId, consentTemplateId, consentTemplateVersion, userId, options) {
            return localVarFp
                .doGiveConsent(baseSiteId, consentTemplateId, consentTemplateVersion, userId, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * If user has not given or withdrawn consent to the template, no given or withdraw date is returned.
         * @summary Fetch the consent.
         * @param {string} baseSiteId Base site identifier
         * @param {string} consentTemplateId Consent template id.
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConsentTemplate: function (baseSiteId, consentTemplateId, userId, fields, options) {
            return localVarFp
                .getConsentTemplate(baseSiteId, consentTemplateId, userId, fields, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * If user has not given or withdrawn consent to any of the template, no given or withdraw date is returned.
         * @summary Fetch the list of consents
         * @param {string} baseSiteId Base site identifier
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConsentTemplates: function (baseSiteId, userId, fields, options) {
            return localVarFp
                .getConsentTemplates(baseSiteId, userId, fields, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * If the user consent was given, the consent is withdrawn. If consent was already withdrawn then returns consent already withdrawn error. If there is no such consent then returns not found. If the current user is an anonymous user then returns access denied error.
         * @summary Withdraw the user consent for a given consent code.
         * @param {string} baseSiteId Base site identifier
         * @param {string} consentCode Consent code.
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeConsent: function (baseSiteId, consentCode, userId, options) {
            return localVarFp
                .removeConsent(baseSiteId, consentCode, userId, options)
                .then(function (request) { return request(axios, basePath); });
        }
    };
};
/**
 * ConsentsApi - object-oriented interface
 * @export
 * @class ConsentsApi
 * @extends {BaseAPI}
 */
var ConsentsApi = /** @class */ (function (_super) {
    __extends(ConsentsApi, _super);
    function ConsentsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary A user can give consent.
     * @param {string} baseSiteId Base site identifier
     * @param {string} consentTemplateId Consent template ID.
     * @param {number} consentTemplateVersion Consent template version.
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConsentsApi
     */
    ConsentsApi.prototype.doGiveConsent = function (baseSiteId, consentTemplateId, consentTemplateVersion, userId, options) {
        var _this = this;
        return ConsentsApiFp(this.configuration)
            .doGiveConsent(baseSiteId, consentTemplateId, consentTemplateVersion, userId, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * If user has not given or withdrawn consent to the template, no given or withdraw date is returned.
     * @summary Fetch the consent.
     * @param {string} baseSiteId Base site identifier
     * @param {string} consentTemplateId Consent template id.
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConsentsApi
     */
    ConsentsApi.prototype.getConsentTemplate = function (baseSiteId, consentTemplateId, userId, fields, options) {
        var _this = this;
        return ConsentsApiFp(this.configuration)
            .getConsentTemplate(baseSiteId, consentTemplateId, userId, fields, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * If user has not given or withdrawn consent to any of the template, no given or withdraw date is returned.
     * @summary Fetch the list of consents
     * @param {string} baseSiteId Base site identifier
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConsentsApi
     */
    ConsentsApi.prototype.getConsentTemplates = function (baseSiteId, userId, fields, options) {
        var _this = this;
        return ConsentsApiFp(this.configuration)
            .getConsentTemplates(baseSiteId, userId, fields, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * If the user consent was given, the consent is withdrawn. If consent was already withdrawn then returns consent already withdrawn error. If there is no such consent then returns not found. If the current user is an anonymous user then returns access denied error.
     * @summary Withdraw the user consent for a given consent code.
     * @param {string} baseSiteId Base site identifier
     * @param {string} consentCode Consent code.
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConsentsApi
     */
    ConsentsApi.prototype.removeConsent = function (baseSiteId, consentCode, userId, options) {
        var _this = this;
        return ConsentsApiFp(this.configuration)
            .removeConsent(baseSiteId, consentCode, userId, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ConsentsApi;
}(BaseAPI));
/**
 * ConsignmentTrackingApi - axios parameter creator
 * @export
 */
var ConsignmentTrackingApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Returns details of consignment tracking information based on the order code and the consignment code.
         * @summary Gets consignment tracking information
         * @param {string} baseSiteId Base site identifier
         * @param {string} consignmentCode consignment identifier
         * @param {string} orderCode order identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConsignmentTrackingDataUsingGET: function (baseSiteId, consignmentCode, orderCode, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('getConsignmentTrackingDataUsingGET', 'baseSiteId', baseSiteId);
                            // verify required parameter 'consignmentCode' is not null or undefined
                            assertParamExists('getConsignmentTrackingDataUsingGET', 'consignmentCode', consignmentCode);
                            // verify required parameter 'orderCode' is not null or undefined
                            assertParamExists('getConsignmentTrackingDataUsingGET', 'orderCode', orderCode);
                            localVarPath = "/{baseSiteId}/orders/{orderCode}/consignments/{consignmentCode}/tracking"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'consignmentCode' + "}", encodeURIComponent(String(consignmentCode)))
                                .replace("{" + 'orderCode' + "}", encodeURIComponent(String(orderCode)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        }
    };
};
/**
 * ConsignmentTrackingApi - functional programming interface
 * @export
 */
var ConsignmentTrackingApiFp = function (configuration) {
    var localVarAxiosParamCreator = ConsignmentTrackingApiAxiosParamCreator(configuration);
    return {
        /**
         * Returns details of consignment tracking information based on the order code and the consignment code.
         * @summary Gets consignment tracking information
         * @param {string} baseSiteId Base site identifier
         * @param {string} consignmentCode consignment identifier
         * @param {string} orderCode order identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConsignmentTrackingDataUsingGET: function (baseSiteId, consignmentCode, orderCode, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getConsignmentTrackingDataUsingGET(baseSiteId, consignmentCode, orderCode, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        }
    };
};
/**
 * ConsignmentTrackingApi - factory interface
 * @export
 */
var ConsignmentTrackingApiFactory = function (configuration, basePath, axios) {
    var localVarFp = ConsignmentTrackingApiFp(configuration);
    return {
        /**
         * Returns details of consignment tracking information based on the order code and the consignment code.
         * @summary Gets consignment tracking information
         * @param {string} baseSiteId Base site identifier
         * @param {string} consignmentCode consignment identifier
         * @param {string} orderCode order identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConsignmentTrackingDataUsingGET: function (baseSiteId, consignmentCode, orderCode, options) {
            return localVarFp
                .getConsignmentTrackingDataUsingGET(baseSiteId, consignmentCode, orderCode, options)
                .then(function (request) { return request(axios, basePath); });
        }
    };
};
/**
 * ConsignmentTrackingApi - object-oriented interface
 * @export
 * @class ConsignmentTrackingApi
 * @extends {BaseAPI}
 */
var ConsignmentTrackingApi = /** @class */ (function (_super) {
    __extends(ConsignmentTrackingApi, _super);
    function ConsignmentTrackingApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Returns details of consignment tracking information based on the order code and the consignment code.
     * @summary Gets consignment tracking information
     * @param {string} baseSiteId Base site identifier
     * @param {string} consignmentCode consignment identifier
     * @param {string} orderCode order identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConsignmentTrackingApi
     */
    ConsignmentTrackingApi.prototype.getConsignmentTrackingDataUsingGET = function (baseSiteId, consignmentCode, orderCode, options) {
        var _this = this;
        return ConsignmentTrackingApiFp(this.configuration)
            .getConsignmentTrackingDataUsingGET(baseSiteId, consignmentCode, orderCode, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ConsignmentTrackingApi;
}(BaseAPI));
/**
 * CountriesApi - axios parameter creator
 * @export
 */
var CountriesApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * If the value of type equals to shipping, then return shipping countries. If the value of type equals to billing, then return billing countries. If the value of type is not given, return all countries. The list is sorted alphabetically.
         * @summary Get a list of countries.
         * @param {string} baseSiteId Base site identifier
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {'SHIPPING' | 'BILLING'} [type] The type of countries.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountries: function (baseSiteId, fields, type, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('getCountries', 'baseSiteId', baseSiteId);
                            localVarPath = "/{baseSiteId}/countries".replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            if (type !== undefined) {
                                localVarQueryParameter['type'] = type;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Lists all regions.
         * @summary Fetch the list of regions for the provided country.
         * @param {string} baseSiteId Base site identifier
         * @param {string} countyIsoCode An ISO code for a country
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountryRegions: function (baseSiteId, countyIsoCode, fields, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('getCountryRegions', 'baseSiteId', baseSiteId);
                            // verify required parameter 'countyIsoCode' is not null or undefined
                            assertParamExists('getCountryRegions', 'countyIsoCode', countyIsoCode);
                            localVarPath = "/{baseSiteId}/countries/{countyIsoCode}/regions"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'countyIsoCode' + "}", encodeURIComponent(String(countyIsoCode)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        }
    };
};
/**
 * CountriesApi - functional programming interface
 * @export
 */
var CountriesApiFp = function (configuration) {
    var localVarAxiosParamCreator = CountriesApiAxiosParamCreator(configuration);
    return {
        /**
         * If the value of type equals to shipping, then return shipping countries. If the value of type equals to billing, then return billing countries. If the value of type is not given, return all countries. The list is sorted alphabetically.
         * @summary Get a list of countries.
         * @param {string} baseSiteId Base site identifier
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {'SHIPPING' | 'BILLING'} [type] The type of countries.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountries: function (baseSiteId, fields, type, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getCountries(baseSiteId, fields, type, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Lists all regions.
         * @summary Fetch the list of regions for the provided country.
         * @param {string} baseSiteId Base site identifier
         * @param {string} countyIsoCode An ISO code for a country
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountryRegions: function (baseSiteId, countyIsoCode, fields, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getCountryRegions(baseSiteId, countyIsoCode, fields, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        }
    };
};
/**
 * CountriesApi - factory interface
 * @export
 */
var CountriesApiFactory = function (configuration, basePath, axios) {
    var localVarFp = CountriesApiFp(configuration);
    return {
        /**
         * If the value of type equals to shipping, then return shipping countries. If the value of type equals to billing, then return billing countries. If the value of type is not given, return all countries. The list is sorted alphabetically.
         * @summary Get a list of countries.
         * @param {string} baseSiteId Base site identifier
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {'SHIPPING' | 'BILLING'} [type] The type of countries.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountries: function (baseSiteId, fields, type, options) {
            return localVarFp
                .getCountries(baseSiteId, fields, type, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Lists all regions.
         * @summary Fetch the list of regions for the provided country.
         * @param {string} baseSiteId Base site identifier
         * @param {string} countyIsoCode An ISO code for a country
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountryRegions: function (baseSiteId, countyIsoCode, fields, options) {
            return localVarFp
                .getCountryRegions(baseSiteId, countyIsoCode, fields, options)
                .then(function (request) { return request(axios, basePath); });
        }
    };
};
/**
 * CountriesApi - object-oriented interface
 * @export
 * @class CountriesApi
 * @extends {BaseAPI}
 */
var CountriesApi = /** @class */ (function (_super) {
    __extends(CountriesApi, _super);
    function CountriesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * If the value of type equals to shipping, then return shipping countries. If the value of type equals to billing, then return billing countries. If the value of type is not given, return all countries. The list is sorted alphabetically.
     * @summary Get a list of countries.
     * @param {string} baseSiteId Base site identifier
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
     * @param {'SHIPPING' | 'BILLING'} [type] The type of countries.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CountriesApi
     */
    CountriesApi.prototype.getCountries = function (baseSiteId, fields, type, options) {
        var _this = this;
        return CountriesApiFp(this.configuration)
            .getCountries(baseSiteId, fields, type, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Lists all regions.
     * @summary Fetch the list of regions for the provided country.
     * @param {string} baseSiteId Base site identifier
     * @param {string} countyIsoCode An ISO code for a country
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CountriesApi
     */
    CountriesApi.prototype.getCountryRegions = function (baseSiteId, countyIsoCode, fields, options) {
        var _this = this;
        return CountriesApiFp(this.configuration)
            .getCountryRegions(baseSiteId, countyIsoCode, fields, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return CountriesApi;
}(BaseAPI));
/**
 * CustomerGroupsApi - axios parameter creator
 * @export
 */
var CustomerGroupsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Creates a new customer group that is a direct subgroup of a customergroup.  To try out the methods of the Customer Groups controller, you must authorize a user who belongs to the “customermanagergroup”.
         * @summary Creates a new customer group.
         * @param {string} baseSiteId Base site identifier
         * @param {UserGroup} userGroup User group object with id and name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomerGroup: function (baseSiteId, userGroup, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('createCustomerGroup', 'baseSiteId', baseSiteId);
                            // verify required parameter 'userGroup' is not null or undefined
                            assertParamExists('createCustomerGroup', 'userGroup', userGroup);
                            localVarPath = "/{baseSiteId}/customergroups".replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/xml';
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = serializeDataIfNeeded(userGroup, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Returns a customer group with a specific groupId.  To try out the methods of the Customer Groups controller, you must authorize a user who belongs to the “customermanagergroup”.
         * @summary Get a specific customer group.
         * @param {string} baseSiteId Base site identifier
         * @param {string} groupId Group identifier.
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerGroup: function (baseSiteId, groupId, fields, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('getCustomerGroup', 'baseSiteId', baseSiteId);
                            // verify required parameter 'groupId' is not null or undefined
                            assertParamExists('getCustomerGroup', 'groupId', groupId);
                            localVarPath = "/{baseSiteId}/customergroups/{groupId}"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'groupId' + "}", encodeURIComponent(String(groupId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Returns all customer groups that are direct subgroups of a customergroup.  To try out the methods of the Customer Groups controller, you must authorize a user who belongs to the “customermanagergroup”.
         * @summary Get all subgroups of a customergroup.
         * @param {string} baseSiteId Base site identifier
         * @param {number} [currentPage] Current page number (starts with 0).
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {number} [pageSize] Number of customer group returned in one page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerGroups: function (baseSiteId, currentPage, fields, pageSize, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('getCustomerGroups', 'baseSiteId', baseSiteId);
                            localVarPath = "/{baseSiteId}/customergroups".replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (currentPage !== undefined) {
                                localVarQueryParameter['currentPage'] = currentPage;
                            }
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['pageSize'] = pageSize;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Deletes user from a customer group.  To try out the methods of the Customer Groups controller, you must authorize a user who belongs to the “customermanagergroup”.
         * @summary Deletes a user from a customer group.
         * @param {string} baseSiteId Base site identifier
         * @param {string} groupId Group identifier.
         * @param {string} userId User identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeUsersFromCustomerGroup: function (baseSiteId, groupId, userId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('removeUsersFromCustomerGroup', 'baseSiteId', baseSiteId);
                            // verify required parameter 'groupId' is not null or undefined
                            assertParamExists('removeUsersFromCustomerGroup', 'groupId', groupId);
                            // verify required parameter 'userId' is not null or undefined
                            assertParamExists('removeUsersFromCustomerGroup', 'userId', userId);
                            localVarPath = "/{baseSiteId}/customergroups/{groupId}/members/{userId}"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'groupId' + "}", encodeURIComponent(String(groupId)))
                                .replace("{" + 'userId' + "}", encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Sets members for a user group. The list of existing members is overwritten with a new one.  To try out the methods of the Customer Groups controller, you must authorize a user who belongs to the “customermanagergroup”.
         * @summary Sets members for a user group.
         * @param {string} baseSiteId Base site identifier
         * @param {string} groupId Group identifier.
         * @param {MemberList} members List of users to set for customer group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceUsersForCustomerGroup: function (baseSiteId, groupId, members, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('replaceUsersForCustomerGroup', 'baseSiteId', baseSiteId);
                            // verify required parameter 'groupId' is not null or undefined
                            assertParamExists('replaceUsersForCustomerGroup', 'groupId', groupId);
                            // verify required parameter 'members' is not null or undefined
                            assertParamExists('replaceUsersForCustomerGroup', 'members', members);
                            localVarPath = "/{baseSiteId}/customergroups/{groupId}/members"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'groupId' + "}", encodeURIComponent(String(groupId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/xml';
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = serializeDataIfNeeded(members, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Assigns user(s) to a customer group.  To try out the methods of the Customer Groups controller, you must authorize a user who belongs to the “customermanagergroup”.
         * @summary Assigns user(s) to a customer group.
         * @param {string} baseSiteId Base site identifier
         * @param {string} groupId Group identifier.
         * @param {MemberList} members List of users to assign to customer group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomerGroupWithUsers: function (baseSiteId, groupId, members, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('updateCustomerGroupWithUsers', 'baseSiteId', baseSiteId);
                            // verify required parameter 'groupId' is not null or undefined
                            assertParamExists('updateCustomerGroupWithUsers', 'groupId', groupId);
                            // verify required parameter 'members' is not null or undefined
                            assertParamExists('updateCustomerGroupWithUsers', 'members', members);
                            localVarPath = "/{baseSiteId}/customergroups/{groupId}/members"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'groupId' + "}", encodeURIComponent(String(groupId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/xml';
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = serializeDataIfNeeded(members, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        }
    };
};
/**
 * CustomerGroupsApi - functional programming interface
 * @export
 */
var CustomerGroupsApiFp = function (configuration) {
    var localVarAxiosParamCreator = CustomerGroupsApiAxiosParamCreator(configuration);
    return {
        /**
         * Creates a new customer group that is a direct subgroup of a customergroup.  To try out the methods of the Customer Groups controller, you must authorize a user who belongs to the “customermanagergroup”.
         * @summary Creates a new customer group.
         * @param {string} baseSiteId Base site identifier
         * @param {UserGroup} userGroup User group object with id and name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomerGroup: function (baseSiteId, userGroup, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createCustomerGroup(baseSiteId, userGroup, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns a customer group with a specific groupId.  To try out the methods of the Customer Groups controller, you must authorize a user who belongs to the “customermanagergroup”.
         * @summary Get a specific customer group.
         * @param {string} baseSiteId Base site identifier
         * @param {string} groupId Group identifier.
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerGroup: function (baseSiteId, groupId, fields, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getCustomerGroup(baseSiteId, groupId, fields, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns all customer groups that are direct subgroups of a customergroup.  To try out the methods of the Customer Groups controller, you must authorize a user who belongs to the “customermanagergroup”.
         * @summary Get all subgroups of a customergroup.
         * @param {string} baseSiteId Base site identifier
         * @param {number} [currentPage] Current page number (starts with 0).
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {number} [pageSize] Number of customer group returned in one page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerGroups: function (baseSiteId, currentPage, fields, pageSize, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getCustomerGroups(baseSiteId, currentPage, fields, pageSize, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Deletes user from a customer group.  To try out the methods of the Customer Groups controller, you must authorize a user who belongs to the “customermanagergroup”.
         * @summary Deletes a user from a customer group.
         * @param {string} baseSiteId Base site identifier
         * @param {string} groupId Group identifier.
         * @param {string} userId User identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeUsersFromCustomerGroup: function (baseSiteId, groupId, userId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.removeUsersFromCustomerGroup(baseSiteId, groupId, userId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Sets members for a user group. The list of existing members is overwritten with a new one.  To try out the methods of the Customer Groups controller, you must authorize a user who belongs to the “customermanagergroup”.
         * @summary Sets members for a user group.
         * @param {string} baseSiteId Base site identifier
         * @param {string} groupId Group identifier.
         * @param {MemberList} members List of users to set for customer group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceUsersForCustomerGroup: function (baseSiteId, groupId, members, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.replaceUsersForCustomerGroup(baseSiteId, groupId, members, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Assigns user(s) to a customer group.  To try out the methods of the Customer Groups controller, you must authorize a user who belongs to the “customermanagergroup”.
         * @summary Assigns user(s) to a customer group.
         * @param {string} baseSiteId Base site identifier
         * @param {string} groupId Group identifier.
         * @param {MemberList} members List of users to assign to customer group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomerGroupWithUsers: function (baseSiteId, groupId, members, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateCustomerGroupWithUsers(baseSiteId, groupId, members, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        }
    };
};
/**
 * CustomerGroupsApi - factory interface
 * @export
 */
var CustomerGroupsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = CustomerGroupsApiFp(configuration);
    return {
        /**
         * Creates a new customer group that is a direct subgroup of a customergroup.  To try out the methods of the Customer Groups controller, you must authorize a user who belongs to the “customermanagergroup”.
         * @summary Creates a new customer group.
         * @param {string} baseSiteId Base site identifier
         * @param {UserGroup} userGroup User group object with id and name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomerGroup: function (baseSiteId, userGroup, options) {
            return localVarFp
                .createCustomerGroup(baseSiteId, userGroup, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns a customer group with a specific groupId.  To try out the methods of the Customer Groups controller, you must authorize a user who belongs to the “customermanagergroup”.
         * @summary Get a specific customer group.
         * @param {string} baseSiteId Base site identifier
         * @param {string} groupId Group identifier.
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerGroup: function (baseSiteId, groupId, fields, options) {
            return localVarFp
                .getCustomerGroup(baseSiteId, groupId, fields, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns all customer groups that are direct subgroups of a customergroup.  To try out the methods of the Customer Groups controller, you must authorize a user who belongs to the “customermanagergroup”.
         * @summary Get all subgroups of a customergroup.
         * @param {string} baseSiteId Base site identifier
         * @param {number} [currentPage] Current page number (starts with 0).
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {number} [pageSize] Number of customer group returned in one page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerGroups: function (baseSiteId, currentPage, fields, pageSize, options) {
            return localVarFp
                .getCustomerGroups(baseSiteId, currentPage, fields, pageSize, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Deletes user from a customer group.  To try out the methods of the Customer Groups controller, you must authorize a user who belongs to the “customermanagergroup”.
         * @summary Deletes a user from a customer group.
         * @param {string} baseSiteId Base site identifier
         * @param {string} groupId Group identifier.
         * @param {string} userId User identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeUsersFromCustomerGroup: function (baseSiteId, groupId, userId, options) {
            return localVarFp
                .removeUsersFromCustomerGroup(baseSiteId, groupId, userId, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Sets members for a user group. The list of existing members is overwritten with a new one.  To try out the methods of the Customer Groups controller, you must authorize a user who belongs to the “customermanagergroup”.
         * @summary Sets members for a user group.
         * @param {string} baseSiteId Base site identifier
         * @param {string} groupId Group identifier.
         * @param {MemberList} members List of users to set for customer group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceUsersForCustomerGroup: function (baseSiteId, groupId, members, options) {
            return localVarFp
                .replaceUsersForCustomerGroup(baseSiteId, groupId, members, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Assigns user(s) to a customer group.  To try out the methods of the Customer Groups controller, you must authorize a user who belongs to the “customermanagergroup”.
         * @summary Assigns user(s) to a customer group.
         * @param {string} baseSiteId Base site identifier
         * @param {string} groupId Group identifier.
         * @param {MemberList} members List of users to assign to customer group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomerGroupWithUsers: function (baseSiteId, groupId, members, options) {
            return localVarFp
                .updateCustomerGroupWithUsers(baseSiteId, groupId, members, options)
                .then(function (request) { return request(axios, basePath); });
        }
    };
};
/**
 * CustomerGroupsApi - object-oriented interface
 * @export
 * @class CustomerGroupsApi
 * @extends {BaseAPI}
 */
var CustomerGroupsApi = /** @class */ (function (_super) {
    __extends(CustomerGroupsApi, _super);
    function CustomerGroupsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Creates a new customer group that is a direct subgroup of a customergroup.  To try out the methods of the Customer Groups controller, you must authorize a user who belongs to the “customermanagergroup”.
     * @summary Creates a new customer group.
     * @param {string} baseSiteId Base site identifier
     * @param {UserGroup} userGroup User group object with id and name.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerGroupsApi
     */
    CustomerGroupsApi.prototype.createCustomerGroup = function (baseSiteId, userGroup, options) {
        var _this = this;
        return CustomerGroupsApiFp(this.configuration)
            .createCustomerGroup(baseSiteId, userGroup, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns a customer group with a specific groupId.  To try out the methods of the Customer Groups controller, you must authorize a user who belongs to the “customermanagergroup”.
     * @summary Get a specific customer group.
     * @param {string} baseSiteId Base site identifier
     * @param {string} groupId Group identifier.
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerGroupsApi
     */
    CustomerGroupsApi.prototype.getCustomerGroup = function (baseSiteId, groupId, fields, options) {
        var _this = this;
        return CustomerGroupsApiFp(this.configuration)
            .getCustomerGroup(baseSiteId, groupId, fields, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns all customer groups that are direct subgroups of a customergroup.  To try out the methods of the Customer Groups controller, you must authorize a user who belongs to the “customermanagergroup”.
     * @summary Get all subgroups of a customergroup.
     * @param {string} baseSiteId Base site identifier
     * @param {number} [currentPage] Current page number (starts with 0).
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
     * @param {number} [pageSize] Number of customer group returned in one page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerGroupsApi
     */
    CustomerGroupsApi.prototype.getCustomerGroups = function (baseSiteId, currentPage, fields, pageSize, options) {
        var _this = this;
        return CustomerGroupsApiFp(this.configuration)
            .getCustomerGroups(baseSiteId, currentPage, fields, pageSize, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Deletes user from a customer group.  To try out the methods of the Customer Groups controller, you must authorize a user who belongs to the “customermanagergroup”.
     * @summary Deletes a user from a customer group.
     * @param {string} baseSiteId Base site identifier
     * @param {string} groupId Group identifier.
     * @param {string} userId User identifier.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerGroupsApi
     */
    CustomerGroupsApi.prototype.removeUsersFromCustomerGroup = function (baseSiteId, groupId, userId, options) {
        var _this = this;
        return CustomerGroupsApiFp(this.configuration)
            .removeUsersFromCustomerGroup(baseSiteId, groupId, userId, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Sets members for a user group. The list of existing members is overwritten with a new one.  To try out the methods of the Customer Groups controller, you must authorize a user who belongs to the “customermanagergroup”.
     * @summary Sets members for a user group.
     * @param {string} baseSiteId Base site identifier
     * @param {string} groupId Group identifier.
     * @param {MemberList} members List of users to set for customer group.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerGroupsApi
     */
    CustomerGroupsApi.prototype.replaceUsersForCustomerGroup = function (baseSiteId, groupId, members, options) {
        var _this = this;
        return CustomerGroupsApiFp(this.configuration)
            .replaceUsersForCustomerGroup(baseSiteId, groupId, members, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Assigns user(s) to a customer group.  To try out the methods of the Customer Groups controller, you must authorize a user who belongs to the “customermanagergroup”.
     * @summary Assigns user(s) to a customer group.
     * @param {string} baseSiteId Base site identifier
     * @param {string} groupId Group identifier.
     * @param {MemberList} members List of users to assign to customer group.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerGroupsApi
     */
    CustomerGroupsApi.prototype.updateCustomerGroupWithUsers = function (baseSiteId, groupId, members, options) {
        var _this = this;
        return CustomerGroupsApiFp(this.configuration)
            .updateCustomerGroupWithUsers(baseSiteId, groupId, members, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return CustomerGroupsApi;
}(BaseAPI));
/**
 * CustomerProximityControllerApi - axios parameter creator
 * @export
 */
var CustomerProximityControllerApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary customerEntered
         * @param {string} beaconUUID beaconUUID
         * @param {string} major major
         * @param {string} minor minor
         * @param {string} userId userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerEnteredUsingGET: function (beaconUUID, major, minor, userId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'beaconUUID' is not null or undefined
                            assertParamExists('customerEnteredUsingGET', 'beaconUUID', beaconUUID);
                            // verify required parameter 'major' is not null or undefined
                            assertParamExists('customerEnteredUsingGET', 'major', major);
                            // verify required parameter 'minor' is not null or undefined
                            assertParamExists('customerEnteredUsingGET', 'minor', minor);
                            // verify required parameter 'userId' is not null or undefined
                            assertParamExists('customerEnteredUsingGET', 'userId', userId);
                            localVarPath = "/{baseSiteId}/proximity/{userId}/{beaconUUID}/{major}/{minor}"
                                .replace("{" + 'beaconUUID' + "}", encodeURIComponent(String(beaconUUID)))
                                .replace("{" + 'major' + "}", encodeURIComponent(String(major)))
                                .replace("{" + 'minor' + "}", encodeURIComponent(String(minor)))
                                .replace("{" + 'userId' + "}", encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary getAllIBeacons
         * @param {string} [fields] fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllIBeaconsUsingGET: function (fields, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/{baseSiteId}/proximity/beacons";
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        }
    };
};
/**
 * CustomerProximityControllerApi - functional programming interface
 * @export
 */
var CustomerProximityControllerApiFp = function (configuration) {
    var localVarAxiosParamCreator = CustomerProximityControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary customerEntered
         * @param {string} beaconUUID beaconUUID
         * @param {string} major major
         * @param {string} minor minor
         * @param {string} userId userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerEnteredUsingGET: function (beaconUUID, major, minor, userId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customerEnteredUsingGET(beaconUUID, major, minor, userId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary getAllIBeacons
         * @param {string} [fields] fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllIBeaconsUsingGET: function (fields, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllIBeaconsUsingGET(fields, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        }
    };
};
/**
 * CustomerProximityControllerApi - factory interface
 * @export
 */
var CustomerProximityControllerApiFactory = function (configuration, basePath, axios) {
    var localVarFp = CustomerProximityControllerApiFp(configuration);
    return {
        /**
         *
         * @summary customerEntered
         * @param {string} beaconUUID beaconUUID
         * @param {string} major major
         * @param {string} minor minor
         * @param {string} userId userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerEnteredUsingGET: function (beaconUUID, major, minor, userId, options) {
            return localVarFp
                .customerEnteredUsingGET(beaconUUID, major, minor, userId, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary getAllIBeacons
         * @param {string} [fields] fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllIBeaconsUsingGET: function (fields, options) {
            return localVarFp
                .getAllIBeaconsUsingGET(fields, options)
                .then(function (request) { return request(axios, basePath); });
        }
    };
};
/**
 * CustomerProximityControllerApi - object-oriented interface
 * @export
 * @class CustomerProximityControllerApi
 * @extends {BaseAPI}
 */
var CustomerProximityControllerApi = /** @class */ (function (_super) {
    __extends(CustomerProximityControllerApi, _super);
    function CustomerProximityControllerApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary customerEntered
     * @param {string} beaconUUID beaconUUID
     * @param {string} major major
     * @param {string} minor minor
     * @param {string} userId userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerProximityControllerApi
     */
    CustomerProximityControllerApi.prototype.customerEnteredUsingGET = function (beaconUUID, major, minor, userId, options) {
        var _this = this;
        return CustomerProximityControllerApiFp(this.configuration)
            .customerEnteredUsingGET(beaconUUID, major, minor, userId, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary getAllIBeacons
     * @param {string} [fields] fields
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerProximityControllerApi
     */
    CustomerProximityControllerApi.prototype.getAllIBeaconsUsingGET = function (fields, options) {
        var _this = this;
        return CustomerProximityControllerApiFp(this.configuration)
            .getAllIBeaconsUsingGET(fields, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return CustomerProximityControllerApi;
}(BaseAPI));
/**
 * ExportApi - axios parameter creator
 * @export
 */
var ExportApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Used for product export. Depending on the timestamp parameter, it can return all products or only products modified after the given time.
         * @summary Get a list of product exports.
         * @param {string} baseSiteId Base site identifier
         * @param {string} [catalog] The catalog to retrieve products from. The catalog must be provided along with the version.
         * @param {number} [currentPage] The current result page requested.
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {number} [pageSize] The number of results returned per page.
         * @param {string} [timestamp] When this parameter is set, only products modified after the given time will be returned. This parameter should be in ISO-8601 format (for example, 2018-01-09T16:28:45+0000).
         * @param {string} [version] The catalog version. The catalog version must be provided along with the catalog.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExportedProducts: function (baseSiteId, catalog, currentPage, fields, pageSize, timestamp, version, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('getExportedProducts', 'baseSiteId', baseSiteId);
                            localVarPath = "/{baseSiteId}/export/products".replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (catalog !== undefined) {
                                localVarQueryParameter['catalog'] = catalog;
                            }
                            if (currentPage !== undefined) {
                                localVarQueryParameter['currentPage'] = currentPage;
                            }
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['pageSize'] = pageSize;
                            }
                            if (timestamp !== undefined) {
                                localVarQueryParameter['timestamp'] = timestamp;
                            }
                            if (version !== undefined) {
                                localVarQueryParameter['version'] = version;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        }
    };
};
/**
 * ExportApi - functional programming interface
 * @export
 */
var ExportApiFp = function (configuration) {
    var localVarAxiosParamCreator = ExportApiAxiosParamCreator(configuration);
    return {
        /**
         * Used for product export. Depending on the timestamp parameter, it can return all products or only products modified after the given time.
         * @summary Get a list of product exports.
         * @param {string} baseSiteId Base site identifier
         * @param {string} [catalog] The catalog to retrieve products from. The catalog must be provided along with the version.
         * @param {number} [currentPage] The current result page requested.
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {number} [pageSize] The number of results returned per page.
         * @param {string} [timestamp] When this parameter is set, only products modified after the given time will be returned. This parameter should be in ISO-8601 format (for example, 2018-01-09T16:28:45+0000).
         * @param {string} [version] The catalog version. The catalog version must be provided along with the catalog.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExportedProducts: function (baseSiteId, catalog, currentPage, fields, pageSize, timestamp, version, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getExportedProducts(baseSiteId, catalog, currentPage, fields, pageSize, timestamp, version, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        }
    };
};
/**
 * ExportApi - factory interface
 * @export
 */
var ExportApiFactory = function (configuration, basePath, axios) {
    var localVarFp = ExportApiFp(configuration);
    return {
        /**
         * Used for product export. Depending on the timestamp parameter, it can return all products or only products modified after the given time.
         * @summary Get a list of product exports.
         * @param {string} baseSiteId Base site identifier
         * @param {string} [catalog] The catalog to retrieve products from. The catalog must be provided along with the version.
         * @param {number} [currentPage] The current result page requested.
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {number} [pageSize] The number of results returned per page.
         * @param {string} [timestamp] When this parameter is set, only products modified after the given time will be returned. This parameter should be in ISO-8601 format (for example, 2018-01-09T16:28:45+0000).
         * @param {string} [version] The catalog version. The catalog version must be provided along with the catalog.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExportedProducts: function (baseSiteId, catalog, currentPage, fields, pageSize, timestamp, version, options) {
            return localVarFp
                .getExportedProducts(baseSiteId, catalog, currentPage, fields, pageSize, timestamp, version, options)
                .then(function (request) { return request(axios, basePath); });
        }
    };
};
/**
 * ExportApi - object-oriented interface
 * @export
 * @class ExportApi
 * @extends {BaseAPI}
 */
var ExportApi = /** @class */ (function (_super) {
    __extends(ExportApi, _super);
    function ExportApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Used for product export. Depending on the timestamp parameter, it can return all products or only products modified after the given time.
     * @summary Get a list of product exports.
     * @param {string} baseSiteId Base site identifier
     * @param {string} [catalog] The catalog to retrieve products from. The catalog must be provided along with the version.
     * @param {number} [currentPage] The current result page requested.
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
     * @param {number} [pageSize] The number of results returned per page.
     * @param {string} [timestamp] When this parameter is set, only products modified after the given time will be returned. This parameter should be in ISO-8601 format (for example, 2018-01-09T16:28:45+0000).
     * @param {string} [version] The catalog version. The catalog version must be provided along with the catalog.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExportApi
     */
    ExportApi.prototype.getExportedProducts = function (baseSiteId, catalog, currentPage, fields, pageSize, timestamp, version, options) {
        var _this = this;
        return ExportApiFp(this.configuration)
            .getExportedProducts(baseSiteId, catalog, currentPage, fields, pageSize, timestamp, version, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ExportApi;
}(BaseAPI));
/**
 * ExtendedCartsApi - axios parameter creator
 * @export
 */
var ExtendedCartsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Specifies one store location where all items will be picked up.  Note, if any of the items are not available at the specified location, these items are removed from the cart.
         * @summary Handles the consolidating pickup locations.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} storeName The name of the store where items will be picked up
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createConsolidatedPickupLocation: function (baseSiteId, cartId, storeName, userId, fields, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('createConsolidatedPickupLocation', 'baseSiteId', baseSiteId);
                            // verify required parameter 'cartId' is not null or undefined
                            assertParamExists('createConsolidatedPickupLocation', 'cartId', cartId);
                            // verify required parameter 'storeName' is not null or undefined
                            assertParamExists('createConsolidatedPickupLocation', 'storeName', storeName);
                            // verify required parameter 'userId' is not null or undefined
                            assertParamExists('createConsolidatedPickupLocation', 'userId', userId);
                            localVarPath = "/{baseSiteId}/users/{userId}/carts/{cartId}/consolidate"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'cartId' + "}", encodeURIComponent(String(cartId)))
                                .replace("{" + 'userId' + "}", encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            if (storeName !== undefined) {
                                localVarQueryParameter['storeName'] = storeName;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Handles the response from the payment provider and creates payment details.  Note, the “Try it out” button is not enabled for this method (always returns an error) because the Extended Carts Controller handles parameters differently, depending on which payment provider is used. For more information about this controller, please refer to the “acceleratorwebservicesaddon AddOn” documentation on help.hybris.com.
         * @summary Handles response from payment provider and create payment details
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doHandleSopPaymentResponse: function (baseSiteId, cartId, userId, fields, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('doHandleSopPaymentResponse', 'baseSiteId', baseSiteId);
                            // verify required parameter 'cartId' is not null or undefined
                            assertParamExists('doHandleSopPaymentResponse', 'cartId', cartId);
                            // verify required parameter 'userId' is not null or undefined
                            assertParamExists('doHandleSopPaymentResponse', 'userId', userId);
                            localVarPath = "/{baseSiteId}/users/{userId}/carts/{cartId}/payment/sop/response"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'cartId' + "}", encodeURIComponent(String(cartId)))
                                .replace("{" + 'userId' + "}", encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Returns a list of stores that have all the pick-up items in stock.  Note, if there are no stores that have all the pick up items in stock, or all items are already set to the same pick up location, the response returns an empty list.
         * @summary Get consolidated pickup options.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConsolidatedPickupLocations: function (baseSiteId, cartId, userId, fields, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('getConsolidatedPickupLocations', 'baseSiteId', baseSiteId);
                            // verify required parameter 'cartId' is not null or undefined
                            assertParamExists('getConsolidatedPickupLocations', 'cartId', cartId);
                            // verify required parameter 'userId' is not null or undefined
                            assertParamExists('getConsolidatedPickupLocations', 'userId', userId);
                            localVarPath = "/{baseSiteId}/users/{userId}/carts/{cartId}/consolidate"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'cartId' + "}", encodeURIComponent(String(cartId)))
                                .replace("{" + 'userId' + "}", encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Returns the necessary information for creating a subscription that contacts the payment provider directly. This information contains the payment provider URL and a list of parameters that are needed to create the subscription.
         * @summary Get information needed for create subscription
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} responseUrl The URL that the payment provider uses to return payment information. Possible values for responseUrl include the following: “orderPage_cancelResponseURL”, “orderPage_declineResponseURL”, and “orderPage_receiptResponseURL”.
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {boolean} [extendedMerchantCallback] Define which url should be returned
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSopPaymentRequestDetails: function (baseSiteId, cartId, responseUrl, userId, extendedMerchantCallback, fields, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('getSopPaymentRequestDetails', 'baseSiteId', baseSiteId);
                            // verify required parameter 'cartId' is not null or undefined
                            assertParamExists('getSopPaymentRequestDetails', 'cartId', cartId);
                            // verify required parameter 'responseUrl' is not null or undefined
                            assertParamExists('getSopPaymentRequestDetails', 'responseUrl', responseUrl);
                            // verify required parameter 'userId' is not null or undefined
                            assertParamExists('getSopPaymentRequestDetails', 'userId', userId);
                            localVarPath = "/{baseSiteId}/users/{userId}/carts/{cartId}/payment/sop/request"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'cartId' + "}", encodeURIComponent(String(cartId)))
                                .replace("{" + 'userId' + "}", encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (extendedMerchantCallback !== undefined) {
                                localVarQueryParameter['extendedMerchantCallback'] = extendedMerchantCallback;
                            }
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            if (responseUrl !== undefined) {
                                localVarQueryParameter['responseUrl'] = responseUrl;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Returns information related to creating subscription request results. If there is no response from the payment provider, a \"202 Accepted\" status is returned. If the subscription is created successfully, the payment details are returned. Otherwise, an error response is returned.  Note, the “Try it out” button is not enabled for this method (always returns an error) because the Extended Carts Controller handles parameters differently, depending on which payment provider is used. For more information about this controller, please refer to the “acceleratorwebservicesaddon AddOn” documentation on help.hybris.com.
         * @summary Get information about create subscription request results
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSopPaymentResponse: function (baseSiteId, cartId, userId, fields, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('getSopPaymentResponse', 'baseSiteId', baseSiteId);
                            // verify required parameter 'cartId' is not null or undefined
                            assertParamExists('getSopPaymentResponse', 'cartId', cartId);
                            // verify required parameter 'userId' is not null or undefined
                            assertParamExists('getSopPaymentResponse', 'userId', userId);
                            localVarPath = "/{baseSiteId}/users/{userId}/carts/{cartId}/payment/sop/response"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'cartId' + "}", encodeURIComponent(String(cartId)))
                                .replace("{" + 'userId' + "}", encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Deletes the payment provider response related to the specified cart.
         * @summary Deletes payment provider response related to cart.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeSopPaymentResponse: function (baseSiteId, cartId, userId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('removeSopPaymentResponse', 'baseSiteId', baseSiteId);
                            // verify required parameter 'cartId' is not null or undefined
                            assertParamExists('removeSopPaymentResponse', 'cartId', cartId);
                            // verify required parameter 'userId' is not null or undefined
                            assertParamExists('removeSopPaymentResponse', 'userId', userId);
                            localVarPath = "/{baseSiteId}/users/{userId}/carts/{cartId}/payment/sop/response"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'cartId' + "}", encodeURIComponent(String(cartId)))
                                .replace("{" + 'userId' + "}", encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        }
    };
};
/**
 * ExtendedCartsApi - functional programming interface
 * @export
 */
var ExtendedCartsApiFp = function (configuration) {
    var localVarAxiosParamCreator = ExtendedCartsApiAxiosParamCreator(configuration);
    return {
        /**
         * Specifies one store location where all items will be picked up.  Note, if any of the items are not available at the specified location, these items are removed from the cart.
         * @summary Handles the consolidating pickup locations.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} storeName The name of the store where items will be picked up
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createConsolidatedPickupLocation: function (baseSiteId, cartId, storeName, userId, fields, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createConsolidatedPickupLocation(baseSiteId, cartId, storeName, userId, fields, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Handles the response from the payment provider and creates payment details.  Note, the “Try it out” button is not enabled for this method (always returns an error) because the Extended Carts Controller handles parameters differently, depending on which payment provider is used. For more information about this controller, please refer to the “acceleratorwebservicesaddon AddOn” documentation on help.hybris.com.
         * @summary Handles response from payment provider and create payment details
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doHandleSopPaymentResponse: function (baseSiteId, cartId, userId, fields, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.doHandleSopPaymentResponse(baseSiteId, cartId, userId, fields, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns a list of stores that have all the pick-up items in stock.  Note, if there are no stores that have all the pick up items in stock, or all items are already set to the same pick up location, the response returns an empty list.
         * @summary Get consolidated pickup options.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConsolidatedPickupLocations: function (baseSiteId, cartId, userId, fields, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getConsolidatedPickupLocations(baseSiteId, cartId, userId, fields, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns the necessary information for creating a subscription that contacts the payment provider directly. This information contains the payment provider URL and a list of parameters that are needed to create the subscription.
         * @summary Get information needed for create subscription
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} responseUrl The URL that the payment provider uses to return payment information. Possible values for responseUrl include the following: “orderPage_cancelResponseURL”, “orderPage_declineResponseURL”, and “orderPage_receiptResponseURL”.
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {boolean} [extendedMerchantCallback] Define which url should be returned
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSopPaymentRequestDetails: function (baseSiteId, cartId, responseUrl, userId, extendedMerchantCallback, fields, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getSopPaymentRequestDetails(baseSiteId, cartId, responseUrl, userId, extendedMerchantCallback, fields, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns information related to creating subscription request results. If there is no response from the payment provider, a \"202 Accepted\" status is returned. If the subscription is created successfully, the payment details are returned. Otherwise, an error response is returned.  Note, the “Try it out” button is not enabled for this method (always returns an error) because the Extended Carts Controller handles parameters differently, depending on which payment provider is used. For more information about this controller, please refer to the “acceleratorwebservicesaddon AddOn” documentation on help.hybris.com.
         * @summary Get information about create subscription request results
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSopPaymentResponse: function (baseSiteId, cartId, userId, fields, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getSopPaymentResponse(baseSiteId, cartId, userId, fields, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Deletes the payment provider response related to the specified cart.
         * @summary Deletes payment provider response related to cart.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeSopPaymentResponse: function (baseSiteId, cartId, userId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.removeSopPaymentResponse(baseSiteId, cartId, userId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        }
    };
};
/**
 * ExtendedCartsApi - factory interface
 * @export
 */
var ExtendedCartsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = ExtendedCartsApiFp(configuration);
    return {
        /**
         * Specifies one store location where all items will be picked up.  Note, if any of the items are not available at the specified location, these items are removed from the cart.
         * @summary Handles the consolidating pickup locations.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} storeName The name of the store where items will be picked up
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createConsolidatedPickupLocation: function (baseSiteId, cartId, storeName, userId, fields, options) {
            return localVarFp
                .createConsolidatedPickupLocation(baseSiteId, cartId, storeName, userId, fields, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Handles the response from the payment provider and creates payment details.  Note, the “Try it out” button is not enabled for this method (always returns an error) because the Extended Carts Controller handles parameters differently, depending on which payment provider is used. For more information about this controller, please refer to the “acceleratorwebservicesaddon AddOn” documentation on help.hybris.com.
         * @summary Handles response from payment provider and create payment details
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doHandleSopPaymentResponse: function (baseSiteId, cartId, userId, fields, options) {
            return localVarFp
                .doHandleSopPaymentResponse(baseSiteId, cartId, userId, fields, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns a list of stores that have all the pick-up items in stock.  Note, if there are no stores that have all the pick up items in stock, or all items are already set to the same pick up location, the response returns an empty list.
         * @summary Get consolidated pickup options.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConsolidatedPickupLocations: function (baseSiteId, cartId, userId, fields, options) {
            return localVarFp
                .getConsolidatedPickupLocations(baseSiteId, cartId, userId, fields, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns the necessary information for creating a subscription that contacts the payment provider directly. This information contains the payment provider URL and a list of parameters that are needed to create the subscription.
         * @summary Get information needed for create subscription
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} responseUrl The URL that the payment provider uses to return payment information. Possible values for responseUrl include the following: “orderPage_cancelResponseURL”, “orderPage_declineResponseURL”, and “orderPage_receiptResponseURL”.
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {boolean} [extendedMerchantCallback] Define which url should be returned
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSopPaymentRequestDetails: function (baseSiteId, cartId, responseUrl, userId, extendedMerchantCallback, fields, options) {
            return localVarFp
                .getSopPaymentRequestDetails(baseSiteId, cartId, responseUrl, userId, extendedMerchantCallback, fields, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns information related to creating subscription request results. If there is no response from the payment provider, a \"202 Accepted\" status is returned. If the subscription is created successfully, the payment details are returned. Otherwise, an error response is returned.  Note, the “Try it out” button is not enabled for this method (always returns an error) because the Extended Carts Controller handles parameters differently, depending on which payment provider is used. For more information about this controller, please refer to the “acceleratorwebservicesaddon AddOn” documentation on help.hybris.com.
         * @summary Get information about create subscription request results
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSopPaymentResponse: function (baseSiteId, cartId, userId, fields, options) {
            return localVarFp
                .getSopPaymentResponse(baseSiteId, cartId, userId, fields, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Deletes the payment provider response related to the specified cart.
         * @summary Deletes payment provider response related to cart.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeSopPaymentResponse: function (baseSiteId, cartId, userId, options) {
            return localVarFp
                .removeSopPaymentResponse(baseSiteId, cartId, userId, options)
                .then(function (request) { return request(axios, basePath); });
        }
    };
};
/**
 * ExtendedCartsApi - object-oriented interface
 * @export
 * @class ExtendedCartsApi
 * @extends {BaseAPI}
 */
var ExtendedCartsApi = /** @class */ (function (_super) {
    __extends(ExtendedCartsApi, _super);
    function ExtendedCartsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Specifies one store location where all items will be picked up.  Note, if any of the items are not available at the specified location, these items are removed from the cart.
     * @summary Handles the consolidating pickup locations.
     * @param {string} baseSiteId Base site identifier
     * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
     * @param {string} storeName The name of the store where items will be picked up
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExtendedCartsApi
     */
    ExtendedCartsApi.prototype.createConsolidatedPickupLocation = function (baseSiteId, cartId, storeName, userId, fields, options) {
        var _this = this;
        return ExtendedCartsApiFp(this.configuration)
            .createConsolidatedPickupLocation(baseSiteId, cartId, storeName, userId, fields, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Handles the response from the payment provider and creates payment details.  Note, the “Try it out” button is not enabled for this method (always returns an error) because the Extended Carts Controller handles parameters differently, depending on which payment provider is used. For more information about this controller, please refer to the “acceleratorwebservicesaddon AddOn” documentation on help.hybris.com.
     * @summary Handles response from payment provider and create payment details
     * @param {string} baseSiteId Base site identifier
     * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExtendedCartsApi
     */
    ExtendedCartsApi.prototype.doHandleSopPaymentResponse = function (baseSiteId, cartId, userId, fields, options) {
        var _this = this;
        return ExtendedCartsApiFp(this.configuration)
            .doHandleSopPaymentResponse(baseSiteId, cartId, userId, fields, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns a list of stores that have all the pick-up items in stock.  Note, if there are no stores that have all the pick up items in stock, or all items are already set to the same pick up location, the response returns an empty list.
     * @summary Get consolidated pickup options.
     * @param {string} baseSiteId Base site identifier
     * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExtendedCartsApi
     */
    ExtendedCartsApi.prototype.getConsolidatedPickupLocations = function (baseSiteId, cartId, userId, fields, options) {
        var _this = this;
        return ExtendedCartsApiFp(this.configuration)
            .getConsolidatedPickupLocations(baseSiteId, cartId, userId, fields, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns the necessary information for creating a subscription that contacts the payment provider directly. This information contains the payment provider URL and a list of parameters that are needed to create the subscription.
     * @summary Get information needed for create subscription
     * @param {string} baseSiteId Base site identifier
     * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
     * @param {string} responseUrl The URL that the payment provider uses to return payment information. Possible values for responseUrl include the following: “orderPage_cancelResponseURL”, “orderPage_declineResponseURL”, and “orderPage_receiptResponseURL”.
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {boolean} [extendedMerchantCallback] Define which url should be returned
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExtendedCartsApi
     */
    ExtendedCartsApi.prototype.getSopPaymentRequestDetails = function (baseSiteId, cartId, responseUrl, userId, extendedMerchantCallback, fields, options) {
        var _this = this;
        return ExtendedCartsApiFp(this.configuration)
            .getSopPaymentRequestDetails(baseSiteId, cartId, responseUrl, userId, extendedMerchantCallback, fields, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns information related to creating subscription request results. If there is no response from the payment provider, a \"202 Accepted\" status is returned. If the subscription is created successfully, the payment details are returned. Otherwise, an error response is returned.  Note, the “Try it out” button is not enabled for this method (always returns an error) because the Extended Carts Controller handles parameters differently, depending on which payment provider is used. For more information about this controller, please refer to the “acceleratorwebservicesaddon AddOn” documentation on help.hybris.com.
     * @summary Get information about create subscription request results
     * @param {string} baseSiteId Base site identifier
     * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExtendedCartsApi
     */
    ExtendedCartsApi.prototype.getSopPaymentResponse = function (baseSiteId, cartId, userId, fields, options) {
        var _this = this;
        return ExtendedCartsApiFp(this.configuration)
            .getSopPaymentResponse(baseSiteId, cartId, userId, fields, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Deletes the payment provider response related to the specified cart.
     * @summary Deletes payment provider response related to cart.
     * @param {string} baseSiteId Base site identifier
     * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExtendedCartsApi
     */
    ExtendedCartsApi.prototype.removeSopPaymentResponse = function (baseSiteId, cartId, userId, options) {
        var _this = this;
        return ExtendedCartsApiFp(this.configuration)
            .removeSopPaymentResponse(baseSiteId, cartId, userId, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ExtendedCartsApi;
}(BaseAPI));
/**
 * FeedsApi - axios parameter creator
 * @export
 */
var FeedsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Returns the orders that have changed status. Returns only the elements from the current baseSite that have been updated after the provided timestamp.
         * @summary Get a list of orders with status updates.
         * @param {string} baseSiteId Base site identifier
         * @param {string} timestamp Only items newer than the given parameter are retrieved. This parameter should be in ISO-8601 format (for example, 2018-01-09T16:28:45+0000).
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderStatusFeed: function (baseSiteId, timestamp, fields, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('getOrderStatusFeed', 'baseSiteId', baseSiteId);
                            // verify required parameter 'timestamp' is not null or undefined
                            assertParamExists('getOrderStatusFeed', 'timestamp', timestamp);
                            localVarPath = "/{baseSiteId}/feeds/orders/statusfeed".replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            if (timestamp !== undefined) {
                                localVarQueryParameter['timestamp'] = timestamp;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        }
    };
};
/**
 * FeedsApi - functional programming interface
 * @export
 */
var FeedsApiFp = function (configuration) {
    var localVarAxiosParamCreator = FeedsApiAxiosParamCreator(configuration);
    return {
        /**
         * Returns the orders that have changed status. Returns only the elements from the current baseSite that have been updated after the provided timestamp.
         * @summary Get a list of orders with status updates.
         * @param {string} baseSiteId Base site identifier
         * @param {string} timestamp Only items newer than the given parameter are retrieved. This parameter should be in ISO-8601 format (for example, 2018-01-09T16:28:45+0000).
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderStatusFeed: function (baseSiteId, timestamp, fields, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getOrderStatusFeed(baseSiteId, timestamp, fields, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        }
    };
};
/**
 * FeedsApi - factory interface
 * @export
 */
var FeedsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = FeedsApiFp(configuration);
    return {
        /**
         * Returns the orders that have changed status. Returns only the elements from the current baseSite that have been updated after the provided timestamp.
         * @summary Get a list of orders with status updates.
         * @param {string} baseSiteId Base site identifier
         * @param {string} timestamp Only items newer than the given parameter are retrieved. This parameter should be in ISO-8601 format (for example, 2018-01-09T16:28:45+0000).
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderStatusFeed: function (baseSiteId, timestamp, fields, options) {
            return localVarFp
                .getOrderStatusFeed(baseSiteId, timestamp, fields, options)
                .then(function (request) { return request(axios, basePath); });
        }
    };
};
/**
 * FeedsApi - object-oriented interface
 * @export
 * @class FeedsApi
 * @extends {BaseAPI}
 */
var FeedsApi = /** @class */ (function (_super) {
    __extends(FeedsApi, _super);
    function FeedsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Returns the orders that have changed status. Returns only the elements from the current baseSite that have been updated after the provided timestamp.
     * @summary Get a list of orders with status updates.
     * @param {string} baseSiteId Base site identifier
     * @param {string} timestamp Only items newer than the given parameter are retrieved. This parameter should be in ISO-8601 format (for example, 2018-01-09T16:28:45+0000).
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeedsApi
     */
    FeedsApi.prototype.getOrderStatusFeed = function (baseSiteId, timestamp, fields, options) {
        var _this = this;
        return FeedsApiFp(this.configuration)
            .getOrderStatusFeed(baseSiteId, timestamp, fields, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return FeedsApi;
}(BaseAPI));
/**
 * ForgottenPasswordsApi - axios parameter creator
 * @export
 */
var ForgottenPasswordsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Reset password after customer\'s clicked forgotten password link.
         * @summary Reset password after customer\'s clicked forgotten password link.
         * @param {string} baseSiteId Base site identifier
         * @param {ResetPassword} resetPassword Request body parameter that contains details such as token and new password
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doResetPassword: function (baseSiteId, resetPassword, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('doResetPassword', 'baseSiteId', baseSiteId);
                            // verify required parameter 'resetPassword' is not null or undefined
                            assertParamExists('doResetPassword', 'resetPassword', resetPassword);
                            localVarPath = "/{baseSiteId}/resetpassword".replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/xml';
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = serializeDataIfNeeded(resetPassword, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Generates a token to restore a customer\'s forgotten password.
         * @summary Generates a token to restore a customer\'s forgotten password.
         * @param {string} baseSiteId Base site identifier
         * @param {string} userId Customer\&#39;s user id. Customer user id is case insensitive.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doRestorePassword: function (baseSiteId, userId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('doRestorePassword', 'baseSiteId', baseSiteId);
                            // verify required parameter 'userId' is not null or undefined
                            assertParamExists('doRestorePassword', 'userId', userId);
                            localVarPath = "/{baseSiteId}/forgottenpasswordtokens".replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (userId !== undefined) {
                                localVarQueryParameter['userId'] = userId;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        }
    };
};
/**
 * ForgottenPasswordsApi - functional programming interface
 * @export
 */
var ForgottenPasswordsApiFp = function (configuration) {
    var localVarAxiosParamCreator = ForgottenPasswordsApiAxiosParamCreator(configuration);
    return {
        /**
         * Reset password after customer\'s clicked forgotten password link.
         * @summary Reset password after customer\'s clicked forgotten password link.
         * @param {string} baseSiteId Base site identifier
         * @param {ResetPassword} resetPassword Request body parameter that contains details such as token and new password
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doResetPassword: function (baseSiteId, resetPassword, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.doResetPassword(baseSiteId, resetPassword, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Generates a token to restore a customer\'s forgotten password.
         * @summary Generates a token to restore a customer\'s forgotten password.
         * @param {string} baseSiteId Base site identifier
         * @param {string} userId Customer\&#39;s user id. Customer user id is case insensitive.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doRestorePassword: function (baseSiteId, userId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.doRestorePassword(baseSiteId, userId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        }
    };
};
/**
 * ForgottenPasswordsApi - factory interface
 * @export
 */
var ForgottenPasswordsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = ForgottenPasswordsApiFp(configuration);
    return {
        /**
         * Reset password after customer\'s clicked forgotten password link.
         * @summary Reset password after customer\'s clicked forgotten password link.
         * @param {string} baseSiteId Base site identifier
         * @param {ResetPassword} resetPassword Request body parameter that contains details such as token and new password
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doResetPassword: function (baseSiteId, resetPassword, options) {
            return localVarFp
                .doResetPassword(baseSiteId, resetPassword, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Generates a token to restore a customer\'s forgotten password.
         * @summary Generates a token to restore a customer\'s forgotten password.
         * @param {string} baseSiteId Base site identifier
         * @param {string} userId Customer\&#39;s user id. Customer user id is case insensitive.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doRestorePassword: function (baseSiteId, userId, options) {
            return localVarFp
                .doRestorePassword(baseSiteId, userId, options)
                .then(function (request) { return request(axios, basePath); });
        }
    };
};
/**
 * ForgottenPasswordsApi - object-oriented interface
 * @export
 * @class ForgottenPasswordsApi
 * @extends {BaseAPI}
 */
var ForgottenPasswordsApi = /** @class */ (function (_super) {
    __extends(ForgottenPasswordsApi, _super);
    function ForgottenPasswordsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Reset password after customer\'s clicked forgotten password link.
     * @summary Reset password after customer\'s clicked forgotten password link.
     * @param {string} baseSiteId Base site identifier
     * @param {ResetPassword} resetPassword Request body parameter that contains details such as token and new password
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ForgottenPasswordsApi
     */
    ForgottenPasswordsApi.prototype.doResetPassword = function (baseSiteId, resetPassword, options) {
        var _this = this;
        return ForgottenPasswordsApiFp(this.configuration)
            .doResetPassword(baseSiteId, resetPassword, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Generates a token to restore a customer\'s forgotten password.
     * @summary Generates a token to restore a customer\'s forgotten password.
     * @param {string} baseSiteId Base site identifier
     * @param {string} userId Customer\&#39;s user id. Customer user id is case insensitive.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ForgottenPasswordsApi
     */
    ForgottenPasswordsApi.prototype.doRestorePassword = function (baseSiteId, userId, options) {
        var _this = this;
        return ForgottenPasswordsApiFp(this.configuration)
            .doRestorePassword(baseSiteId, userId, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ForgottenPasswordsApi;
}(BaseAPI));
/**
 * MerchantCallbackApi - axios parameter creator
 * @export
 */
var MerchantCallbackApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Verifies the decision of the merchant for a specified cart, and stores information of the PaymentSubscriptionResult for the cart.   Note, the “Try it out” button is not enabled for this method (always returns an error) because the Merchant Callback Controller handles parameters differently, depending on which payment provider is used. For more information about this controller, please refer to the “acceleratorwebservicesaddon AddOn” documentation on help.hybris.com.
         * @summary Verify the decision of the Merchant for a cart
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doHandleCartMerchantCallback: function (baseSiteId, cartId, userId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('doHandleCartMerchantCallback', 'baseSiteId', baseSiteId);
                            // verify required parameter 'cartId' is not null or undefined
                            assertParamExists('doHandleCartMerchantCallback', 'cartId', cartId);
                            // verify required parameter 'userId' is not null or undefined
                            assertParamExists('doHandleCartMerchantCallback', 'userId', userId);
                            localVarPath = "/{baseSiteId}/integration/users/{userId}/carts/{cartId}/payment/sop/response"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'cartId' + "}", encodeURIComponent(String(cartId)))
                                .replace("{" + 'userId' + "}", encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Verifies the decision of the merchant.   Note, the “Try it out” button is not enabled for this method (always returns an error) because the Merchant Callback Controller handles parameters differently, depending on which payment provider is used. For more information about this controller, please refer to the “acceleratorwebservicesaddon AddOn” documentation on help.hybris.com.
         * @summary Verify the decision of the Merchant
         * @param {string} baseSiteId Base site identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doHandleMerchantCallback: function (baseSiteId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('doHandleMerchantCallback', 'baseSiteId', baseSiteId);
                            localVarPath = "/{baseSiteId}/integration/merchant_callback".replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        }
    };
};
/**
 * MerchantCallbackApi - functional programming interface
 * @export
 */
var MerchantCallbackApiFp = function (configuration) {
    var localVarAxiosParamCreator = MerchantCallbackApiAxiosParamCreator(configuration);
    return {
        /**
         * Verifies the decision of the merchant for a specified cart, and stores information of the PaymentSubscriptionResult for the cart.   Note, the “Try it out” button is not enabled for this method (always returns an error) because the Merchant Callback Controller handles parameters differently, depending on which payment provider is used. For more information about this controller, please refer to the “acceleratorwebservicesaddon AddOn” documentation on help.hybris.com.
         * @summary Verify the decision of the Merchant for a cart
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doHandleCartMerchantCallback: function (baseSiteId, cartId, userId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.doHandleCartMerchantCallback(baseSiteId, cartId, userId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Verifies the decision of the merchant.   Note, the “Try it out” button is not enabled for this method (always returns an error) because the Merchant Callback Controller handles parameters differently, depending on which payment provider is used. For more information about this controller, please refer to the “acceleratorwebservicesaddon AddOn” documentation on help.hybris.com.
         * @summary Verify the decision of the Merchant
         * @param {string} baseSiteId Base site identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doHandleMerchantCallback: function (baseSiteId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.doHandleMerchantCallback(baseSiteId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        }
    };
};
/**
 * MerchantCallbackApi - factory interface
 * @export
 */
var MerchantCallbackApiFactory = function (configuration, basePath, axios) {
    var localVarFp = MerchantCallbackApiFp(configuration);
    return {
        /**
         * Verifies the decision of the merchant for a specified cart, and stores information of the PaymentSubscriptionResult for the cart.   Note, the “Try it out” button is not enabled for this method (always returns an error) because the Merchant Callback Controller handles parameters differently, depending on which payment provider is used. For more information about this controller, please refer to the “acceleratorwebservicesaddon AddOn” documentation on help.hybris.com.
         * @summary Verify the decision of the Merchant for a cart
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doHandleCartMerchantCallback: function (baseSiteId, cartId, userId, options) {
            return localVarFp
                .doHandleCartMerchantCallback(baseSiteId, cartId, userId, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Verifies the decision of the merchant.   Note, the “Try it out” button is not enabled for this method (always returns an error) because the Merchant Callback Controller handles parameters differently, depending on which payment provider is used. For more information about this controller, please refer to the “acceleratorwebservicesaddon AddOn” documentation on help.hybris.com.
         * @summary Verify the decision of the Merchant
         * @param {string} baseSiteId Base site identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doHandleMerchantCallback: function (baseSiteId, options) {
            return localVarFp
                .doHandleMerchantCallback(baseSiteId, options)
                .then(function (request) { return request(axios, basePath); });
        }
    };
};
/**
 * MerchantCallbackApi - object-oriented interface
 * @export
 * @class MerchantCallbackApi
 * @extends {BaseAPI}
 */
var MerchantCallbackApi = /** @class */ (function (_super) {
    __extends(MerchantCallbackApi, _super);
    function MerchantCallbackApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Verifies the decision of the merchant for a specified cart, and stores information of the PaymentSubscriptionResult for the cart.   Note, the “Try it out” button is not enabled for this method (always returns an error) because the Merchant Callback Controller handles parameters differently, depending on which payment provider is used. For more information about this controller, please refer to the “acceleratorwebservicesaddon AddOn” documentation on help.hybris.com.
     * @summary Verify the decision of the Merchant for a cart
     * @param {string} baseSiteId Base site identifier
     * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MerchantCallbackApi
     */
    MerchantCallbackApi.prototype.doHandleCartMerchantCallback = function (baseSiteId, cartId, userId, options) {
        var _this = this;
        return MerchantCallbackApiFp(this.configuration)
            .doHandleCartMerchantCallback(baseSiteId, cartId, userId, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Verifies the decision of the merchant.   Note, the “Try it out” button is not enabled for this method (always returns an error) because the Merchant Callback Controller handles parameters differently, depending on which payment provider is used. For more information about this controller, please refer to the “acceleratorwebservicesaddon AddOn” documentation on help.hybris.com.
     * @summary Verify the decision of the Merchant
     * @param {string} baseSiteId Base site identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MerchantCallbackApi
     */
    MerchantCallbackApi.prototype.doHandleMerchantCallback = function (baseSiteId, options) {
        var _this = this;
        return MerchantCallbackApiFp(this.configuration)
            .doHandleMerchantCallback(baseSiteId, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return MerchantCallbackApi;
}(BaseAPI));
/**
 * MiscsApi - axios parameter creator
 * @export
 */
var MiscsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Lists supported payment card types.
         * @summary Get a list of supported payment card types.
         * @param {string} baseSiteId Base site identifier
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardTypes: function (baseSiteId, fields, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('getCardTypes', 'baseSiteId', baseSiteId);
                            localVarPath = "/{baseSiteId}/cardtypes".replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Lists all available currencies (all usable currencies for the current store). If the list of currencies for a base store is empty, a list of all currencies available in the system is returned.
         * @summary Get a list of available currencies.
         * @param {string} baseSiteId Base site identifier
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrencies: function (baseSiteId, fields, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('getCurrencies', 'baseSiteId', baseSiteId);
                            localVarPath = "/{baseSiteId}/currencies".replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Lists all supported delivery countries for the current store. The list is sorted alphabetically.
         * @summary Get a list of shipping countries.
         * @param {string} baseSiteId Base site identifier
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeliveryCountries: function (baseSiteId, fields, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('getDeliveryCountries', 'baseSiteId', baseSiteId);
                            localVarPath = "/{baseSiteId}/deliverycountries".replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Lists all available languages (all languages used for a particular store). If the list of languages for a base store is empty, a list of all languages available in the system will be returned.
         * @summary Get a list of available languages.
         * @param {string} baseSiteId Base site identifier
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLanguages: function (baseSiteId, fields, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('getLanguages', 'baseSiteId', baseSiteId);
                            localVarPath = "/{baseSiteId}/languages".replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Lists all localized titles.
         * @summary Get a list of all localized titles.
         * @param {string} baseSiteId Base site identifier
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTitles: function (baseSiteId, fields, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('getTitles', 'baseSiteId', baseSiteId);
                            localVarPath = "/{baseSiteId}/titles".replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        }
    };
};
/**
 * MiscsApi - functional programming interface
 * @export
 */
var MiscsApiFp = function (configuration) {
    var localVarAxiosParamCreator = MiscsApiAxiosParamCreator(configuration);
    return {
        /**
         * Lists supported payment card types.
         * @summary Get a list of supported payment card types.
         * @param {string} baseSiteId Base site identifier
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardTypes: function (baseSiteId, fields, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getCardTypes(baseSiteId, fields, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Lists all available currencies (all usable currencies for the current store). If the list of currencies for a base store is empty, a list of all currencies available in the system is returned.
         * @summary Get a list of available currencies.
         * @param {string} baseSiteId Base site identifier
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrencies: function (baseSiteId, fields, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getCurrencies(baseSiteId, fields, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Lists all supported delivery countries for the current store. The list is sorted alphabetically.
         * @summary Get a list of shipping countries.
         * @param {string} baseSiteId Base site identifier
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeliveryCountries: function (baseSiteId, fields, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDeliveryCountries(baseSiteId, fields, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Lists all available languages (all languages used for a particular store). If the list of languages for a base store is empty, a list of all languages available in the system will be returned.
         * @summary Get a list of available languages.
         * @param {string} baseSiteId Base site identifier
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLanguages: function (baseSiteId, fields, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getLanguages(baseSiteId, fields, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Lists all localized titles.
         * @summary Get a list of all localized titles.
         * @param {string} baseSiteId Base site identifier
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTitles: function (baseSiteId, fields, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getTitles(baseSiteId, fields, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        }
    };
};
/**
 * MiscsApi - factory interface
 * @export
 */
var MiscsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = MiscsApiFp(configuration);
    return {
        /**
         * Lists supported payment card types.
         * @summary Get a list of supported payment card types.
         * @param {string} baseSiteId Base site identifier
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardTypes: function (baseSiteId, fields, options) {
            return localVarFp
                .getCardTypes(baseSiteId, fields, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Lists all available currencies (all usable currencies for the current store). If the list of currencies for a base store is empty, a list of all currencies available in the system is returned.
         * @summary Get a list of available currencies.
         * @param {string} baseSiteId Base site identifier
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrencies: function (baseSiteId, fields, options) {
            return localVarFp
                .getCurrencies(baseSiteId, fields, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Lists all supported delivery countries for the current store. The list is sorted alphabetically.
         * @summary Get a list of shipping countries.
         * @param {string} baseSiteId Base site identifier
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeliveryCountries: function (baseSiteId, fields, options) {
            return localVarFp
                .getDeliveryCountries(baseSiteId, fields, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Lists all available languages (all languages used for a particular store). If the list of languages for a base store is empty, a list of all languages available in the system will be returned.
         * @summary Get a list of available languages.
         * @param {string} baseSiteId Base site identifier
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLanguages: function (baseSiteId, fields, options) {
            return localVarFp
                .getLanguages(baseSiteId, fields, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Lists all localized titles.
         * @summary Get a list of all localized titles.
         * @param {string} baseSiteId Base site identifier
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTitles: function (baseSiteId, fields, options) {
            return localVarFp
                .getTitles(baseSiteId, fields, options)
                .then(function (request) { return request(axios, basePath); });
        }
    };
};
/**
 * MiscsApi - object-oriented interface
 * @export
 * @class MiscsApi
 * @extends {BaseAPI}
 */
var MiscsApi = /** @class */ (function (_super) {
    __extends(MiscsApi, _super);
    function MiscsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Lists supported payment card types.
     * @summary Get a list of supported payment card types.
     * @param {string} baseSiteId Base site identifier
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MiscsApi
     */
    MiscsApi.prototype.getCardTypes = function (baseSiteId, fields, options) {
        var _this = this;
        return MiscsApiFp(this.configuration)
            .getCardTypes(baseSiteId, fields, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Lists all available currencies (all usable currencies for the current store). If the list of currencies for a base store is empty, a list of all currencies available in the system is returned.
     * @summary Get a list of available currencies.
     * @param {string} baseSiteId Base site identifier
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MiscsApi
     */
    MiscsApi.prototype.getCurrencies = function (baseSiteId, fields, options) {
        var _this = this;
        return MiscsApiFp(this.configuration)
            .getCurrencies(baseSiteId, fields, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Lists all supported delivery countries for the current store. The list is sorted alphabetically.
     * @summary Get a list of shipping countries.
     * @param {string} baseSiteId Base site identifier
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MiscsApi
     */
    MiscsApi.prototype.getDeliveryCountries = function (baseSiteId, fields, options) {
        var _this = this;
        return MiscsApiFp(this.configuration)
            .getDeliveryCountries(baseSiteId, fields, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Lists all available languages (all languages used for a particular store). If the list of languages for a base store is empty, a list of all languages available in the system will be returned.
     * @summary Get a list of available languages.
     * @param {string} baseSiteId Base site identifier
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MiscsApi
     */
    MiscsApi.prototype.getLanguages = function (baseSiteId, fields, options) {
        var _this = this;
        return MiscsApiFp(this.configuration)
            .getLanguages(baseSiteId, fields, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Lists all localized titles.
     * @summary Get a list of all localized titles.
     * @param {string} baseSiteId Base site identifier
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MiscsApi
     */
    MiscsApi.prototype.getTitles = function (baseSiteId, fields, options) {
        var _this = this;
        return MiscsApiFp(this.configuration)
            .getTitles(baseSiteId, fields, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return MiscsApi;
}(BaseAPI));
/**
 * OrderFormsControllerApi - axios parameter creator
 * @export
 */
var OrderFormsControllerApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary createOrderForm
         * @param {OrderForm} orderFormWsDTO orderFormWsDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrderFormUsingPOST: function (orderFormWsDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'orderFormWsDTO' is not null or undefined
                            assertParamExists('createOrderFormUsingPOST', 'orderFormWsDTO', orderFormWsDTO);
                            localVarPath = "/{baseSiteId}/orderforms";
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/xml';
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = serializeDataIfNeeded(orderFormWsDTO, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary deleteOrderForm
         * @param {string} orderFormCode orderFormCode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrderFormUsingDELETE: function (orderFormCode, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'orderFormCode' is not null or undefined
                            assertParamExists('deleteOrderFormUsingDELETE', 'orderFormCode', orderFormCode);
                            localVarPath = "/{baseSiteId}/orderforms/{orderFormCode}".replace("{" + 'orderFormCode' + "}", encodeURIComponent(String(orderFormCode)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary getOrderFormForCode
         * @param {string} orderFormCode orderFormCode
         * @param {string} [fields] fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderFormForCodeUsingGET: function (orderFormCode, fields, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'orderFormCode' is not null or undefined
                            assertParamExists('getOrderFormForCodeUsingGET', 'orderFormCode', orderFormCode);
                            localVarPath = "/{baseSiteId}/orderforms/{orderFormCode}".replace("{" + 'orderFormCode' + "}", encodeURIComponent(String(orderFormCode)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary getOrderFormsForCurrentUser
         * @param {string} [fields] fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderFormsForCurrentUserUsingGET: function (fields, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/{baseSiteId}/orderforms";
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary orderForm
         * @param {string} baseSiteId baseSiteId
         * @param {string} orderFormCode orderFormCode
         * @param {string} [fields] fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderFormUsingPOST: function (baseSiteId, orderFormCode, fields, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('orderFormUsingPOST', 'baseSiteId', baseSiteId);
                            // verify required parameter 'orderFormCode' is not null or undefined
                            assertParamExists('orderFormUsingPOST', 'orderFormCode', orderFormCode);
                            localVarPath = "/{baseSiteId}/orderforms/{orderFormCode}/cart"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'orderFormCode' + "}", encodeURIComponent(String(orderFormCode)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary updateOrderForm
         * @param {string} orderFormCode orderFormCode
         * @param {OrderForm} orderFormWsDTO orderFormWsDTO
         * @param {string} [fields] fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrderFormUsingPUT: function (orderFormCode, orderFormWsDTO, fields, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'orderFormCode' is not null or undefined
                            assertParamExists('updateOrderFormUsingPUT', 'orderFormCode', orderFormCode);
                            // verify required parameter 'orderFormWsDTO' is not null or undefined
                            assertParamExists('updateOrderFormUsingPUT', 'orderFormWsDTO', orderFormWsDTO);
                            localVarPath = "/{baseSiteId}/orderforms/{orderFormCode}".replace("{" + 'orderFormCode' + "}", encodeURIComponent(String(orderFormCode)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = serializeDataIfNeeded(orderFormWsDTO, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        }
    };
};
/**
 * OrderFormsControllerApi - functional programming interface
 * @export
 */
var OrderFormsControllerApiFp = function (configuration) {
    var localVarAxiosParamCreator = OrderFormsControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary createOrderForm
         * @param {OrderForm} orderFormWsDTO orderFormWsDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrderFormUsingPOST: function (orderFormWsDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createOrderFormUsingPOST(orderFormWsDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary deleteOrderForm
         * @param {string} orderFormCode orderFormCode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrderFormUsingDELETE: function (orderFormCode, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteOrderFormUsingDELETE(orderFormCode, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary getOrderFormForCode
         * @param {string} orderFormCode orderFormCode
         * @param {string} [fields] fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderFormForCodeUsingGET: function (orderFormCode, fields, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getOrderFormForCodeUsingGET(orderFormCode, fields, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary getOrderFormsForCurrentUser
         * @param {string} [fields] fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderFormsForCurrentUserUsingGET: function (fields, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getOrderFormsForCurrentUserUsingGET(fields, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary orderForm
         * @param {string} baseSiteId baseSiteId
         * @param {string} orderFormCode orderFormCode
         * @param {string} [fields] fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderFormUsingPOST: function (baseSiteId, orderFormCode, fields, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.orderFormUsingPOST(baseSiteId, orderFormCode, fields, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary updateOrderForm
         * @param {string} orderFormCode orderFormCode
         * @param {OrderForm} orderFormWsDTO orderFormWsDTO
         * @param {string} [fields] fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrderFormUsingPUT: function (orderFormCode, orderFormWsDTO, fields, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateOrderFormUsingPUT(orderFormCode, orderFormWsDTO, fields, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        }
    };
};
/**
 * OrderFormsControllerApi - factory interface
 * @export
 */
var OrderFormsControllerApiFactory = function (configuration, basePath, axios) {
    var localVarFp = OrderFormsControllerApiFp(configuration);
    return {
        /**
         *
         * @summary createOrderForm
         * @param {OrderForm} orderFormWsDTO orderFormWsDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrderFormUsingPOST: function (orderFormWsDTO, options) {
            return localVarFp
                .createOrderFormUsingPOST(orderFormWsDTO, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary deleteOrderForm
         * @param {string} orderFormCode orderFormCode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrderFormUsingDELETE: function (orderFormCode, options) {
            return localVarFp
                .deleteOrderFormUsingDELETE(orderFormCode, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary getOrderFormForCode
         * @param {string} orderFormCode orderFormCode
         * @param {string} [fields] fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderFormForCodeUsingGET: function (orderFormCode, fields, options) {
            return localVarFp
                .getOrderFormForCodeUsingGET(orderFormCode, fields, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary getOrderFormsForCurrentUser
         * @param {string} [fields] fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderFormsForCurrentUserUsingGET: function (fields, options) {
            return localVarFp
                .getOrderFormsForCurrentUserUsingGET(fields, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary orderForm
         * @param {string} baseSiteId baseSiteId
         * @param {string} orderFormCode orderFormCode
         * @param {string} [fields] fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderFormUsingPOST: function (baseSiteId, orderFormCode, fields, options) {
            return localVarFp
                .orderFormUsingPOST(baseSiteId, orderFormCode, fields, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary updateOrderForm
         * @param {string} orderFormCode orderFormCode
         * @param {OrderForm} orderFormWsDTO orderFormWsDTO
         * @param {string} [fields] fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrderFormUsingPUT: function (orderFormCode, orderFormWsDTO, fields, options) {
            return localVarFp
                .updateOrderFormUsingPUT(orderFormCode, orderFormWsDTO, fields, options)
                .then(function (request) { return request(axios, basePath); });
        }
    };
};
/**
 * OrderFormsControllerApi - object-oriented interface
 * @export
 * @class OrderFormsControllerApi
 * @extends {BaseAPI}
 */
var OrderFormsControllerApi = /** @class */ (function (_super) {
    __extends(OrderFormsControllerApi, _super);
    function OrderFormsControllerApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary createOrderForm
     * @param {OrderForm} orderFormWsDTO orderFormWsDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderFormsControllerApi
     */
    OrderFormsControllerApi.prototype.createOrderFormUsingPOST = function (orderFormWsDTO, options) {
        var _this = this;
        return OrderFormsControllerApiFp(this.configuration)
            .createOrderFormUsingPOST(orderFormWsDTO, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary deleteOrderForm
     * @param {string} orderFormCode orderFormCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderFormsControllerApi
     */
    OrderFormsControllerApi.prototype.deleteOrderFormUsingDELETE = function (orderFormCode, options) {
        var _this = this;
        return OrderFormsControllerApiFp(this.configuration)
            .deleteOrderFormUsingDELETE(orderFormCode, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary getOrderFormForCode
     * @param {string} orderFormCode orderFormCode
     * @param {string} [fields] fields
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderFormsControllerApi
     */
    OrderFormsControllerApi.prototype.getOrderFormForCodeUsingGET = function (orderFormCode, fields, options) {
        var _this = this;
        return OrderFormsControllerApiFp(this.configuration)
            .getOrderFormForCodeUsingGET(orderFormCode, fields, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary getOrderFormsForCurrentUser
     * @param {string} [fields] fields
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderFormsControllerApi
     */
    OrderFormsControllerApi.prototype.getOrderFormsForCurrentUserUsingGET = function (fields, options) {
        var _this = this;
        return OrderFormsControllerApiFp(this.configuration)
            .getOrderFormsForCurrentUserUsingGET(fields, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary orderForm
     * @param {string} baseSiteId baseSiteId
     * @param {string} orderFormCode orderFormCode
     * @param {string} [fields] fields
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderFormsControllerApi
     */
    OrderFormsControllerApi.prototype.orderFormUsingPOST = function (baseSiteId, orderFormCode, fields, options) {
        var _this = this;
        return OrderFormsControllerApiFp(this.configuration)
            .orderFormUsingPOST(baseSiteId, orderFormCode, fields, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary updateOrderForm
     * @param {string} orderFormCode orderFormCode
     * @param {OrderForm} orderFormWsDTO orderFormWsDTO
     * @param {string} [fields] fields
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderFormsControllerApi
     */
    OrderFormsControllerApi.prototype.updateOrderFormUsingPUT = function (orderFormCode, orderFormWsDTO, fields, options) {
        var _this = this;
        return OrderFormsControllerApiFp(this.configuration)
            .updateOrderFormUsingPUT(orderFormCode, orderFormWsDTO, fields, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return OrderFormsControllerApi;
}(BaseAPI));
/**
 * OrdersApi - axios parameter creator
 * @export
 */
var OrdersApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * In the response header, the \"x-total-count\" indicates the total number of orders placed by a specified user for a specified base store.
         * @summary Get total number of orders.
         * @param {string} baseSiteId Base site identifier
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {string} [statuses] Filters only certain order statuses. For example, statuses&#x3D;CANCELLED,CHECKED_VALID would only return orders with status CANCELLED or CHECKED_VALID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countUserOrders: function (baseSiteId, userId, statuses, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('countUserOrders', 'baseSiteId', baseSiteId);
                            // verify required parameter 'userId' is not null or undefined
                            assertParamExists('countUserOrders', 'userId', userId);
                            localVarPath = "/{baseSiteId}/users/{userId}/orders"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'userId' + "}", encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'HEAD' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (statuses !== undefined) {
                                localVarQueryParameter['statuses'] = statuses;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Returns details of a specific order based on the order GUID (Globally Unique Identifier) or the order CODE. The response contains detailed order information.
         * @summary Get a order.
         * @param {string} baseSiteId Base site identifier
         * @param {string} code Order GUID (Globally Unique Identifier) or order CODE
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrder: function (baseSiteId, code, fields, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('getOrder', 'baseSiteId', baseSiteId);
                            // verify required parameter 'code' is not null or undefined
                            assertParamExists('getOrder', 'code', code);
                            localVarPath = "/{baseSiteId}/orders/{code}"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'code' + "}", encodeURIComponent(String(code)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Returns order history data for all orders placed by a specified user for a specified base store. The response can display the results across multiple pages, if required.
         * @summary Get order history for user.
         * @param {string} baseSiteId Base site identifier
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {number} [currentPage] The current result page requested.
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {number} [pageSize] The number of results returned per page.
         * @param {string} [sort] Sorting method applied to the return results.
         * @param {string} [statuses] Filters only certain order statuses. For example, statuses&#x3D;CANCELLED,CHECKED_VALID would only return orders with status CANCELLED or CHECKED_VALID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserOrderHistory: function (baseSiteId, userId, currentPage, fields, pageSize, sort, statuses, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('getUserOrderHistory', 'baseSiteId', baseSiteId);
                            // verify required parameter 'userId' is not null or undefined
                            assertParamExists('getUserOrderHistory', 'userId', userId);
                            localVarPath = "/{baseSiteId}/users/{userId}/orders"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'userId' + "}", encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (currentPage !== undefined) {
                                localVarQueryParameter['currentPage'] = currentPage;
                            }
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['pageSize'] = pageSize;
                            }
                            if (sort !== undefined) {
                                localVarQueryParameter['sort'] = sort;
                            }
                            if (statuses !== undefined) {
                                localVarQueryParameter['statuses'] = statuses;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Returns specific order details based on a specific order code. The response contains detailed order information.
         * @summary Get a order.
         * @param {string} baseSiteId Base site identifier
         * @param {string} code Order GUID (Globally Unique Identifier) or order CODE
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserOrders: function (baseSiteId, code, userId, fields, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('getUserOrders', 'baseSiteId', baseSiteId);
                            // verify required parameter 'code' is not null or undefined
                            assertParamExists('getUserOrders', 'code', code);
                            // verify required parameter 'userId' is not null or undefined
                            assertParamExists('getUserOrders', 'userId', userId);
                            localVarPath = "/{baseSiteId}/users/{userId}/orders/{code}"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'code' + "}", encodeURIComponent(String(code)))
                                .replace("{" + 'userId' + "}", encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Authorizes the cart and places the order. The response contains the new order data.
         * @summary Place a order.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart code for logged in user, cart GUID for guest checkout
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        placeOrder: function (baseSiteId, cartId, userId, fields, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('placeOrder', 'baseSiteId', baseSiteId);
                            // verify required parameter 'cartId' is not null or undefined
                            assertParamExists('placeOrder', 'cartId', cartId);
                            // verify required parameter 'userId' is not null or undefined
                            assertParamExists('placeOrder', 'userId', userId);
                            localVarPath = "/{baseSiteId}/users/{userId}/orders"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'userId' + "}", encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (cartId !== undefined) {
                                localVarQueryParameter['cartId'] = cartId;
                            }
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        }
    };
};
/**
 * OrdersApi - functional programming interface
 * @export
 */
var OrdersApiFp = function (configuration) {
    var localVarAxiosParamCreator = OrdersApiAxiosParamCreator(configuration);
    return {
        /**
         * In the response header, the \"x-total-count\" indicates the total number of orders placed by a specified user for a specified base store.
         * @summary Get total number of orders.
         * @param {string} baseSiteId Base site identifier
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {string} [statuses] Filters only certain order statuses. For example, statuses&#x3D;CANCELLED,CHECKED_VALID would only return orders with status CANCELLED or CHECKED_VALID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countUserOrders: function (baseSiteId, userId, statuses, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.countUserOrders(baseSiteId, userId, statuses, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns details of a specific order based on the order GUID (Globally Unique Identifier) or the order CODE. The response contains detailed order information.
         * @summary Get a order.
         * @param {string} baseSiteId Base site identifier
         * @param {string} code Order GUID (Globally Unique Identifier) or order CODE
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrder: function (baseSiteId, code, fields, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getOrder(baseSiteId, code, fields, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns order history data for all orders placed by a specified user for a specified base store. The response can display the results across multiple pages, if required.
         * @summary Get order history for user.
         * @param {string} baseSiteId Base site identifier
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {number} [currentPage] The current result page requested.
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {number} [pageSize] The number of results returned per page.
         * @param {string} [sort] Sorting method applied to the return results.
         * @param {string} [statuses] Filters only certain order statuses. For example, statuses&#x3D;CANCELLED,CHECKED_VALID would only return orders with status CANCELLED or CHECKED_VALID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserOrderHistory: function (baseSiteId, userId, currentPage, fields, pageSize, sort, statuses, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getUserOrderHistory(baseSiteId, userId, currentPage, fields, pageSize, sort, statuses, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns specific order details based on a specific order code. The response contains detailed order information.
         * @summary Get a order.
         * @param {string} baseSiteId Base site identifier
         * @param {string} code Order GUID (Globally Unique Identifier) or order CODE
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserOrders: function (baseSiteId, code, userId, fields, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getUserOrders(baseSiteId, code, userId, fields, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Authorizes the cart and places the order. The response contains the new order data.
         * @summary Place a order.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart code for logged in user, cart GUID for guest checkout
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        placeOrder: function (baseSiteId, cartId, userId, fields, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.placeOrder(baseSiteId, cartId, userId, fields, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        }
    };
};
/**
 * OrdersApi - factory interface
 * @export
 */
var OrdersApiFactory = function (configuration, basePath, axios) {
    var localVarFp = OrdersApiFp(configuration);
    return {
        /**
         * In the response header, the \"x-total-count\" indicates the total number of orders placed by a specified user for a specified base store.
         * @summary Get total number of orders.
         * @param {string} baseSiteId Base site identifier
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {string} [statuses] Filters only certain order statuses. For example, statuses&#x3D;CANCELLED,CHECKED_VALID would only return orders with status CANCELLED or CHECKED_VALID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countUserOrders: function (baseSiteId, userId, statuses, options) {
            return localVarFp
                .countUserOrders(baseSiteId, userId, statuses, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns details of a specific order based on the order GUID (Globally Unique Identifier) or the order CODE. The response contains detailed order information.
         * @summary Get a order.
         * @param {string} baseSiteId Base site identifier
         * @param {string} code Order GUID (Globally Unique Identifier) or order CODE
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrder: function (baseSiteId, code, fields, options) {
            return localVarFp
                .getOrder(baseSiteId, code, fields, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns order history data for all orders placed by a specified user for a specified base store. The response can display the results across multiple pages, if required.
         * @summary Get order history for user.
         * @param {string} baseSiteId Base site identifier
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {number} [currentPage] The current result page requested.
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {number} [pageSize] The number of results returned per page.
         * @param {string} [sort] Sorting method applied to the return results.
         * @param {string} [statuses] Filters only certain order statuses. For example, statuses&#x3D;CANCELLED,CHECKED_VALID would only return orders with status CANCELLED or CHECKED_VALID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserOrderHistory: function (baseSiteId, userId, currentPage, fields, pageSize, sort, statuses, options) {
            return localVarFp
                .getUserOrderHistory(baseSiteId, userId, currentPage, fields, pageSize, sort, statuses, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns specific order details based on a specific order code. The response contains detailed order information.
         * @summary Get a order.
         * @param {string} baseSiteId Base site identifier
         * @param {string} code Order GUID (Globally Unique Identifier) or order CODE
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserOrders: function (baseSiteId, code, userId, fields, options) {
            return localVarFp
                .getUserOrders(baseSiteId, code, userId, fields, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Authorizes the cart and places the order. The response contains the new order data.
         * @summary Place a order.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart code for logged in user, cart GUID for guest checkout
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        placeOrder: function (baseSiteId, cartId, userId, fields, options) {
            return localVarFp
                .placeOrder(baseSiteId, cartId, userId, fields, options)
                .then(function (request) { return request(axios, basePath); });
        }
    };
};
/**
 * OrdersApi - object-oriented interface
 * @export
 * @class OrdersApi
 * @extends {BaseAPI}
 */
var OrdersApi = /** @class */ (function (_super) {
    __extends(OrdersApi, _super);
    function OrdersApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * In the response header, the \"x-total-count\" indicates the total number of orders placed by a specified user for a specified base store.
     * @summary Get total number of orders.
     * @param {string} baseSiteId Base site identifier
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {string} [statuses] Filters only certain order statuses. For example, statuses&#x3D;CANCELLED,CHECKED_VALID would only return orders with status CANCELLED or CHECKED_VALID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    OrdersApi.prototype.countUserOrders = function (baseSiteId, userId, statuses, options) {
        var _this = this;
        return OrdersApiFp(this.configuration)
            .countUserOrders(baseSiteId, userId, statuses, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns details of a specific order based on the order GUID (Globally Unique Identifier) or the order CODE. The response contains detailed order information.
     * @summary Get a order.
     * @param {string} baseSiteId Base site identifier
     * @param {string} code Order GUID (Globally Unique Identifier) or order CODE
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    OrdersApi.prototype.getOrder = function (baseSiteId, code, fields, options) {
        var _this = this;
        return OrdersApiFp(this.configuration)
            .getOrder(baseSiteId, code, fields, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns order history data for all orders placed by a specified user for a specified base store. The response can display the results across multiple pages, if required.
     * @summary Get order history for user.
     * @param {string} baseSiteId Base site identifier
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {number} [currentPage] The current result page requested.
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
     * @param {number} [pageSize] The number of results returned per page.
     * @param {string} [sort] Sorting method applied to the return results.
     * @param {string} [statuses] Filters only certain order statuses. For example, statuses&#x3D;CANCELLED,CHECKED_VALID would only return orders with status CANCELLED or CHECKED_VALID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    OrdersApi.prototype.getUserOrderHistory = function (baseSiteId, userId, currentPage, fields, pageSize, sort, statuses, options) {
        var _this = this;
        return OrdersApiFp(this.configuration)
            .getUserOrderHistory(baseSiteId, userId, currentPage, fields, pageSize, sort, statuses, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns specific order details based on a specific order code. The response contains detailed order information.
     * @summary Get a order.
     * @param {string} baseSiteId Base site identifier
     * @param {string} code Order GUID (Globally Unique Identifier) or order CODE
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    OrdersApi.prototype.getUserOrders = function (baseSiteId, code, userId, fields, options) {
        var _this = this;
        return OrdersApiFp(this.configuration)
            .getUserOrders(baseSiteId, code, userId, fields, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Authorizes the cart and places the order. The response contains the new order data.
     * @summary Place a order.
     * @param {string} baseSiteId Base site identifier
     * @param {string} cartId Cart code for logged in user, cart GUID for guest checkout
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    OrdersApi.prototype.placeOrder = function (baseSiteId, cartId, userId, fields, options) {
        var _this = this;
        return OrdersApiFp(this.configuration)
            .placeOrder(baseSiteId, cartId, userId, fields, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return OrdersApi;
}(BaseAPI));
/**
 * PageApi - axios parameter creator
 * @export
 */
var PageApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Given a page identifier, return the page data with a list of cms content slots, each of which contains a list of cms component data.
         * @summary Get page data with list of cms content slots
         * @param {string} baseSiteId Base site identifier
         * @param {string} [code] If pageType is ProductPage, code should be product code; if pageType is CategoryPage, code should be category code; if pageType is CatalogPage, code should be catalog code
         * @param {'BASIC' | 'DEFAULT' | 'FULL'} [fields] Response configuration (list of fields, which should be returned in response)
         * @param {string} [pageLabelOrId] Page Label or Id; if no page has a label that matches the provided label exactly, try to find pages whose label starts with a section of the provided label. Otherwise, try to find the page by id. Note: URL encoding on the page label should be applied when the label contains special characters
         * @param {'ContentPage' | 'ProductPage' | 'CategoryPage' | 'CatalogPage'} [pageType] page type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPage: function (baseSiteId, code, fields, pageLabelOrId, pageType, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('getPage', 'baseSiteId', baseSiteId);
                            localVarPath = "/{baseSiteId}/cms/pages".replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (code !== undefined) {
                                localVarQueryParameter['code'] = code;
                            }
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            if (pageLabelOrId !== undefined) {
                                localVarQueryParameter['pageLabelOrId'] = pageLabelOrId;
                            }
                            if (pageType !== undefined) {
                                localVarQueryParameter['pageType'] = pageType;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Given a page identifier, return the page data with a list of cms content slots, each of which contains a list of cms component data.
         * @summary Get page data with list of cms content slots
         * @param {string} baseSiteId Base site identifier
         * @param {string} pageId Page Id
         * @param {'BASIC' | 'DEFAULT' | 'FULL'} [fields] Response configuration (list of fields, which should be returned in response)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPageById: function (baseSiteId, pageId, fields, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('getPageById', 'baseSiteId', baseSiteId);
                            // verify required parameter 'pageId' is not null or undefined
                            assertParamExists('getPageById', 'pageId', pageId);
                            localVarPath = "/{baseSiteId}/cms/pages/{pageId}"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'pageId' + "}", encodeURIComponent(String(pageId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        }
    };
};
/**
 * PageApi - functional programming interface
 * @export
 */
var PageApiFp = function (configuration) {
    var localVarAxiosParamCreator = PageApiAxiosParamCreator(configuration);
    return {
        /**
         * Given a page identifier, return the page data with a list of cms content slots, each of which contains a list of cms component data.
         * @summary Get page data with list of cms content slots
         * @param {string} baseSiteId Base site identifier
         * @param {string} [code] If pageType is ProductPage, code should be product code; if pageType is CategoryPage, code should be category code; if pageType is CatalogPage, code should be catalog code
         * @param {'BASIC' | 'DEFAULT' | 'FULL'} [fields] Response configuration (list of fields, which should be returned in response)
         * @param {string} [pageLabelOrId] Page Label or Id; if no page has a label that matches the provided label exactly, try to find pages whose label starts with a section of the provided label. Otherwise, try to find the page by id. Note: URL encoding on the page label should be applied when the label contains special characters
         * @param {'ContentPage' | 'ProductPage' | 'CategoryPage' | 'CatalogPage'} [pageType] page type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPage: function (baseSiteId, code, fields, pageLabelOrId, pageType, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getPage(baseSiteId, code, fields, pageLabelOrId, pageType, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Given a page identifier, return the page data with a list of cms content slots, each of which contains a list of cms component data.
         * @summary Get page data with list of cms content slots
         * @param {string} baseSiteId Base site identifier
         * @param {string} pageId Page Id
         * @param {'BASIC' | 'DEFAULT' | 'FULL'} [fields] Response configuration (list of fields, which should be returned in response)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPageById: function (baseSiteId, pageId, fields, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getPageById(baseSiteId, pageId, fields, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        }
    };
};
/**
 * PageApi - factory interface
 * @export
 */
var PageApiFactory = function (configuration, basePath, axios) {
    var localVarFp = PageApiFp(configuration);
    return {
        /**
         * Given a page identifier, return the page data with a list of cms content slots, each of which contains a list of cms component data.
         * @summary Get page data with list of cms content slots
         * @param {string} baseSiteId Base site identifier
         * @param {string} [code] If pageType is ProductPage, code should be product code; if pageType is CategoryPage, code should be category code; if pageType is CatalogPage, code should be catalog code
         * @param {'BASIC' | 'DEFAULT' | 'FULL'} [fields] Response configuration (list of fields, which should be returned in response)
         * @param {string} [pageLabelOrId] Page Label or Id; if no page has a label that matches the provided label exactly, try to find pages whose label starts with a section of the provided label. Otherwise, try to find the page by id. Note: URL encoding on the page label should be applied when the label contains special characters
         * @param {'ContentPage' | 'ProductPage' | 'CategoryPage' | 'CatalogPage'} [pageType] page type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPage: function (baseSiteId, code, fields, pageLabelOrId, pageType, options) {
            return localVarFp
                .getPage(baseSiteId, code, fields, pageLabelOrId, pageType, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Given a page identifier, return the page data with a list of cms content slots, each of which contains a list of cms component data.
         * @summary Get page data with list of cms content slots
         * @param {string} baseSiteId Base site identifier
         * @param {string} pageId Page Id
         * @param {'BASIC' | 'DEFAULT' | 'FULL'} [fields] Response configuration (list of fields, which should be returned in response)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPageById: function (baseSiteId, pageId, fields, options) {
            return localVarFp
                .getPageById(baseSiteId, pageId, fields, options)
                .then(function (request) { return request(axios, basePath); });
        }
    };
};
/**
 * PageApi - object-oriented interface
 * @export
 * @class PageApi
 * @extends {BaseAPI}
 */
var PageApi = /** @class */ (function (_super) {
    __extends(PageApi, _super);
    function PageApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Given a page identifier, return the page data with a list of cms content slots, each of which contains a list of cms component data.
     * @summary Get page data with list of cms content slots
     * @param {string} baseSiteId Base site identifier
     * @param {string} [code] If pageType is ProductPage, code should be product code; if pageType is CategoryPage, code should be category code; if pageType is CatalogPage, code should be catalog code
     * @param {'BASIC' | 'DEFAULT' | 'FULL'} [fields] Response configuration (list of fields, which should be returned in response)
     * @param {string} [pageLabelOrId] Page Label or Id; if no page has a label that matches the provided label exactly, try to find pages whose label starts with a section of the provided label. Otherwise, try to find the page by id. Note: URL encoding on the page label should be applied when the label contains special characters
     * @param {'ContentPage' | 'ProductPage' | 'CategoryPage' | 'CatalogPage'} [pageType] page type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PageApi
     */
    PageApi.prototype.getPage = function (baseSiteId, code, fields, pageLabelOrId, pageType, options) {
        var _this = this;
        return PageApiFp(this.configuration)
            .getPage(baseSiteId, code, fields, pageLabelOrId, pageType, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Given a page identifier, return the page data with a list of cms content slots, each of which contains a list of cms component data.
     * @summary Get page data with list of cms content slots
     * @param {string} baseSiteId Base site identifier
     * @param {string} pageId Page Id
     * @param {'BASIC' | 'DEFAULT' | 'FULL'} [fields] Response configuration (list of fields, which should be returned in response)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PageApi
     */
    PageApi.prototype.getPageById = function (baseSiteId, pageId, fields, options) {
        var _this = this;
        return PageApiFp(this.configuration)
            .getPageById(baseSiteId, pageId, fields, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return PageApi;
}(BaseAPI));
/**
 * PaymentDetailsApi - axios parameter creator
 * @export
 */
var PaymentDetailsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Returns a customer\'s credit card payment details for the specified paymentDetailsId.
         * @summary Get customer\'s credit card payment details.
         * @param {string} baseSiteId Base site identifier
         * @param {string} paymentDetailsId Payment details identifier.
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentDetails: function (baseSiteId, paymentDetailsId, userId, fields, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('getPaymentDetails', 'baseSiteId', baseSiteId);
                            // verify required parameter 'paymentDetailsId' is not null or undefined
                            assertParamExists('getPaymentDetails', 'paymentDetailsId', paymentDetailsId);
                            // verify required parameter 'userId' is not null or undefined
                            assertParamExists('getPaymentDetails', 'userId', userId);
                            localVarPath = "/{baseSiteId}/users/{userId}/paymentdetails/{paymentDetailsId}"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'paymentDetailsId' + "}", encodeURIComponent(String(paymentDetailsId)))
                                .replace("{" + 'userId' + "}", encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Return customer\'s credit card payment details list.
         * @summary Get customer\'s credit card payment details list.
         * @param {string} baseSiteId Base site identifier
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {boolean} [saved] Type of payment details.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentDetailsList: function (baseSiteId, userId, fields, saved, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('getPaymentDetailsList', 'baseSiteId', baseSiteId);
                            // verify required parameter 'userId' is not null or undefined
                            assertParamExists('getPaymentDetailsList', 'userId', userId);
                            localVarPath = "/{baseSiteId}/users/{userId}/paymentdetails"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'userId' + "}", encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            if (saved !== undefined) {
                                localVarQueryParameter['saved'] = saved;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Deletes a customer\'s credit card payment details based on a specified paymentDetailsId.
         * @summary Deletes customer\'s credit card payment details.
         * @param {string} baseSiteId Base site identifier
         * @param {string} paymentDetailsId Payment details identifier.
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removePaymentDetails: function (baseSiteId, paymentDetailsId, userId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('removePaymentDetails', 'baseSiteId', baseSiteId);
                            // verify required parameter 'paymentDetailsId' is not null or undefined
                            assertParamExists('removePaymentDetails', 'paymentDetailsId', paymentDetailsId);
                            // verify required parameter 'userId' is not null or undefined
                            assertParamExists('removePaymentDetails', 'userId', userId);
                            localVarPath = "/{baseSiteId}/users/{userId}/paymentdetails/{paymentDetailsId}"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'paymentDetailsId' + "}", encodeURIComponent(String(paymentDetailsId)))
                                .replace("{" + 'userId' + "}", encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Updates existing customer\'s credit card payment info based on the payment info ID. Attributes not given in request will be defined again (set to null or default).
         * @summary Updates existing customer\'s credit card payment info.
         * @param {string} baseSiteId Base site identifier
         * @param {string} paymentDetailsId Payment details identifier.
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {PaymentDetails} paymentDetails Payment details object.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replacePaymentDetails: function (baseSiteId, paymentDetailsId, userId, paymentDetails, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('replacePaymentDetails', 'baseSiteId', baseSiteId);
                            // verify required parameter 'paymentDetailsId' is not null or undefined
                            assertParamExists('replacePaymentDetails', 'paymentDetailsId', paymentDetailsId);
                            // verify required parameter 'userId' is not null or undefined
                            assertParamExists('replacePaymentDetails', 'userId', userId);
                            // verify required parameter 'paymentDetails' is not null or undefined
                            assertParamExists('replacePaymentDetails', 'paymentDetails', paymentDetails);
                            localVarPath = "/{baseSiteId}/users/{userId}/paymentdetails/{paymentDetailsId}"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'paymentDetailsId' + "}", encodeURIComponent(String(paymentDetailsId)))
                                .replace("{" + 'userId' + "}", encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/xml';
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = serializeDataIfNeeded(paymentDetails, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Updates an existing customer\'s credit card payment details based on the specified paymentDetailsId. Only those attributes provided in the request will be updated.
         * @summary Updates existing customer\'s credit card payment details.
         * @param {string} baseSiteId Base site identifier
         * @param {string} paymentDetailsId Payment details identifier.
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {PaymentDetails} paymentDetails Payment details object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePaymentDetails: function (baseSiteId, paymentDetailsId, userId, paymentDetails, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('updatePaymentDetails', 'baseSiteId', baseSiteId);
                            // verify required parameter 'paymentDetailsId' is not null or undefined
                            assertParamExists('updatePaymentDetails', 'paymentDetailsId', paymentDetailsId);
                            // verify required parameter 'userId' is not null or undefined
                            assertParamExists('updatePaymentDetails', 'userId', userId);
                            // verify required parameter 'paymentDetails' is not null or undefined
                            assertParamExists('updatePaymentDetails', 'paymentDetails', paymentDetails);
                            localVarPath = "/{baseSiteId}/users/{userId}/paymentdetails/{paymentDetailsId}"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'paymentDetailsId' + "}", encodeURIComponent(String(paymentDetailsId)))
                                .replace("{" + 'userId' + "}", encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/xml';
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = serializeDataIfNeeded(paymentDetails, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        }
    };
};
/**
 * PaymentDetailsApi - functional programming interface
 * @export
 */
var PaymentDetailsApiFp = function (configuration) {
    var localVarAxiosParamCreator = PaymentDetailsApiAxiosParamCreator(configuration);
    return {
        /**
         * Returns a customer\'s credit card payment details for the specified paymentDetailsId.
         * @summary Get customer\'s credit card payment details.
         * @param {string} baseSiteId Base site identifier
         * @param {string} paymentDetailsId Payment details identifier.
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentDetails: function (baseSiteId, paymentDetailsId, userId, fields, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getPaymentDetails(baseSiteId, paymentDetailsId, userId, fields, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Return customer\'s credit card payment details list.
         * @summary Get customer\'s credit card payment details list.
         * @param {string} baseSiteId Base site identifier
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {boolean} [saved] Type of payment details.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentDetailsList: function (baseSiteId, userId, fields, saved, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getPaymentDetailsList(baseSiteId, userId, fields, saved, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Deletes a customer\'s credit card payment details based on a specified paymentDetailsId.
         * @summary Deletes customer\'s credit card payment details.
         * @param {string} baseSiteId Base site identifier
         * @param {string} paymentDetailsId Payment details identifier.
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removePaymentDetails: function (baseSiteId, paymentDetailsId, userId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.removePaymentDetails(baseSiteId, paymentDetailsId, userId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Updates existing customer\'s credit card payment info based on the payment info ID. Attributes not given in request will be defined again (set to null or default).
         * @summary Updates existing customer\'s credit card payment info.
         * @param {string} baseSiteId Base site identifier
         * @param {string} paymentDetailsId Payment details identifier.
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {PaymentDetails} paymentDetails Payment details object.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replacePaymentDetails: function (baseSiteId, paymentDetailsId, userId, paymentDetails, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.replacePaymentDetails(baseSiteId, paymentDetailsId, userId, paymentDetails, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Updates an existing customer\'s credit card payment details based on the specified paymentDetailsId. Only those attributes provided in the request will be updated.
         * @summary Updates existing customer\'s credit card payment details.
         * @param {string} baseSiteId Base site identifier
         * @param {string} paymentDetailsId Payment details identifier.
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {PaymentDetails} paymentDetails Payment details object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePaymentDetails: function (baseSiteId, paymentDetailsId, userId, paymentDetails, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updatePaymentDetails(baseSiteId, paymentDetailsId, userId, paymentDetails, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        }
    };
};
/**
 * PaymentDetailsApi - factory interface
 * @export
 */
var PaymentDetailsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = PaymentDetailsApiFp(configuration);
    return {
        /**
         * Returns a customer\'s credit card payment details for the specified paymentDetailsId.
         * @summary Get customer\'s credit card payment details.
         * @param {string} baseSiteId Base site identifier
         * @param {string} paymentDetailsId Payment details identifier.
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentDetails: function (baseSiteId, paymentDetailsId, userId, fields, options) {
            return localVarFp
                .getPaymentDetails(baseSiteId, paymentDetailsId, userId, fields, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Return customer\'s credit card payment details list.
         * @summary Get customer\'s credit card payment details list.
         * @param {string} baseSiteId Base site identifier
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {boolean} [saved] Type of payment details.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentDetailsList: function (baseSiteId, userId, fields, saved, options) {
            return localVarFp
                .getPaymentDetailsList(baseSiteId, userId, fields, saved, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Deletes a customer\'s credit card payment details based on a specified paymentDetailsId.
         * @summary Deletes customer\'s credit card payment details.
         * @param {string} baseSiteId Base site identifier
         * @param {string} paymentDetailsId Payment details identifier.
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removePaymentDetails: function (baseSiteId, paymentDetailsId, userId, options) {
            return localVarFp
                .removePaymentDetails(baseSiteId, paymentDetailsId, userId, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Updates existing customer\'s credit card payment info based on the payment info ID. Attributes not given in request will be defined again (set to null or default).
         * @summary Updates existing customer\'s credit card payment info.
         * @param {string} baseSiteId Base site identifier
         * @param {string} paymentDetailsId Payment details identifier.
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {PaymentDetails} paymentDetails Payment details object.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replacePaymentDetails: function (baseSiteId, paymentDetailsId, userId, paymentDetails, options) {
            return localVarFp
                .replacePaymentDetails(baseSiteId, paymentDetailsId, userId, paymentDetails, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Updates an existing customer\'s credit card payment details based on the specified paymentDetailsId. Only those attributes provided in the request will be updated.
         * @summary Updates existing customer\'s credit card payment details.
         * @param {string} baseSiteId Base site identifier
         * @param {string} paymentDetailsId Payment details identifier.
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {PaymentDetails} paymentDetails Payment details object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePaymentDetails: function (baseSiteId, paymentDetailsId, userId, paymentDetails, options) {
            return localVarFp
                .updatePaymentDetails(baseSiteId, paymentDetailsId, userId, paymentDetails, options)
                .then(function (request) { return request(axios, basePath); });
        }
    };
};
/**
 * PaymentDetailsApi - object-oriented interface
 * @export
 * @class PaymentDetailsApi
 * @extends {BaseAPI}
 */
var PaymentDetailsApi = /** @class */ (function (_super) {
    __extends(PaymentDetailsApi, _super);
    function PaymentDetailsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Returns a customer\'s credit card payment details for the specified paymentDetailsId.
     * @summary Get customer\'s credit card payment details.
     * @param {string} baseSiteId Base site identifier
     * @param {string} paymentDetailsId Payment details identifier.
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentDetailsApi
     */
    PaymentDetailsApi.prototype.getPaymentDetails = function (baseSiteId, paymentDetailsId, userId, fields, options) {
        var _this = this;
        return PaymentDetailsApiFp(this.configuration)
            .getPaymentDetails(baseSiteId, paymentDetailsId, userId, fields, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Return customer\'s credit card payment details list.
     * @summary Get customer\'s credit card payment details list.
     * @param {string} baseSiteId Base site identifier
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
     * @param {boolean} [saved] Type of payment details.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentDetailsApi
     */
    PaymentDetailsApi.prototype.getPaymentDetailsList = function (baseSiteId, userId, fields, saved, options) {
        var _this = this;
        return PaymentDetailsApiFp(this.configuration)
            .getPaymentDetailsList(baseSiteId, userId, fields, saved, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Deletes a customer\'s credit card payment details based on a specified paymentDetailsId.
     * @summary Deletes customer\'s credit card payment details.
     * @param {string} baseSiteId Base site identifier
     * @param {string} paymentDetailsId Payment details identifier.
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentDetailsApi
     */
    PaymentDetailsApi.prototype.removePaymentDetails = function (baseSiteId, paymentDetailsId, userId, options) {
        var _this = this;
        return PaymentDetailsApiFp(this.configuration)
            .removePaymentDetails(baseSiteId, paymentDetailsId, userId, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Updates existing customer\'s credit card payment info based on the payment info ID. Attributes not given in request will be defined again (set to null or default).
     * @summary Updates existing customer\'s credit card payment info.
     * @param {string} baseSiteId Base site identifier
     * @param {string} paymentDetailsId Payment details identifier.
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {PaymentDetails} paymentDetails Payment details object.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentDetailsApi
     */
    PaymentDetailsApi.prototype.replacePaymentDetails = function (baseSiteId, paymentDetailsId, userId, paymentDetails, options) {
        var _this = this;
        return PaymentDetailsApiFp(this.configuration)
            .replacePaymentDetails(baseSiteId, paymentDetailsId, userId, paymentDetails, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Updates an existing customer\'s credit card payment details based on the specified paymentDetailsId. Only those attributes provided in the request will be updated.
     * @summary Updates existing customer\'s credit card payment details.
     * @param {string} baseSiteId Base site identifier
     * @param {string} paymentDetailsId Payment details identifier.
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {PaymentDetails} paymentDetails Payment details object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentDetailsApi
     */
    PaymentDetailsApi.prototype.updatePaymentDetails = function (baseSiteId, paymentDetailsId, userId, paymentDetails, options) {
        var _this = this;
        return PaymentDetailsApiFp(this.configuration)
            .updatePaymentDetails(baseSiteId, paymentDetailsId, userId, paymentDetails, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return PaymentDetailsApi;
}(BaseAPI));
/**
 * PaymentModesApi - axios parameter creator
 * @export
 */
var PaymentModesApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Gets all payment modes defined for the base store.
         * @summary Gets all available payment modes.
         * @param {string} baseSiteId Base site identifier
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentModes: function (baseSiteId, fields, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('getPaymentModes', 'baseSiteId', baseSiteId);
                            localVarPath = "/{baseSiteId}/paymentmodes".replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        }
    };
};
/**
 * PaymentModesApi - functional programming interface
 * @export
 */
var PaymentModesApiFp = function (configuration) {
    var localVarAxiosParamCreator = PaymentModesApiAxiosParamCreator(configuration);
    return {
        /**
         * Gets all payment modes defined for the base store.
         * @summary Gets all available payment modes.
         * @param {string} baseSiteId Base site identifier
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentModes: function (baseSiteId, fields, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getPaymentModes(baseSiteId, fields, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        }
    };
};
/**
 * PaymentModesApi - factory interface
 * @export
 */
var PaymentModesApiFactory = function (configuration, basePath, axios) {
    var localVarFp = PaymentModesApiFp(configuration);
    return {
        /**
         * Gets all payment modes defined for the base store.
         * @summary Gets all available payment modes.
         * @param {string} baseSiteId Base site identifier
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentModes: function (baseSiteId, fields, options) {
            return localVarFp
                .getPaymentModes(baseSiteId, fields, options)
                .then(function (request) { return request(axios, basePath); });
        }
    };
};
/**
 * PaymentModesApi - object-oriented interface
 * @export
 * @class PaymentModesApi
 * @extends {BaseAPI}
 */
var PaymentModesApi = /** @class */ (function (_super) {
    __extends(PaymentModesApi, _super);
    function PaymentModesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Gets all payment modes defined for the base store.
     * @summary Gets all available payment modes.
     * @param {string} baseSiteId Base site identifier
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentModesApi
     */
    PaymentModesApi.prototype.getPaymentModes = function (baseSiteId, fields, options) {
        var _this = this;
        return PaymentModesApiFp(this.configuration)
            .getPaymentModes(baseSiteId, fields, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return PaymentModesApi;
}(BaseAPI));
/**
 * ProductListControllerApi - axios parameter creator
 * @export
 */
var ProductListControllerApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary addEntriesToCart
         * @param {string} baseSiteId baseSiteId
         * @param {AddToCartEntries} addToCartData addToCartData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addEntriesToCartUsingPOST: function (baseSiteId, addToCartData, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('addEntriesToCartUsingPOST', 'baseSiteId', baseSiteId);
                            // verify required parameter 'addToCartData' is not null or undefined
                            assertParamExists('addEntriesToCartUsingPOST', 'addToCartData', addToCartData);
                            localVarPath = "/{baseSiteId}/productlists/entries/addtocart".replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/xml';
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = serializeDataIfNeeded(addToCartData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary addProductList
         * @param {string} productlistname productlistname
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addProductListUsingPOST: function (productlistname, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'productlistname' is not null or undefined
                            assertParamExists('addProductListUsingPOST', 'productlistname', productlistname);
                            localVarPath = "/{baseSiteId}/productlists/{productlistname}".replace("{" + 'productlistname' + "}", encodeURIComponent(String(productlistname)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary addProductToList
         * @param {string} productcode productcode
         * @param {string} productlistname productlistname
         * @param {number} [quantity] quantity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addProductToListUsingPOST: function (productcode, productlistname, quantity, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'productcode' is not null or undefined
                            assertParamExists('addProductToListUsingPOST', 'productcode', productcode);
                            // verify required parameter 'productlistname' is not null or undefined
                            assertParamExists('addProductToListUsingPOST', 'productlistname', productlistname);
                            localVarPath = "/{baseSiteId}/productlists/{productlistname}/products/{productcode}"
                                .replace("{" + 'productcode' + "}", encodeURIComponent(String(productcode)))
                                .replace("{" + 'productlistname' + "}", encodeURIComponent(String(productlistname)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (quantity !== undefined) {
                                localVarQueryParameter['quantity'] = quantity;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary editProductList
         * @param {string} newname newname
         * @param {string} productlistname productlistname
         * @param {boolean} [isfavourite] isfavourite
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editProductListUsingPUT: function (newname, productlistname, isfavourite, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'newname' is not null or undefined
                            assertParamExists('editProductListUsingPUT', 'newname', newname);
                            // verify required parameter 'productlistname' is not null or undefined
                            assertParamExists('editProductListUsingPUT', 'productlistname', productlistname);
                            localVarPath = "/{baseSiteId}/productlists/{productlistname}".replace("{" + 'productlistname' + "}", encodeURIComponent(String(productlistname)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (isfavourite !== undefined) {
                                localVarQueryParameter['isfavourite'] = isfavourite;
                            }
                            if (newname !== undefined) {
                                localVarQueryParameter['newname'] = newname;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary getFavouriteProductList
         * @param {string} [fields] fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFavouriteProductListUsingGET: function (fields, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/{baseSiteId}/productlists/favourite";
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary getProductListBin
         * @param {string} [fields] fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductListBinUsingGET: function (fields, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/{baseSiteId}/productlists";
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary getProductList
         * @param {string} productlistname productlistname
         * @param {string} [fields] fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductListUsingGET: function (productlistname, fields, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'productlistname' is not null or undefined
                            assertParamExists('getProductListUsingGET', 'productlistname', productlistname);
                            localVarPath = "/{baseSiteId}/productlists/{productlistname}".replace("{" + 'productlistname' + "}", encodeURIComponent(String(productlistname)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary getSharedWithMeProductLists
         * @param {string} [fields] fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSharedWithMeProductListsUsingGET: function (fields, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/{baseSiteId}/productlists/shared";
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary removeEntry
         * @param {string} entrycode entrycode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeEntryUsingDELETE: function (entrycode, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'entrycode' is not null or undefined
                            assertParamExists('removeEntryUsingDELETE', 'entrycode', entrycode);
                            localVarPath = "/{baseSiteId}/productlists/entries/{entrycode}".replace("{" + 'entrycode' + "}", encodeURIComponent(String(entrycode)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary removeProductList
         * @param {string} productlistname productlistname
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeProductListUsingDELETE: function (productlistname, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'productlistname' is not null or undefined
                            assertParamExists('removeProductListUsingDELETE', 'productlistname', productlistname);
                            localVarPath = "/{baseSiteId}/productlists/{productlistname}".replace("{" + 'productlistname' + "}", encodeURIComponent(String(productlistname)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary removeSharedProductListForUser
         * @param {string} productlistname productlistname
         * @param {string} userid userid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeSharedProductListForUserUsingDELETE: function (productlistname, userid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'productlistname' is not null or undefined
                            assertParamExists('removeSharedProductListForUserUsingDELETE', 'productlistname', productlistname);
                            // verify required parameter 'userid' is not null or undefined
                            assertParamExists('removeSharedProductListForUserUsingDELETE', 'userid', userid);
                            localVarPath = "/{baseSiteId}/productlists/shared/{productlistname}".replace("{" + 'productlistname' + "}", encodeURIComponent(String(productlistname)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (userid !== undefined) {
                                localVarQueryParameter['userid'] = userid;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary setFavouriteProductList
         * @param {string} name name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setFavouriteProductListUsingPOST: function (name, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'name' is not null or undefined
                            assertParamExists('setFavouriteProductListUsingPOST', 'name', name);
                            localVarPath = "/{baseSiteId}/productlists/favourite";
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (name !== undefined) {
                                localVarQueryParameter['name'] = name;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary shareProductListWithUser
         * @param {string} productlistname productlistname
         * @param {string} userid userid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shareProductListWithUserUsingPOST: function (productlistname, userid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'productlistname' is not null or undefined
                            assertParamExists('shareProductListWithUserUsingPOST', 'productlistname', productlistname);
                            // verify required parameter 'userid' is not null or undefined
                            assertParamExists('shareProductListWithUserUsingPOST', 'userid', userid);
                            localVarPath = "/{baseSiteId}/productlists/shared/{productlistname}".replace("{" + 'productlistname' + "}", encodeURIComponent(String(productlistname)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (userid !== undefined) {
                                localVarQueryParameter['userid'] = userid;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary updateEntry
         * @param {string} entrycode entrycode
         * @param {number} [quantity] quantity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntryUsingPOST: function (entrycode, quantity, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'entrycode' is not null or undefined
                            assertParamExists('updateEntryUsingPOST', 'entrycode', entrycode);
                            localVarPath = "/{baseSiteId}/productlists/entries/{entrycode}".replace("{" + 'entrycode' + "}", encodeURIComponent(String(entrycode)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (quantity !== undefined) {
                                localVarQueryParameter['quantity'] = quantity;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        }
    };
};
/**
 * ProductListControllerApi - functional programming interface
 * @export
 */
var ProductListControllerApiFp = function (configuration) {
    var localVarAxiosParamCreator = ProductListControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary addEntriesToCart
         * @param {string} baseSiteId baseSiteId
         * @param {AddToCartEntries} addToCartData addToCartData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addEntriesToCartUsingPOST: function (baseSiteId, addToCartData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.addEntriesToCartUsingPOST(baseSiteId, addToCartData, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary addProductList
         * @param {string} productlistname productlistname
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addProductListUsingPOST: function (productlistname, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.addProductListUsingPOST(productlistname, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary addProductToList
         * @param {string} productcode productcode
         * @param {string} productlistname productlistname
         * @param {number} [quantity] quantity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addProductToListUsingPOST: function (productcode, productlistname, quantity, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.addProductToListUsingPOST(productcode, productlistname, quantity, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary editProductList
         * @param {string} newname newname
         * @param {string} productlistname productlistname
         * @param {boolean} [isfavourite] isfavourite
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editProductListUsingPUT: function (newname, productlistname, isfavourite, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.editProductListUsingPUT(newname, productlistname, isfavourite, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary getFavouriteProductList
         * @param {string} [fields] fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFavouriteProductListUsingGET: function (fields, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getFavouriteProductListUsingGET(fields, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary getProductListBin
         * @param {string} [fields] fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductListBinUsingGET: function (fields, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getProductListBinUsingGET(fields, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary getProductList
         * @param {string} productlistname productlistname
         * @param {string} [fields] fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductListUsingGET: function (productlistname, fields, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getProductListUsingGET(productlistname, fields, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary getSharedWithMeProductLists
         * @param {string} [fields] fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSharedWithMeProductListsUsingGET: function (fields, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getSharedWithMeProductListsUsingGET(fields, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary removeEntry
         * @param {string} entrycode entrycode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeEntryUsingDELETE: function (entrycode, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.removeEntryUsingDELETE(entrycode, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary removeProductList
         * @param {string} productlistname productlistname
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeProductListUsingDELETE: function (productlistname, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.removeProductListUsingDELETE(productlistname, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary removeSharedProductListForUser
         * @param {string} productlistname productlistname
         * @param {string} userid userid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeSharedProductListForUserUsingDELETE: function (productlistname, userid, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.removeSharedProductListForUserUsingDELETE(productlistname, userid, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary setFavouriteProductList
         * @param {string} name name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setFavouriteProductListUsingPOST: function (name, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.setFavouriteProductListUsingPOST(name, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary shareProductListWithUser
         * @param {string} productlistname productlistname
         * @param {string} userid userid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shareProductListWithUserUsingPOST: function (productlistname, userid, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shareProductListWithUserUsingPOST(productlistname, userid, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary updateEntry
         * @param {string} entrycode entrycode
         * @param {number} [quantity] quantity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntryUsingPOST: function (entrycode, quantity, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateEntryUsingPOST(entrycode, quantity, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        }
    };
};
/**
 * ProductListControllerApi - factory interface
 * @export
 */
var ProductListControllerApiFactory = function (configuration, basePath, axios) {
    var localVarFp = ProductListControllerApiFp(configuration);
    return {
        /**
         *
         * @summary addEntriesToCart
         * @param {string} baseSiteId baseSiteId
         * @param {AddToCartEntries} addToCartData addToCartData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addEntriesToCartUsingPOST: function (baseSiteId, addToCartData, options) {
            return localVarFp
                .addEntriesToCartUsingPOST(baseSiteId, addToCartData, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary addProductList
         * @param {string} productlistname productlistname
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addProductListUsingPOST: function (productlistname, options) {
            return localVarFp
                .addProductListUsingPOST(productlistname, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary addProductToList
         * @param {string} productcode productcode
         * @param {string} productlistname productlistname
         * @param {number} [quantity] quantity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addProductToListUsingPOST: function (productcode, productlistname, quantity, options) {
            return localVarFp
                .addProductToListUsingPOST(productcode, productlistname, quantity, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary editProductList
         * @param {string} newname newname
         * @param {string} productlistname productlistname
         * @param {boolean} [isfavourite] isfavourite
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editProductListUsingPUT: function (newname, productlistname, isfavourite, options) {
            return localVarFp
                .editProductListUsingPUT(newname, productlistname, isfavourite, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary getFavouriteProductList
         * @param {string} [fields] fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFavouriteProductListUsingGET: function (fields, options) {
            return localVarFp
                .getFavouriteProductListUsingGET(fields, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary getProductListBin
         * @param {string} [fields] fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductListBinUsingGET: function (fields, options) {
            return localVarFp
                .getProductListBinUsingGET(fields, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary getProductList
         * @param {string} productlistname productlistname
         * @param {string} [fields] fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductListUsingGET: function (productlistname, fields, options) {
            return localVarFp
                .getProductListUsingGET(productlistname, fields, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary getSharedWithMeProductLists
         * @param {string} [fields] fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSharedWithMeProductListsUsingGET: function (fields, options) {
            return localVarFp
                .getSharedWithMeProductListsUsingGET(fields, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary removeEntry
         * @param {string} entrycode entrycode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeEntryUsingDELETE: function (entrycode, options) {
            return localVarFp
                .removeEntryUsingDELETE(entrycode, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary removeProductList
         * @param {string} productlistname productlistname
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeProductListUsingDELETE: function (productlistname, options) {
            return localVarFp
                .removeProductListUsingDELETE(productlistname, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary removeSharedProductListForUser
         * @param {string} productlistname productlistname
         * @param {string} userid userid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeSharedProductListForUserUsingDELETE: function (productlistname, userid, options) {
            return localVarFp
                .removeSharedProductListForUserUsingDELETE(productlistname, userid, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary setFavouriteProductList
         * @param {string} name name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setFavouriteProductListUsingPOST: function (name, options) {
            return localVarFp
                .setFavouriteProductListUsingPOST(name, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary shareProductListWithUser
         * @param {string} productlistname productlistname
         * @param {string} userid userid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shareProductListWithUserUsingPOST: function (productlistname, userid, options) {
            return localVarFp
                .shareProductListWithUserUsingPOST(productlistname, userid, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary updateEntry
         * @param {string} entrycode entrycode
         * @param {number} [quantity] quantity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntryUsingPOST: function (entrycode, quantity, options) {
            return localVarFp
                .updateEntryUsingPOST(entrycode, quantity, options)
                .then(function (request) { return request(axios, basePath); });
        }
    };
};
/**
 * ProductListControllerApi - object-oriented interface
 * @export
 * @class ProductListControllerApi
 * @extends {BaseAPI}
 */
var ProductListControllerApi = /** @class */ (function (_super) {
    __extends(ProductListControllerApi, _super);
    function ProductListControllerApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary addEntriesToCart
     * @param {string} baseSiteId baseSiteId
     * @param {AddToCartEntries} addToCartData addToCartData
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductListControllerApi
     */
    ProductListControllerApi.prototype.addEntriesToCartUsingPOST = function (baseSiteId, addToCartData, options) {
        var _this = this;
        return ProductListControllerApiFp(this.configuration)
            .addEntriesToCartUsingPOST(baseSiteId, addToCartData, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary addProductList
     * @param {string} productlistname productlistname
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductListControllerApi
     */
    ProductListControllerApi.prototype.addProductListUsingPOST = function (productlistname, options) {
        var _this = this;
        return ProductListControllerApiFp(this.configuration)
            .addProductListUsingPOST(productlistname, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary addProductToList
     * @param {string} productcode productcode
     * @param {string} productlistname productlistname
     * @param {number} [quantity] quantity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductListControllerApi
     */
    ProductListControllerApi.prototype.addProductToListUsingPOST = function (productcode, productlistname, quantity, options) {
        var _this = this;
        return ProductListControllerApiFp(this.configuration)
            .addProductToListUsingPOST(productcode, productlistname, quantity, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary editProductList
     * @param {string} newname newname
     * @param {string} productlistname productlistname
     * @param {boolean} [isfavourite] isfavourite
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductListControllerApi
     */
    ProductListControllerApi.prototype.editProductListUsingPUT = function (newname, productlistname, isfavourite, options) {
        var _this = this;
        return ProductListControllerApiFp(this.configuration)
            .editProductListUsingPUT(newname, productlistname, isfavourite, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary getFavouriteProductList
     * @param {string} [fields] fields
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductListControllerApi
     */
    ProductListControllerApi.prototype.getFavouriteProductListUsingGET = function (fields, options) {
        var _this = this;
        return ProductListControllerApiFp(this.configuration)
            .getFavouriteProductListUsingGET(fields, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary getProductListBin
     * @param {string} [fields] fields
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductListControllerApi
     */
    ProductListControllerApi.prototype.getProductListBinUsingGET = function (fields, options) {
        var _this = this;
        return ProductListControllerApiFp(this.configuration)
            .getProductListBinUsingGET(fields, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary getProductList
     * @param {string} productlistname productlistname
     * @param {string} [fields] fields
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductListControllerApi
     */
    ProductListControllerApi.prototype.getProductListUsingGET = function (productlistname, fields, options) {
        var _this = this;
        return ProductListControllerApiFp(this.configuration)
            .getProductListUsingGET(productlistname, fields, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary getSharedWithMeProductLists
     * @param {string} [fields] fields
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductListControllerApi
     */
    ProductListControllerApi.prototype.getSharedWithMeProductListsUsingGET = function (fields, options) {
        var _this = this;
        return ProductListControllerApiFp(this.configuration)
            .getSharedWithMeProductListsUsingGET(fields, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary removeEntry
     * @param {string} entrycode entrycode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductListControllerApi
     */
    ProductListControllerApi.prototype.removeEntryUsingDELETE = function (entrycode, options) {
        var _this = this;
        return ProductListControllerApiFp(this.configuration)
            .removeEntryUsingDELETE(entrycode, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary removeProductList
     * @param {string} productlistname productlistname
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductListControllerApi
     */
    ProductListControllerApi.prototype.removeProductListUsingDELETE = function (productlistname, options) {
        var _this = this;
        return ProductListControllerApiFp(this.configuration)
            .removeProductListUsingDELETE(productlistname, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary removeSharedProductListForUser
     * @param {string} productlistname productlistname
     * @param {string} userid userid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductListControllerApi
     */
    ProductListControllerApi.prototype.removeSharedProductListForUserUsingDELETE = function (productlistname, userid, options) {
        var _this = this;
        return ProductListControllerApiFp(this.configuration)
            .removeSharedProductListForUserUsingDELETE(productlistname, userid, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary setFavouriteProductList
     * @param {string} name name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductListControllerApi
     */
    ProductListControllerApi.prototype.setFavouriteProductListUsingPOST = function (name, options) {
        var _this = this;
        return ProductListControllerApiFp(this.configuration)
            .setFavouriteProductListUsingPOST(name, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary shareProductListWithUser
     * @param {string} productlistname productlistname
     * @param {string} userid userid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductListControllerApi
     */
    ProductListControllerApi.prototype.shareProductListWithUserUsingPOST = function (productlistname, userid, options) {
        var _this = this;
        return ProductListControllerApiFp(this.configuration)
            .shareProductListWithUserUsingPOST(productlistname, userid, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary updateEntry
     * @param {string} entrycode entrycode
     * @param {number} [quantity] quantity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductListControllerApi
     */
    ProductListControllerApi.prototype.updateEntryUsingPOST = function (entrycode, quantity, options) {
        var _this = this;
        return ProductListControllerApiFp(this.configuration)
            .updateEntryUsingPOST(entrycode, quantity, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ProductListControllerApi;
}(BaseAPI));
/**
 * ProductListForUserControllerApi - axios parameter creator
 * @export
 */
var ProductListForUserControllerApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary getProductListBin
         * @param {string} userId userId
         * @param {string} [fields] fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductListBinUsingGET1: function (userId, fields, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'userId' is not null or undefined
                            assertParamExists('getProductListBinUsingGET1', 'userId', userId);
                            localVarPath = "/{baseSiteId}/users/{userId}/productlists".replace("{" + 'userId' + "}", encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        }
    };
};
/**
 * ProductListForUserControllerApi - functional programming interface
 * @export
 */
var ProductListForUserControllerApiFp = function (configuration) {
    var localVarAxiosParamCreator = ProductListForUserControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary getProductListBin
         * @param {string} userId userId
         * @param {string} [fields] fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductListBinUsingGET1: function (userId, fields, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getProductListBinUsingGET1(userId, fields, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        }
    };
};
/**
 * ProductListForUserControllerApi - factory interface
 * @export
 */
var ProductListForUserControllerApiFactory = function (configuration, basePath, axios) {
    var localVarFp = ProductListForUserControllerApiFp(configuration);
    return {
        /**
         *
         * @summary getProductListBin
         * @param {string} userId userId
         * @param {string} [fields] fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductListBinUsingGET1: function (userId, fields, options) {
            return localVarFp
                .getProductListBinUsingGET1(userId, fields, options)
                .then(function (request) { return request(axios, basePath); });
        }
    };
};
/**
 * ProductListForUserControllerApi - object-oriented interface
 * @export
 * @class ProductListForUserControllerApi
 * @extends {BaseAPI}
 */
var ProductListForUserControllerApi = /** @class */ (function (_super) {
    __extends(ProductListForUserControllerApi, _super);
    function ProductListForUserControllerApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary getProductListBin
     * @param {string} userId userId
     * @param {string} [fields] fields
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductListForUserControllerApi
     */
    ProductListForUserControllerApi.prototype.getProductListBinUsingGET1 = function (userId, fields, options) {
        var _this = this;
        return ProductListForUserControllerApiFp(this.configuration)
            .getProductListBinUsingGET1(userId, fields, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ProductListForUserControllerApi;
}(BaseAPI));
/**
 * ProductSetControllerApi - axios parameter creator
 * @export
 */
var ProductSetControllerApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary buy
         * @param {string} baseSiteId baseSiteId
         * @param {OrderEntryList} orderEntry orderEntry
         * @param {string} [fields] fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buyUsingPOST: function (baseSiteId, orderEntry, fields, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('buyUsingPOST', 'baseSiteId', baseSiteId);
                            // verify required parameter 'orderEntry' is not null or undefined
                            assertParamExists('buyUsingPOST', 'orderEntry', orderEntry);
                            localVarPath = "/{baseSiteId}/users/{userId}/carts/{cartId}/productset/entries".replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = serializeDataIfNeeded(orderEntry, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary getProductSetForProduct
         * @param {string} catalogId catalogId
         * @param {string} catalogVersion catalogVersion
         * @param {string} productCode productCode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductSetForProductUsingGET: function (catalogId, catalogVersion, productCode, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'catalogId' is not null or undefined
                            assertParamExists('getProductSetForProductUsingGET', 'catalogId', catalogId);
                            // verify required parameter 'catalogVersion' is not null or undefined
                            assertParamExists('getProductSetForProductUsingGET', 'catalogVersion', catalogVersion);
                            // verify required parameter 'productCode' is not null or undefined
                            assertParamExists('getProductSetForProductUsingGET', 'productCode', productCode);
                            localVarPath = "/{baseSiteId}/{catalogId}/{catalogVersion}/productset/{productCode}"
                                .replace("{" + 'catalogId' + "}", encodeURIComponent(String(catalogId)))
                                .replace("{" + 'catalogVersion' + "}", encodeURIComponent(String(catalogVersion)))
                                .replace("{" + 'productCode' + "}", encodeURIComponent(String(productCode)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        }
    };
};
/**
 * ProductSetControllerApi - functional programming interface
 * @export
 */
var ProductSetControllerApiFp = function (configuration) {
    var localVarAxiosParamCreator = ProductSetControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary buy
         * @param {string} baseSiteId baseSiteId
         * @param {OrderEntryList} orderEntry orderEntry
         * @param {string} [fields] fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buyUsingPOST: function (baseSiteId, orderEntry, fields, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.buyUsingPOST(baseSiteId, orderEntry, fields, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary getProductSetForProduct
         * @param {string} catalogId catalogId
         * @param {string} catalogVersion catalogVersion
         * @param {string} productCode productCode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductSetForProductUsingGET: function (catalogId, catalogVersion, productCode, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getProductSetForProductUsingGET(catalogId, catalogVersion, productCode, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        }
    };
};
/**
 * ProductSetControllerApi - factory interface
 * @export
 */
var ProductSetControllerApiFactory = function (configuration, basePath, axios) {
    var localVarFp = ProductSetControllerApiFp(configuration);
    return {
        /**
         *
         * @summary buy
         * @param {string} baseSiteId baseSiteId
         * @param {OrderEntryList} orderEntry orderEntry
         * @param {string} [fields] fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buyUsingPOST: function (baseSiteId, orderEntry, fields, options) {
            return localVarFp
                .buyUsingPOST(baseSiteId, orderEntry, fields, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary getProductSetForProduct
         * @param {string} catalogId catalogId
         * @param {string} catalogVersion catalogVersion
         * @param {string} productCode productCode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductSetForProductUsingGET: function (catalogId, catalogVersion, productCode, options) {
            return localVarFp
                .getProductSetForProductUsingGET(catalogId, catalogVersion, productCode, options)
                .then(function (request) { return request(axios, basePath); });
        }
    };
};
/**
 * ProductSetControllerApi - object-oriented interface
 * @export
 * @class ProductSetControllerApi
 * @extends {BaseAPI}
 */
var ProductSetControllerApi = /** @class */ (function (_super) {
    __extends(ProductSetControllerApi, _super);
    function ProductSetControllerApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary buy
     * @param {string} baseSiteId baseSiteId
     * @param {OrderEntryList} orderEntry orderEntry
     * @param {string} [fields] fields
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductSetControllerApi
     */
    ProductSetControllerApi.prototype.buyUsingPOST = function (baseSiteId, orderEntry, fields, options) {
        var _this = this;
        return ProductSetControllerApiFp(this.configuration)
            .buyUsingPOST(baseSiteId, orderEntry, fields, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary getProductSetForProduct
     * @param {string} catalogId catalogId
     * @param {string} catalogVersion catalogVersion
     * @param {string} productCode productCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductSetControllerApi
     */
    ProductSetControllerApi.prototype.getProductSetForProductUsingGET = function (catalogId, catalogVersion, productCode, options) {
        var _this = this;
        return ProductSetControllerApiFp(this.configuration)
            .getProductSetForProductUsingGET(catalogId, catalogVersion, productCode, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ProductSetControllerApi;
}(BaseAPI));
/**
 * ProductsApi - axios parameter creator
 * @export
 */
var ProductsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * In the response header, the \"x-total-count\" indicates the total number of a product\'s stock levels. The following two sets of parameters are available: location (required); or longitude (required), and latitude (required).
         * @summary Get header with a total number of product\'s stock levels.
         * @param {string} baseSiteId Base site identifier
         * @param {string} productCode Product identifier
         * @param {number} [latitude] Latitude location parameter.
         * @param {string} [location] Free-text location
         * @param {number} [longitude] Longitude location parameter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countProductStockByLocation: function (baseSiteId, productCode, latitude, location, longitude, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('countProductStockByLocation', 'baseSiteId', baseSiteId);
                            // verify required parameter 'productCode' is not null or undefined
                            assertParamExists('countProductStockByLocation', 'productCode', productCode);
                            localVarPath = "/{baseSiteId}/products/{productCode}/stock"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'productCode' + "}", encodeURIComponent(String(productCode)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'HEAD' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (latitude !== undefined) {
                                localVarQueryParameter['latitude'] = latitude;
                            }
                            if (location !== undefined) {
                                localVarQueryParameter['location'] = location;
                            }
                            if (longitude !== undefined) {
                                localVarQueryParameter['longitude'] = longitude;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * In the response header, the \"x-total-count\" indicates the total number of products satisfying a query.
         * @summary Get a header with total number of products.
         * @param {string} baseSiteId Base site identifier
         * @param {string} [query] Serialized query, free text search, facets. The format of a serialized query: freeTextSearch:sort:facetKey1:facetValue1:facetKey2:facetValue2
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countProducts: function (baseSiteId, query, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('countProducts', 'baseSiteId', baseSiteId);
                            localVarPath = "/{baseSiteId}/products/search".replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'HEAD' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (query !== undefined) {
                                localVarQueryParameter['query'] = query;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Creates a new customer review as an anonymous user.
         * @summary Creates a new customer review as an anonymous user.
         * @param {string} baseSiteId Base site identifier
         * @param {string} productCode Product identifier
         * @param {Review} review Object contains review details like : rating, alias, headline, comment
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProductReview: function (baseSiteId, productCode, review, fields, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('createProductReview', 'baseSiteId', baseSiteId);
                            // verify required parameter 'productCode' is not null or undefined
                            assertParamExists('createProductReview', 'productCode', productCode);
                            // verify required parameter 'review' is not null or undefined
                            assertParamExists('createProductReview', 'review', review);
                            localVarPath = "/{baseSiteId}/products/{productCode}/reviews"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'productCode' + "}", encodeURIComponent(String(productCode)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/xml';
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = serializeDataIfNeeded(review, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Returns products added to the express update feed. Returns only elements updated after the provided timestamp. The queue is cleared using a defined cronjob.
         * @summary Get products added to the express update feed.
         * @param {string} baseSiteId Base site identifier
         * @param {string} timestamp Only items newer than the given parameter are retrieved from the queue. This parameter should be in ISO-8601 format.
         * @param {string} [catalog] Only products from this catalog are returned. Format: catalogId:catalogVersion
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExpressUpdateProducts: function (baseSiteId, timestamp, catalog, fields, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('getExpressUpdateProducts', 'baseSiteId', baseSiteId);
                            // verify required parameter 'timestamp' is not null or undefined
                            assertParamExists('getExpressUpdateProducts', 'timestamp', timestamp);
                            localVarPath = "/{baseSiteId}/products/expressupdate".replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (catalog !== undefined) {
                                localVarQueryParameter['catalog'] = catalog;
                            }
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            if (timestamp !== undefined) {
                                localVarQueryParameter['timestamp'] = timestamp;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Returns a product\'s stock levels sorted by distance from the specified location, which is provided using the free-text \"location\" parameter, or by using the longitude and latitude parameters. The following two sets of parameters are available: location (required), currentPage (optional), pageSize (optional); or longitude (required), latitude (required), currentPage (optional), pageSize(optional).
         * @summary Get a product\'s stock level.
         * @param {string} baseSiteId Base site identifier
         * @param {string} productCode Product identifier
         * @param {number} [currentPage] The current result page requested.
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {number} [latitude] Latitude location parameter.
         * @param {string} [location] Free-text location
         * @param {number} [longitude] Longitude location parameter.
         * @param {number} [pageSize] The number of results returned per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocationProductStock: function (baseSiteId, productCode, currentPage, fields, latitude, location, longitude, pageSize, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('getLocationProductStock', 'baseSiteId', baseSiteId);
                            // verify required parameter 'productCode' is not null or undefined
                            assertParamExists('getLocationProductStock', 'productCode', productCode);
                            localVarPath = "/{baseSiteId}/products/{productCode}/stock"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'productCode' + "}", encodeURIComponent(String(productCode)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (currentPage !== undefined) {
                                localVarQueryParameter['currentPage'] = currentPage;
                            }
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            if (latitude !== undefined) {
                                localVarQueryParameter['latitude'] = latitude;
                            }
                            if (location !== undefined) {
                                localVarQueryParameter['location'] = location;
                            }
                            if (longitude !== undefined) {
                                localVarQueryParameter['longitude'] = longitude;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['pageSize'] = pageSize;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Returns details of a single product according to a product code.
         * @summary Get product details.
         * @param {string} baseSiteId Base site identifier
         * @param {string} productCode Product identifier
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProduct: function (baseSiteId, productCode, fields, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('getProduct', 'baseSiteId', baseSiteId);
                            // verify required parameter 'productCode' is not null or undefined
                            assertParamExists('getProduct', 'productCode', productCode);
                            localVarPath = "/{baseSiteId}/products/{productCode}"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'productCode' + "}", encodeURIComponent(String(productCode)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Returns references for a product with a given product code. Reference type specifies which references to return.
         * @summary Get a product reference
         * @param {string} baseSiteId Base site identifier
         * @param {string} productCode Product identifier
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {number} [pageSize] Maximum size of returned results.
         * @param {string} [referenceType] Comma-separated list of reference types according to enum ProductReferenceTypeEnum. If not specified, all types of product references will be used.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductReferences: function (baseSiteId, productCode, fields, pageSize, referenceType, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('getProductReferences', 'baseSiteId', baseSiteId);
                            // verify required parameter 'productCode' is not null or undefined
                            assertParamExists('getProductReferences', 'productCode', productCode);
                            localVarPath = "/{baseSiteId}/products/{productCode}/references"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'productCode' + "}", encodeURIComponent(String(productCode)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['pageSize'] = pageSize;
                            }
                            if (referenceType !== undefined) {
                                localVarQueryParameter['referenceType'] = referenceType;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Returns the reviews for a product with a given product code.
         * @summary Get reviews for a product
         * @param {string} baseSiteId Base site identifier
         * @param {string} productCode Product identifier
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {number} [maxCount] Maximum count of reviews
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductReviews: function (baseSiteId, productCode, fields, maxCount, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('getProductReviews', 'baseSiteId', baseSiteId);
                            // verify required parameter 'productCode' is not null or undefined
                            assertParamExists('getProductReviews', 'productCode', productCode);
                            localVarPath = "/{baseSiteId}/products/{productCode}/reviews"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'productCode' + "}", encodeURIComponent(String(productCode)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            if (maxCount !== undefined) {
                                localVarQueryParameter['maxCount'] = maxCount;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Returns a list of products and additional data, such as available facets, available sorting, and pagination options. It can also include spelling suggestions. To make spelling suggestions work, you need to make sure that \"enableSpellCheck\" on the SearchQuery is set to \"true\" (by default, it should already be set to \"true\"). You also need to have indexed properties configured to be used for spellchecking.
         * @summary Get a list of products and additional data
         * @param {string} baseSiteId Base site identifier
         * @param {number} [currentPage] The current result page requested.
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {number} [pageSize] The number of results returned per page.
         * @param {string} [query] Serialized query, free text search, facets. The format of a serialized query: freeTextSearch:sort:facetKey1:facetValue1:facetKey2:facetValue2
         * @param {string} [searchQueryContext] The context to be used in the search query.
         * @param {string} [sort] Sorting method applied to the return results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProducts: function (baseSiteId, currentPage, fields, pageSize, query, searchQueryContext, sort, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('getProducts', 'baseSiteId', baseSiteId);
                            localVarPath = "/{baseSiteId}/products/search".replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (currentPage !== undefined) {
                                localVarQueryParameter['currentPage'] = currentPage;
                            }
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['pageSize'] = pageSize;
                            }
                            if (query !== undefined) {
                                localVarQueryParameter['query'] = query;
                            }
                            if (searchQueryContext !== undefined) {
                                localVarQueryParameter['searchQueryContext'] = searchQueryContext;
                            }
                            if (sort !== undefined) {
                                localVarQueryParameter['sort'] = sort;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Returns a product\'s stock level for a particular store (in other words, for a particular point of sale).
         * @summary Get a product\'s stock level for a store
         * @param {string} baseSiteId Base site identifier
         * @param {string} productCode Product identifier
         * @param {string} storeName Store identifier
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStoreProductStock: function (baseSiteId, productCode, storeName, fields, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('getStoreProductStock', 'baseSiteId', baseSiteId);
                            // verify required parameter 'productCode' is not null or undefined
                            assertParamExists('getStoreProductStock', 'productCode', productCode);
                            // verify required parameter 'storeName' is not null or undefined
                            assertParamExists('getStoreProductStock', 'storeName', storeName);
                            localVarPath = "/{baseSiteId}/products/{productCode}/stock/{storeName}"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'productCode' + "}", encodeURIComponent(String(productCode)))
                                .replace("{" + 'storeName' + "}", encodeURIComponent(String(storeName)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Returns a list of all available suggestions related to a given term and limits the results to a specific value of the max parameter.
         * @summary Get a list of available suggestions
         * @param {string} baseSiteId Base site identifier
         * @param {string} term Specified term
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {number} [max] Specifies the limit of results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSuggestions: function (baseSiteId, term, fields, max, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('getSuggestions', 'baseSiteId', baseSiteId);
                            // verify required parameter 'term' is not null or undefined
                            assertParamExists('getSuggestions', 'term', term);
                            localVarPath = "/{baseSiteId}/products/suggestions".replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            if (max !== undefined) {
                                localVarQueryParameter['max'] = max;
                            }
                            if (term !== undefined) {
                                localVarQueryParameter['term'] = term;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        }
    };
};
/**
 * ProductsApi - functional programming interface
 * @export
 */
var ProductsApiFp = function (configuration) {
    var localVarAxiosParamCreator = ProductsApiAxiosParamCreator(configuration);
    return {
        /**
         * In the response header, the \"x-total-count\" indicates the total number of a product\'s stock levels. The following two sets of parameters are available: location (required); or longitude (required), and latitude (required).
         * @summary Get header with a total number of product\'s stock levels.
         * @param {string} baseSiteId Base site identifier
         * @param {string} productCode Product identifier
         * @param {number} [latitude] Latitude location parameter.
         * @param {string} [location] Free-text location
         * @param {number} [longitude] Longitude location parameter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countProductStockByLocation: function (baseSiteId, productCode, latitude, location, longitude, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.countProductStockByLocation(baseSiteId, productCode, latitude, location, longitude, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * In the response header, the \"x-total-count\" indicates the total number of products satisfying a query.
         * @summary Get a header with total number of products.
         * @param {string} baseSiteId Base site identifier
         * @param {string} [query] Serialized query, free text search, facets. The format of a serialized query: freeTextSearch:sort:facetKey1:facetValue1:facetKey2:facetValue2
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countProducts: function (baseSiteId, query, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.countProducts(baseSiteId, query, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Creates a new customer review as an anonymous user.
         * @summary Creates a new customer review as an anonymous user.
         * @param {string} baseSiteId Base site identifier
         * @param {string} productCode Product identifier
         * @param {Review} review Object contains review details like : rating, alias, headline, comment
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProductReview: function (baseSiteId, productCode, review, fields, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createProductReview(baseSiteId, productCode, review, fields, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns products added to the express update feed. Returns only elements updated after the provided timestamp. The queue is cleared using a defined cronjob.
         * @summary Get products added to the express update feed.
         * @param {string} baseSiteId Base site identifier
         * @param {string} timestamp Only items newer than the given parameter are retrieved from the queue. This parameter should be in ISO-8601 format.
         * @param {string} [catalog] Only products from this catalog are returned. Format: catalogId:catalogVersion
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExpressUpdateProducts: function (baseSiteId, timestamp, catalog, fields, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getExpressUpdateProducts(baseSiteId, timestamp, catalog, fields, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns a product\'s stock levels sorted by distance from the specified location, which is provided using the free-text \"location\" parameter, or by using the longitude and latitude parameters. The following two sets of parameters are available: location (required), currentPage (optional), pageSize (optional); or longitude (required), latitude (required), currentPage (optional), pageSize(optional).
         * @summary Get a product\'s stock level.
         * @param {string} baseSiteId Base site identifier
         * @param {string} productCode Product identifier
         * @param {number} [currentPage] The current result page requested.
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {number} [latitude] Latitude location parameter.
         * @param {string} [location] Free-text location
         * @param {number} [longitude] Longitude location parameter.
         * @param {number} [pageSize] The number of results returned per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocationProductStock: function (baseSiteId, productCode, currentPage, fields, latitude, location, longitude, pageSize, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getLocationProductStock(baseSiteId, productCode, currentPage, fields, latitude, location, longitude, pageSize, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns details of a single product according to a product code.
         * @summary Get product details.
         * @param {string} baseSiteId Base site identifier
         * @param {string} productCode Product identifier
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProduct: function (baseSiteId, productCode, fields, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getProduct(baseSiteId, productCode, fields, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns references for a product with a given product code. Reference type specifies which references to return.
         * @summary Get a product reference
         * @param {string} baseSiteId Base site identifier
         * @param {string} productCode Product identifier
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {number} [pageSize] Maximum size of returned results.
         * @param {string} [referenceType] Comma-separated list of reference types according to enum ProductReferenceTypeEnum. If not specified, all types of product references will be used.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductReferences: function (baseSiteId, productCode, fields, pageSize, referenceType, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getProductReferences(baseSiteId, productCode, fields, pageSize, referenceType, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns the reviews for a product with a given product code.
         * @summary Get reviews for a product
         * @param {string} baseSiteId Base site identifier
         * @param {string} productCode Product identifier
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {number} [maxCount] Maximum count of reviews
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductReviews: function (baseSiteId, productCode, fields, maxCount, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getProductReviews(baseSiteId, productCode, fields, maxCount, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns a list of products and additional data, such as available facets, available sorting, and pagination options. It can also include spelling suggestions. To make spelling suggestions work, you need to make sure that \"enableSpellCheck\" on the SearchQuery is set to \"true\" (by default, it should already be set to \"true\"). You also need to have indexed properties configured to be used for spellchecking.
         * @summary Get a list of products and additional data
         * @param {string} baseSiteId Base site identifier
         * @param {number} [currentPage] The current result page requested.
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {number} [pageSize] The number of results returned per page.
         * @param {string} [query] Serialized query, free text search, facets. The format of a serialized query: freeTextSearch:sort:facetKey1:facetValue1:facetKey2:facetValue2
         * @param {string} [searchQueryContext] The context to be used in the search query.
         * @param {string} [sort] Sorting method applied to the return results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProducts: function (baseSiteId, currentPage, fields, pageSize, query, searchQueryContext, sort, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getProducts(baseSiteId, currentPage, fields, pageSize, query, searchQueryContext, sort, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns a product\'s stock level for a particular store (in other words, for a particular point of sale).
         * @summary Get a product\'s stock level for a store
         * @param {string} baseSiteId Base site identifier
         * @param {string} productCode Product identifier
         * @param {string} storeName Store identifier
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStoreProductStock: function (baseSiteId, productCode, storeName, fields, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getStoreProductStock(baseSiteId, productCode, storeName, fields, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns a list of all available suggestions related to a given term and limits the results to a specific value of the max parameter.
         * @summary Get a list of available suggestions
         * @param {string} baseSiteId Base site identifier
         * @param {string} term Specified term
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {number} [max] Specifies the limit of results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSuggestions: function (baseSiteId, term, fields, max, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getSuggestions(baseSiteId, term, fields, max, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        }
    };
};
/**
 * ProductsApi - factory interface
 * @export
 */
var ProductsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = ProductsApiFp(configuration);
    return {
        /**
         * In the response header, the \"x-total-count\" indicates the total number of a product\'s stock levels. The following two sets of parameters are available: location (required); or longitude (required), and latitude (required).
         * @summary Get header with a total number of product\'s stock levels.
         * @param {string} baseSiteId Base site identifier
         * @param {string} productCode Product identifier
         * @param {number} [latitude] Latitude location parameter.
         * @param {string} [location] Free-text location
         * @param {number} [longitude] Longitude location parameter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countProductStockByLocation: function (baseSiteId, productCode, latitude, location, longitude, options) {
            return localVarFp
                .countProductStockByLocation(baseSiteId, productCode, latitude, location, longitude, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * In the response header, the \"x-total-count\" indicates the total number of products satisfying a query.
         * @summary Get a header with total number of products.
         * @param {string} baseSiteId Base site identifier
         * @param {string} [query] Serialized query, free text search, facets. The format of a serialized query: freeTextSearch:sort:facetKey1:facetValue1:facetKey2:facetValue2
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countProducts: function (baseSiteId, query, options) {
            return localVarFp
                .countProducts(baseSiteId, query, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Creates a new customer review as an anonymous user.
         * @summary Creates a new customer review as an anonymous user.
         * @param {string} baseSiteId Base site identifier
         * @param {string} productCode Product identifier
         * @param {Review} review Object contains review details like : rating, alias, headline, comment
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProductReview: function (baseSiteId, productCode, review, fields, options) {
            return localVarFp
                .createProductReview(baseSiteId, productCode, review, fields, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns products added to the express update feed. Returns only elements updated after the provided timestamp. The queue is cleared using a defined cronjob.
         * @summary Get products added to the express update feed.
         * @param {string} baseSiteId Base site identifier
         * @param {string} timestamp Only items newer than the given parameter are retrieved from the queue. This parameter should be in ISO-8601 format.
         * @param {string} [catalog] Only products from this catalog are returned. Format: catalogId:catalogVersion
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExpressUpdateProducts: function (baseSiteId, timestamp, catalog, fields, options) {
            return localVarFp
                .getExpressUpdateProducts(baseSiteId, timestamp, catalog, fields, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns a product\'s stock levels sorted by distance from the specified location, which is provided using the free-text \"location\" parameter, or by using the longitude and latitude parameters. The following two sets of parameters are available: location (required), currentPage (optional), pageSize (optional); or longitude (required), latitude (required), currentPage (optional), pageSize(optional).
         * @summary Get a product\'s stock level.
         * @param {string} baseSiteId Base site identifier
         * @param {string} productCode Product identifier
         * @param {number} [currentPage] The current result page requested.
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {number} [latitude] Latitude location parameter.
         * @param {string} [location] Free-text location
         * @param {number} [longitude] Longitude location parameter.
         * @param {number} [pageSize] The number of results returned per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocationProductStock: function (baseSiteId, productCode, currentPage, fields, latitude, location, longitude, pageSize, options) {
            return localVarFp
                .getLocationProductStock(baseSiteId, productCode, currentPage, fields, latitude, location, longitude, pageSize, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns details of a single product according to a product code.
         * @summary Get product details.
         * @param {string} baseSiteId Base site identifier
         * @param {string} productCode Product identifier
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProduct: function (baseSiteId, productCode, fields, options) {
            return localVarFp
                .getProduct(baseSiteId, productCode, fields, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns references for a product with a given product code. Reference type specifies which references to return.
         * @summary Get a product reference
         * @param {string} baseSiteId Base site identifier
         * @param {string} productCode Product identifier
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {number} [pageSize] Maximum size of returned results.
         * @param {string} [referenceType] Comma-separated list of reference types according to enum ProductReferenceTypeEnum. If not specified, all types of product references will be used.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductReferences: function (baseSiteId, productCode, fields, pageSize, referenceType, options) {
            return localVarFp
                .getProductReferences(baseSiteId, productCode, fields, pageSize, referenceType, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns the reviews for a product with a given product code.
         * @summary Get reviews for a product
         * @param {string} baseSiteId Base site identifier
         * @param {string} productCode Product identifier
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {number} [maxCount] Maximum count of reviews
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductReviews: function (baseSiteId, productCode, fields, maxCount, options) {
            return localVarFp
                .getProductReviews(baseSiteId, productCode, fields, maxCount, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns a list of products and additional data, such as available facets, available sorting, and pagination options. It can also include spelling suggestions. To make spelling suggestions work, you need to make sure that \"enableSpellCheck\" on the SearchQuery is set to \"true\" (by default, it should already be set to \"true\"). You also need to have indexed properties configured to be used for spellchecking.
         * @summary Get a list of products and additional data
         * @param {string} baseSiteId Base site identifier
         * @param {number} [currentPage] The current result page requested.
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {number} [pageSize] The number of results returned per page.
         * @param {string} [query] Serialized query, free text search, facets. The format of a serialized query: freeTextSearch:sort:facetKey1:facetValue1:facetKey2:facetValue2
         * @param {string} [searchQueryContext] The context to be used in the search query.
         * @param {string} [sort] Sorting method applied to the return results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProducts: function (baseSiteId, currentPage, fields, pageSize, query, searchQueryContext, sort, options) {
            return localVarFp
                .getProducts(baseSiteId, currentPage, fields, pageSize, query, searchQueryContext, sort, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns a product\'s stock level for a particular store (in other words, for a particular point of sale).
         * @summary Get a product\'s stock level for a store
         * @param {string} baseSiteId Base site identifier
         * @param {string} productCode Product identifier
         * @param {string} storeName Store identifier
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStoreProductStock: function (baseSiteId, productCode, storeName, fields, options) {
            return localVarFp
                .getStoreProductStock(baseSiteId, productCode, storeName, fields, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns a list of all available suggestions related to a given term and limits the results to a specific value of the max parameter.
         * @summary Get a list of available suggestions
         * @param {string} baseSiteId Base site identifier
         * @param {string} term Specified term
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {number} [max] Specifies the limit of results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSuggestions: function (baseSiteId, term, fields, max, options) {
            return localVarFp
                .getSuggestions(baseSiteId, term, fields, max, options)
                .then(function (request) { return request(axios, basePath); });
        }
    };
};
/**
 * ProductsApi - object-oriented interface
 * @export
 * @class ProductsApi
 * @extends {BaseAPI}
 */
var ProductsApi = /** @class */ (function (_super) {
    __extends(ProductsApi, _super);
    function ProductsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * In the response header, the \"x-total-count\" indicates the total number of a product\'s stock levels. The following two sets of parameters are available: location (required); or longitude (required), and latitude (required).
     * @summary Get header with a total number of product\'s stock levels.
     * @param {string} baseSiteId Base site identifier
     * @param {string} productCode Product identifier
     * @param {number} [latitude] Latitude location parameter.
     * @param {string} [location] Free-text location
     * @param {number} [longitude] Longitude location parameter.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    ProductsApi.prototype.countProductStockByLocation = function (baseSiteId, productCode, latitude, location, longitude, options) {
        var _this = this;
        return ProductsApiFp(this.configuration)
            .countProductStockByLocation(baseSiteId, productCode, latitude, location, longitude, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * In the response header, the \"x-total-count\" indicates the total number of products satisfying a query.
     * @summary Get a header with total number of products.
     * @param {string} baseSiteId Base site identifier
     * @param {string} [query] Serialized query, free text search, facets. The format of a serialized query: freeTextSearch:sort:facetKey1:facetValue1:facetKey2:facetValue2
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    ProductsApi.prototype.countProducts = function (baseSiteId, query, options) {
        var _this = this;
        return ProductsApiFp(this.configuration)
            .countProducts(baseSiteId, query, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Creates a new customer review as an anonymous user.
     * @summary Creates a new customer review as an anonymous user.
     * @param {string} baseSiteId Base site identifier
     * @param {string} productCode Product identifier
     * @param {Review} review Object contains review details like : rating, alias, headline, comment
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    ProductsApi.prototype.createProductReview = function (baseSiteId, productCode, review, fields, options) {
        var _this = this;
        return ProductsApiFp(this.configuration)
            .createProductReview(baseSiteId, productCode, review, fields, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns products added to the express update feed. Returns only elements updated after the provided timestamp. The queue is cleared using a defined cronjob.
     * @summary Get products added to the express update feed.
     * @param {string} baseSiteId Base site identifier
     * @param {string} timestamp Only items newer than the given parameter are retrieved from the queue. This parameter should be in ISO-8601 format.
     * @param {string} [catalog] Only products from this catalog are returned. Format: catalogId:catalogVersion
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    ProductsApi.prototype.getExpressUpdateProducts = function (baseSiteId, timestamp, catalog, fields, options) {
        var _this = this;
        return ProductsApiFp(this.configuration)
            .getExpressUpdateProducts(baseSiteId, timestamp, catalog, fields, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns a product\'s stock levels sorted by distance from the specified location, which is provided using the free-text \"location\" parameter, or by using the longitude and latitude parameters. The following two sets of parameters are available: location (required), currentPage (optional), pageSize (optional); or longitude (required), latitude (required), currentPage (optional), pageSize(optional).
     * @summary Get a product\'s stock level.
     * @param {string} baseSiteId Base site identifier
     * @param {string} productCode Product identifier
     * @param {number} [currentPage] The current result page requested.
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
     * @param {number} [latitude] Latitude location parameter.
     * @param {string} [location] Free-text location
     * @param {number} [longitude] Longitude location parameter.
     * @param {number} [pageSize] The number of results returned per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    ProductsApi.prototype.getLocationProductStock = function (baseSiteId, productCode, currentPage, fields, latitude, location, longitude, pageSize, options) {
        var _this = this;
        return ProductsApiFp(this.configuration)
            .getLocationProductStock(baseSiteId, productCode, currentPage, fields, latitude, location, longitude, pageSize, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns details of a single product according to a product code.
     * @summary Get product details.
     * @param {string} baseSiteId Base site identifier
     * @param {string} productCode Product identifier
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    ProductsApi.prototype.getProduct = function (baseSiteId, productCode, fields, options) {
        var _this = this;
        return ProductsApiFp(this.configuration)
            .getProduct(baseSiteId, productCode, fields, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns references for a product with a given product code. Reference type specifies which references to return.
     * @summary Get a product reference
     * @param {string} baseSiteId Base site identifier
     * @param {string} productCode Product identifier
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
     * @param {number} [pageSize] Maximum size of returned results.
     * @param {string} [referenceType] Comma-separated list of reference types according to enum ProductReferenceTypeEnum. If not specified, all types of product references will be used.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    ProductsApi.prototype.getProductReferences = function (baseSiteId, productCode, fields, pageSize, referenceType, options) {
        var _this = this;
        return ProductsApiFp(this.configuration)
            .getProductReferences(baseSiteId, productCode, fields, pageSize, referenceType, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns the reviews for a product with a given product code.
     * @summary Get reviews for a product
     * @param {string} baseSiteId Base site identifier
     * @param {string} productCode Product identifier
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
     * @param {number} [maxCount] Maximum count of reviews
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    ProductsApi.prototype.getProductReviews = function (baseSiteId, productCode, fields, maxCount, options) {
        var _this = this;
        return ProductsApiFp(this.configuration)
            .getProductReviews(baseSiteId, productCode, fields, maxCount, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns a list of products and additional data, such as available facets, available sorting, and pagination options. It can also include spelling suggestions. To make spelling suggestions work, you need to make sure that \"enableSpellCheck\" on the SearchQuery is set to \"true\" (by default, it should already be set to \"true\"). You also need to have indexed properties configured to be used for spellchecking.
     * @summary Get a list of products and additional data
     * @param {string} baseSiteId Base site identifier
     * @param {number} [currentPage] The current result page requested.
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
     * @param {number} [pageSize] The number of results returned per page.
     * @param {string} [query] Serialized query, free text search, facets. The format of a serialized query: freeTextSearch:sort:facetKey1:facetValue1:facetKey2:facetValue2
     * @param {string} [searchQueryContext] The context to be used in the search query.
     * @param {string} [sort] Sorting method applied to the return results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    ProductsApi.prototype.getProducts = function (baseSiteId, currentPage, fields, pageSize, query, searchQueryContext, sort, options) {
        var _this = this;
        return ProductsApiFp(this.configuration)
            .getProducts(baseSiteId, currentPage, fields, pageSize, query, searchQueryContext, sort, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns a product\'s stock level for a particular store (in other words, for a particular point of sale).
     * @summary Get a product\'s stock level for a store
     * @param {string} baseSiteId Base site identifier
     * @param {string} productCode Product identifier
     * @param {string} storeName Store identifier
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    ProductsApi.prototype.getStoreProductStock = function (baseSiteId, productCode, storeName, fields, options) {
        var _this = this;
        return ProductsApiFp(this.configuration)
            .getStoreProductStock(baseSiteId, productCode, storeName, fields, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns a list of all available suggestions related to a given term and limits the results to a specific value of the max parameter.
     * @summary Get a list of available suggestions
     * @param {string} baseSiteId Base site identifier
     * @param {string} term Specified term
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
     * @param {number} [max] Specifies the limit of results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    ProductsApi.prototype.getSuggestions = function (baseSiteId, term, fields, max, options) {
        var _this = this;
        return ProductsApiFp(this.configuration)
            .getSuggestions(baseSiteId, term, fields, max, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ProductsApi;
}(BaseAPI));
/**
 * PromotionsApi - axios parameter creator
 * @export
 */
var PromotionsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Returns details of a single promotion specified by a promotion code. Requests pertaining to promotions have been developed for the previous version of promotions and vouchers and therefore some of them are currently not compatible with the new promotion engine.
         * @summary Get a promotion based on code
         * @param {string} baseSiteId Base site identifier
         * @param {string} code Promotion identifier (code)
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPromotion: function (baseSiteId, code, fields, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('getPromotion', 'baseSiteId', baseSiteId);
                            // verify required parameter 'code' is not null or undefined
                            assertParamExists('getPromotion', 'code', code);
                            localVarPath = "/{baseSiteId}/promotions/{code}"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'code' + "}", encodeURIComponent(String(code)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Returns promotions defined for a current base site. Requests pertaining to promotions have been developed for the previous version of promotions and vouchers and therefore some of them are currently not compatible with the new promotion engine.
         * @summary Get a list of promotions.
         * @param {string} baseSiteId Base site identifier
         * @param {'all' | 'product' | 'order'} type Defines what type of promotions should be returned. Values supported for that parameter are: &lt;ul&gt;&lt;li&gt;all: All available promotions are returned&lt;/li&gt;&lt;li&gt;product: Only product promotions are returned&lt;/li&gt;&lt;li&gt;order: Only order promotions are returned&lt;/li&gt;&lt;/ul&gt;
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {string} [promotionGroup] Only promotions from this group are returned
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPromotions: function (baseSiteId, type, fields, promotionGroup, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('getPromotions', 'baseSiteId', baseSiteId);
                            // verify required parameter 'type' is not null or undefined
                            assertParamExists('getPromotions', 'type', type);
                            localVarPath = "/{baseSiteId}/promotions".replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            if (promotionGroup !== undefined) {
                                localVarQueryParameter['promotionGroup'] = promotionGroup;
                            }
                            if (type !== undefined) {
                                localVarQueryParameter['type'] = type;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        }
    };
};
/**
 * PromotionsApi - functional programming interface
 * @export
 */
var PromotionsApiFp = function (configuration) {
    var localVarAxiosParamCreator = PromotionsApiAxiosParamCreator(configuration);
    return {
        /**
         * Returns details of a single promotion specified by a promotion code. Requests pertaining to promotions have been developed for the previous version of promotions and vouchers and therefore some of them are currently not compatible with the new promotion engine.
         * @summary Get a promotion based on code
         * @param {string} baseSiteId Base site identifier
         * @param {string} code Promotion identifier (code)
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPromotion: function (baseSiteId, code, fields, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getPromotion(baseSiteId, code, fields, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns promotions defined for a current base site. Requests pertaining to promotions have been developed for the previous version of promotions and vouchers and therefore some of them are currently not compatible with the new promotion engine.
         * @summary Get a list of promotions.
         * @param {string} baseSiteId Base site identifier
         * @param {'all' | 'product' | 'order'} type Defines what type of promotions should be returned. Values supported for that parameter are: &lt;ul&gt;&lt;li&gt;all: All available promotions are returned&lt;/li&gt;&lt;li&gt;product: Only product promotions are returned&lt;/li&gt;&lt;li&gt;order: Only order promotions are returned&lt;/li&gt;&lt;/ul&gt;
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {string} [promotionGroup] Only promotions from this group are returned
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPromotions: function (baseSiteId, type, fields, promotionGroup, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getPromotions(baseSiteId, type, fields, promotionGroup, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        }
    };
};
/**
 * PromotionsApi - factory interface
 * @export
 */
var PromotionsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = PromotionsApiFp(configuration);
    return {
        /**
         * Returns details of a single promotion specified by a promotion code. Requests pertaining to promotions have been developed for the previous version of promotions and vouchers and therefore some of them are currently not compatible with the new promotion engine.
         * @summary Get a promotion based on code
         * @param {string} baseSiteId Base site identifier
         * @param {string} code Promotion identifier (code)
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPromotion: function (baseSiteId, code, fields, options) {
            return localVarFp
                .getPromotion(baseSiteId, code, fields, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns promotions defined for a current base site. Requests pertaining to promotions have been developed for the previous version of promotions and vouchers and therefore some of them are currently not compatible with the new promotion engine.
         * @summary Get a list of promotions.
         * @param {string} baseSiteId Base site identifier
         * @param {'all' | 'product' | 'order'} type Defines what type of promotions should be returned. Values supported for that parameter are: &lt;ul&gt;&lt;li&gt;all: All available promotions are returned&lt;/li&gt;&lt;li&gt;product: Only product promotions are returned&lt;/li&gt;&lt;li&gt;order: Only order promotions are returned&lt;/li&gt;&lt;/ul&gt;
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {string} [promotionGroup] Only promotions from this group are returned
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPromotions: function (baseSiteId, type, fields, promotionGroup, options) {
            return localVarFp
                .getPromotions(baseSiteId, type, fields, promotionGroup, options)
                .then(function (request) { return request(axios, basePath); });
        }
    };
};
/**
 * PromotionsApi - object-oriented interface
 * @export
 * @class PromotionsApi
 * @extends {BaseAPI}
 */
var PromotionsApi = /** @class */ (function (_super) {
    __extends(PromotionsApi, _super);
    function PromotionsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Returns details of a single promotion specified by a promotion code. Requests pertaining to promotions have been developed for the previous version of promotions and vouchers and therefore some of them are currently not compatible with the new promotion engine.
     * @summary Get a promotion based on code
     * @param {string} baseSiteId Base site identifier
     * @param {string} code Promotion identifier (code)
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromotionsApi
     */
    PromotionsApi.prototype.getPromotion = function (baseSiteId, code, fields, options) {
        var _this = this;
        return PromotionsApiFp(this.configuration)
            .getPromotion(baseSiteId, code, fields, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns promotions defined for a current base site. Requests pertaining to promotions have been developed for the previous version of promotions and vouchers and therefore some of them are currently not compatible with the new promotion engine.
     * @summary Get a list of promotions.
     * @param {string} baseSiteId Base site identifier
     * @param {'all' | 'product' | 'order'} type Defines what type of promotions should be returned. Values supported for that parameter are: &lt;ul&gt;&lt;li&gt;all: All available promotions are returned&lt;/li&gt;&lt;li&gt;product: Only product promotions are returned&lt;/li&gt;&lt;li&gt;order: Only order promotions are returned&lt;/li&gt;&lt;/ul&gt;
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
     * @param {string} [promotionGroup] Only promotions from this group are returned
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromotionsApi
     */
    PromotionsApi.prototype.getPromotions = function (baseSiteId, type, fields, promotionGroup, options) {
        var _this = this;
        return PromotionsApiFp(this.configuration)
            .getPromotions(baseSiteId, type, fields, promotionGroup, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return PromotionsApi;
}(BaseAPI));
/**
 * QualtricsCdcControllerApi - axios parameter creator
 * @export
 */
var QualtricsCdcControllerApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary lightRegistration
         * @param {QualtricsGigyaLightRegistration} data data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lightRegistrationUsingPOST: function (data, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'data' is not null or undefined
                            assertParamExists('lightRegistrationUsingPOST', 'data', data);
                            localVarPath = "/{baseSiteId}/qualtrics/cdc/light-register";
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = serializeDataIfNeeded(data, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary test
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testUsingGET: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/{baseSiteId}/qualtrics/cdc/test";
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        }
    };
};
/**
 * QualtricsCdcControllerApi - functional programming interface
 * @export
 */
var QualtricsCdcControllerApiFp = function (configuration) {
    var localVarAxiosParamCreator = QualtricsCdcControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary lightRegistration
         * @param {QualtricsGigyaLightRegistration} data data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lightRegistrationUsingPOST: function (data, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.lightRegistrationUsingPOST(data, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary test
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testUsingGET: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.testUsingGET(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        }
    };
};
/**
 * QualtricsCdcControllerApi - factory interface
 * @export
 */
var QualtricsCdcControllerApiFactory = function (configuration, basePath, axios) {
    var localVarFp = QualtricsCdcControllerApiFp(configuration);
    return {
        /**
         *
         * @summary lightRegistration
         * @param {QualtricsGigyaLightRegistration} data data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lightRegistrationUsingPOST: function (data, options) {
            return localVarFp
                .lightRegistrationUsingPOST(data, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary test
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testUsingGET: function (options) {
            return localVarFp
                .testUsingGET(options)
                .then(function (request) { return request(axios, basePath); });
        }
    };
};
/**
 * QualtricsCdcControllerApi - object-oriented interface
 * @export
 * @class QualtricsCdcControllerApi
 * @extends {BaseAPI}
 */
var QualtricsCdcControllerApi = /** @class */ (function (_super) {
    __extends(QualtricsCdcControllerApi, _super);
    function QualtricsCdcControllerApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary lightRegistration
     * @param {QualtricsGigyaLightRegistration} data data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QualtricsCdcControllerApi
     */
    QualtricsCdcControllerApi.prototype.lightRegistrationUsingPOST = function (data, options) {
        var _this = this;
        return QualtricsCdcControllerApiFp(this.configuration)
            .lightRegistrationUsingPOST(data, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary test
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QualtricsCdcControllerApi
     */
    QualtricsCdcControllerApi.prototype.testUsingGET = function (options) {
        var _this = this;
        return QualtricsCdcControllerApiFp(this.configuration)
            .testUsingGET(options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return QualtricsCdcControllerApi;
}(BaseAPI));
/**
 * QualtricsConfigurationControllerApi - axios parameter creator
 * @export
 */
var QualtricsConfigurationControllerApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary getNewResource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNewResourceUsingGET: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/{baseSiteId}/qualtrics/config";
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        }
    };
};
/**
 * QualtricsConfigurationControllerApi - functional programming interface
 * @export
 */
var QualtricsConfigurationControllerApiFp = function (configuration) {
    var localVarAxiosParamCreator = QualtricsConfigurationControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary getNewResource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNewResourceUsingGET: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getNewResourceUsingGET(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        }
    };
};
/**
 * QualtricsConfigurationControllerApi - factory interface
 * @export
 */
var QualtricsConfigurationControllerApiFactory = function (configuration, basePath, axios) {
    var localVarFp = QualtricsConfigurationControllerApiFp(configuration);
    return {
        /**
         *
         * @summary getNewResource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNewResourceUsingGET: function (options) {
            return localVarFp
                .getNewResourceUsingGET(options)
                .then(function (request) { return request(axios, basePath); });
        }
    };
};
/**
 * QualtricsConfigurationControllerApi - object-oriented interface
 * @export
 * @class QualtricsConfigurationControllerApi
 * @extends {BaseAPI}
 */
var QualtricsConfigurationControllerApi = /** @class */ (function (_super) {
    __extends(QualtricsConfigurationControllerApi, _super);
    function QualtricsConfigurationControllerApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary getNewResource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QualtricsConfigurationControllerApi
     */
    QualtricsConfigurationControllerApi.prototype.getNewResourceUsingGET = function (options) {
        var _this = this;
        return QualtricsConfigurationControllerApiFp(this.configuration)
            .getNewResourceUsingGET(options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return QualtricsConfigurationControllerApi;
}(BaseAPI));
/**
 * SaveCartApi - axios parameter creator
 * @export
 */
var SaveCartApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Explicitly clones a cart.
         * @summary Explicitly clones a cart.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {string} [description] The description that should be applied to the cloned cart.
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {string} [name] The name that should be applied to the cloned cart.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doCartClone: function (baseSiteId, cartId, userId, description, fields, name, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('doCartClone', 'baseSiteId', baseSiteId);
                            // verify required parameter 'cartId' is not null or undefined
                            assertParamExists('doCartClone', 'cartId', cartId);
                            // verify required parameter 'userId' is not null or undefined
                            assertParamExists('doCartClone', 'userId', userId);
                            localVarPath = "/{baseSiteId}/users/{userId}/carts/{cartId}/clonesavedcart"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'cartId' + "}", encodeURIComponent(String(cartId)))
                                .replace("{" + 'userId' + "}", encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (description !== undefined) {
                                localVarQueryParameter['description'] = description;
                            }
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            if (name !== undefined) {
                                localVarQueryParameter['name'] = name;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Explicitly saves a cart.
         * @summary Explicitly saves a cart.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {string} [saveCartDescription] The description that should be applied to the saved cart.
         * @param {string} [saveCartName] The name that should be applied to the saved cart.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doSaveCart: function (baseSiteId, cartId, userId, fields, saveCartDescription, saveCartName, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('doSaveCart', 'baseSiteId', baseSiteId);
                            // verify required parameter 'cartId' is not null or undefined
                            assertParamExists('doSaveCart', 'cartId', cartId);
                            // verify required parameter 'userId' is not null or undefined
                            assertParamExists('doSaveCart', 'userId', userId);
                            localVarPath = "/{baseSiteId}/users/{userId}/carts/{cartId}/save"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'cartId' + "}", encodeURIComponent(String(cartId)))
                                .replace("{" + 'userId' + "}", encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            if (saveCartDescription !== undefined) {
                                localVarQueryParameter['saveCartDescription'] = saveCartDescription;
                            }
                            if (saveCartName !== undefined) {
                                localVarQueryParameter['saveCartName'] = saveCartName;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Flags a cart for deletion (the cart doesn\'t have corresponding save cart attributes anymore). The cart is not actually deleted from the database. But with the removal of the saved cart attributes, this cart will be taken care of by the cart removal job just like any other cart.
         * @summary Flag a cart for deletion.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doUpdateFlagForDeletion: function (baseSiteId, cartId, userId, fields, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('doUpdateFlagForDeletion', 'baseSiteId', baseSiteId);
                            // verify required parameter 'cartId' is not null or undefined
                            assertParamExists('doUpdateFlagForDeletion', 'cartId', cartId);
                            // verify required parameter 'userId' is not null or undefined
                            assertParamExists('doUpdateFlagForDeletion', 'userId', userId);
                            localVarPath = "/{baseSiteId}/users/{userId}/carts/{cartId}/flagForDeletion"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'cartId' + "}", encodeURIComponent(String(cartId)))
                                .replace("{" + 'userId' + "}", encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Restore a saved cart.
         * @summary Restore a saved cart.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doUpdateSavedCart: function (baseSiteId, cartId, userId, fields, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('doUpdateSavedCart', 'baseSiteId', baseSiteId);
                            // verify required parameter 'cartId' is not null or undefined
                            assertParamExists('doUpdateSavedCart', 'cartId', cartId);
                            // verify required parameter 'userId' is not null or undefined
                            assertParamExists('doUpdateSavedCart', 'userId', userId);
                            localVarPath = "/{baseSiteId}/users/{userId}/carts/{cartId}/restoresavedcart"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'cartId' + "}", encodeURIComponent(String(cartId)))
                                .replace("{" + 'userId' + "}", encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Returns a saved cart for an authenticated user. The cart is identified using the \"cartId\" parameter.
         * @summary Get a saved cart.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSavedCart: function (baseSiteId, cartId, userId, fields, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('getSavedCart', 'baseSiteId', baseSiteId);
                            // verify required parameter 'cartId' is not null or undefined
                            assertParamExists('getSavedCart', 'cartId', cartId);
                            // verify required parameter 'userId' is not null or undefined
                            assertParamExists('getSavedCart', 'userId', userId);
                            localVarPath = "/{baseSiteId}/users/{userId}/carts/{cartId}/savedcart"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'cartId' + "}", encodeURIComponent(String(cartId)))
                                .replace("{" + 'userId' + "}", encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        }
    };
};
/**
 * SaveCartApi - functional programming interface
 * @export
 */
var SaveCartApiFp = function (configuration) {
    var localVarAxiosParamCreator = SaveCartApiAxiosParamCreator(configuration);
    return {
        /**
         * Explicitly clones a cart.
         * @summary Explicitly clones a cart.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {string} [description] The description that should be applied to the cloned cart.
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {string} [name] The name that should be applied to the cloned cart.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doCartClone: function (baseSiteId, cartId, userId, description, fields, name, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.doCartClone(baseSiteId, cartId, userId, description, fields, name, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Explicitly saves a cart.
         * @summary Explicitly saves a cart.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {string} [saveCartDescription] The description that should be applied to the saved cart.
         * @param {string} [saveCartName] The name that should be applied to the saved cart.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doSaveCart: function (baseSiteId, cartId, userId, fields, saveCartDescription, saveCartName, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.doSaveCart(baseSiteId, cartId, userId, fields, saveCartDescription, saveCartName, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Flags a cart for deletion (the cart doesn\'t have corresponding save cart attributes anymore). The cart is not actually deleted from the database. But with the removal of the saved cart attributes, this cart will be taken care of by the cart removal job just like any other cart.
         * @summary Flag a cart for deletion.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doUpdateFlagForDeletion: function (baseSiteId, cartId, userId, fields, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.doUpdateFlagForDeletion(baseSiteId, cartId, userId, fields, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Restore a saved cart.
         * @summary Restore a saved cart.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doUpdateSavedCart: function (baseSiteId, cartId, userId, fields, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.doUpdateSavedCart(baseSiteId, cartId, userId, fields, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns a saved cart for an authenticated user. The cart is identified using the \"cartId\" parameter.
         * @summary Get a saved cart.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSavedCart: function (baseSiteId, cartId, userId, fields, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getSavedCart(baseSiteId, cartId, userId, fields, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        }
    };
};
/**
 * SaveCartApi - factory interface
 * @export
 */
var SaveCartApiFactory = function (configuration, basePath, axios) {
    var localVarFp = SaveCartApiFp(configuration);
    return {
        /**
         * Explicitly clones a cart.
         * @summary Explicitly clones a cart.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {string} [description] The description that should be applied to the cloned cart.
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {string} [name] The name that should be applied to the cloned cart.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doCartClone: function (baseSiteId, cartId, userId, description, fields, name, options) {
            return localVarFp
                .doCartClone(baseSiteId, cartId, userId, description, fields, name, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Explicitly saves a cart.
         * @summary Explicitly saves a cart.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {string} [saveCartDescription] The description that should be applied to the saved cart.
         * @param {string} [saveCartName] The name that should be applied to the saved cart.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doSaveCart: function (baseSiteId, cartId, userId, fields, saveCartDescription, saveCartName, options) {
            return localVarFp
                .doSaveCart(baseSiteId, cartId, userId, fields, saveCartDescription, saveCartName, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Flags a cart for deletion (the cart doesn\'t have corresponding save cart attributes anymore). The cart is not actually deleted from the database. But with the removal of the saved cart attributes, this cart will be taken care of by the cart removal job just like any other cart.
         * @summary Flag a cart for deletion.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doUpdateFlagForDeletion: function (baseSiteId, cartId, userId, fields, options) {
            return localVarFp
                .doUpdateFlagForDeletion(baseSiteId, cartId, userId, fields, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Restore a saved cart.
         * @summary Restore a saved cart.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doUpdateSavedCart: function (baseSiteId, cartId, userId, fields, options) {
            return localVarFp
                .doUpdateSavedCart(baseSiteId, cartId, userId, fields, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns a saved cart for an authenticated user. The cart is identified using the \"cartId\" parameter.
         * @summary Get a saved cart.
         * @param {string} baseSiteId Base site identifier
         * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSavedCart: function (baseSiteId, cartId, userId, fields, options) {
            return localVarFp
                .getSavedCart(baseSiteId, cartId, userId, fields, options)
                .then(function (request) { return request(axios, basePath); });
        }
    };
};
/**
 * SaveCartApi - object-oriented interface
 * @export
 * @class SaveCartApi
 * @extends {BaseAPI}
 */
var SaveCartApi = /** @class */ (function (_super) {
    __extends(SaveCartApi, _super);
    function SaveCartApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Explicitly clones a cart.
     * @summary Explicitly clones a cart.
     * @param {string} baseSiteId Base site identifier
     * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {string} [description] The description that should be applied to the cloned cart.
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
     * @param {string} [name] The name that should be applied to the cloned cart.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SaveCartApi
     */
    SaveCartApi.prototype.doCartClone = function (baseSiteId, cartId, userId, description, fields, name, options) {
        var _this = this;
        return SaveCartApiFp(this.configuration)
            .doCartClone(baseSiteId, cartId, userId, description, fields, name, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Explicitly saves a cart.
     * @summary Explicitly saves a cart.
     * @param {string} baseSiteId Base site identifier
     * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
     * @param {string} [saveCartDescription] The description that should be applied to the saved cart.
     * @param {string} [saveCartName] The name that should be applied to the saved cart.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SaveCartApi
     */
    SaveCartApi.prototype.doSaveCart = function (baseSiteId, cartId, userId, fields, saveCartDescription, saveCartName, options) {
        var _this = this;
        return SaveCartApiFp(this.configuration)
            .doSaveCart(baseSiteId, cartId, userId, fields, saveCartDescription, saveCartName, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Flags a cart for deletion (the cart doesn\'t have corresponding save cart attributes anymore). The cart is not actually deleted from the database. But with the removal of the saved cart attributes, this cart will be taken care of by the cart removal job just like any other cart.
     * @summary Flag a cart for deletion.
     * @param {string} baseSiteId Base site identifier
     * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SaveCartApi
     */
    SaveCartApi.prototype.doUpdateFlagForDeletion = function (baseSiteId, cartId, userId, fields, options) {
        var _this = this;
        return SaveCartApiFp(this.configuration)
            .doUpdateFlagForDeletion(baseSiteId, cartId, userId, fields, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Restore a saved cart.
     * @summary Restore a saved cart.
     * @param {string} baseSiteId Base site identifier
     * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SaveCartApi
     */
    SaveCartApi.prototype.doUpdateSavedCart = function (baseSiteId, cartId, userId, fields, options) {
        var _this = this;
        return SaveCartApiFp(this.configuration)
            .doUpdateSavedCart(baseSiteId, cartId, userId, fields, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns a saved cart for an authenticated user. The cart is identified using the \"cartId\" parameter.
     * @summary Get a saved cart.
     * @param {string} baseSiteId Base site identifier
     * @param {string} cartId Cart identifier: cart code for logged in user, cart guid for anonymous user, \&#39;current\&#39; for the last modified cart
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SaveCartApi
     */
    SaveCartApi.prototype.getSavedCart = function (baseSiteId, cartId, userId, fields, options) {
        var _this = this;
        return SaveCartApiFp(this.configuration)
            .getSavedCart(baseSiteId, cartId, userId, fields, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return SaveCartApi;
}(BaseAPI));
/**
 * ShowcaseUserApi - axios parameter creator
 * @export
 */
var ShowcaseUserApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Adds device uid to customer\'s device list.
         * @summary Registers device for customer.
         * @param {string} baseSiteId Base site identifier
         * @param {string} [fcmToken] Device Uid for currently logged customer.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerFCMToken: function (baseSiteId, fcmToken, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('registerFCMToken', 'baseSiteId', baseSiteId);
                            localVarPath = "/{baseSiteId}/showcasenotifications/devices/registerfcmtoken".replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (fcmToken !== undefined) {
                                localVarQueryParameter['fcmToken'] = fcmToken;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        }
    };
};
/**
 * ShowcaseUserApi - functional programming interface
 * @export
 */
var ShowcaseUserApiFp = function (configuration) {
    var localVarAxiosParamCreator = ShowcaseUserApiAxiosParamCreator(configuration);
    return {
        /**
         * Adds device uid to customer\'s device list.
         * @summary Registers device for customer.
         * @param {string} baseSiteId Base site identifier
         * @param {string} [fcmToken] Device Uid for currently logged customer.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerFCMToken: function (baseSiteId, fcmToken, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.registerFCMToken(baseSiteId, fcmToken, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        }
    };
};
/**
 * ShowcaseUserApi - factory interface
 * @export
 */
var ShowcaseUserApiFactory = function (configuration, basePath, axios) {
    var localVarFp = ShowcaseUserApiFp(configuration);
    return {
        /**
         * Adds device uid to customer\'s device list.
         * @summary Registers device for customer.
         * @param {string} baseSiteId Base site identifier
         * @param {string} [fcmToken] Device Uid for currently logged customer.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerFCMToken: function (baseSiteId, fcmToken, options) {
            return localVarFp
                .registerFCMToken(baseSiteId, fcmToken, options)
                .then(function (request) { return request(axios, basePath); });
        }
    };
};
/**
 * ShowcaseUserApi - object-oriented interface
 * @export
 * @class ShowcaseUserApi
 * @extends {BaseAPI}
 */
var ShowcaseUserApi = /** @class */ (function (_super) {
    __extends(ShowcaseUserApi, _super);
    function ShowcaseUserApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Adds device uid to customer\'s device list.
     * @summary Registers device for customer.
     * @param {string} baseSiteId Base site identifier
     * @param {string} [fcmToken] Device Uid for currently logged customer.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShowcaseUserApi
     */
    ShowcaseUserApi.prototype.registerFCMToken = function (baseSiteId, fcmToken, options) {
        var _this = this;
        return ShowcaseUserApiFp(this.configuration)
            .registerFCMToken(baseSiteId, fcmToken, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ShowcaseUserApi;
}(BaseAPI));
/**
 * StoresApi - axios parameter creator
 * @export
 */
var StoresApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * In the response header, the \"x-total-count\" indicates the number of all store locations that are near the location specified in a query, or based on latitude and longitude.
         * @summary Get a header with the number of store locations.
         * @param {string} baseSiteId Base site identifier
         * @param {number} [accuracy] Accuracy in meters.
         * @param {number} [latitude] Coordinate that specifies the north-south position of a point on the Earth\&#39;s surface.
         * @param {number} [longitude] Coordinate that specifies the east-west position of a point on the Earth\&#39;s surface.
         * @param {string} [query] Location in natural language i.e. city or country.
         * @param {number} [radius] Radius in meters. Max value: 40075000.0 (Earth\&#39;s perimeter).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countStoreLocations: function (baseSiteId, accuracy, latitude, longitude, query, radius, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('countStoreLocations', 'baseSiteId', baseSiteId);
                            localVarPath = "/{baseSiteId}/stores".replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'HEAD' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (accuracy !== undefined) {
                                localVarQueryParameter['accuracy'] = accuracy;
                            }
                            if (latitude !== undefined) {
                                localVarQueryParameter['latitude'] = latitude;
                            }
                            if (longitude !== undefined) {
                                localVarQueryParameter['longitude'] = longitude;
                            }
                            if (query !== undefined) {
                                localVarQueryParameter['query'] = query;
                            }
                            if (radius !== undefined) {
                                localVarQueryParameter['radius'] = radius;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Returns store counts in countries and regions
         * @summary Gets a store location count per country and regions
         * @param {string} baseSiteId Base site identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocationCounts: function (baseSiteId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('getLocationCounts', 'baseSiteId', baseSiteId);
                            localVarPath = "/{baseSiteId}/stores/storescounts".replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Returns store location based on its unique name.
         * @summary Get a store location
         * @param {string} baseSiteId Base site identifier
         * @param {string} storeId Store identifier (currently store name)
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStoreLocation: function (baseSiteId, storeId, fields, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('getStoreLocation', 'baseSiteId', baseSiteId);
                            // verify required parameter 'storeId' is not null or undefined
                            assertParamExists('getStoreLocation', 'storeId', storeId);
                            localVarPath = "/{baseSiteId}/stores/{storeId}"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'storeId' + "}", encodeURIComponent(String(storeId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Lists all store locations that are near the location specified in a query or based on latitude and longitude.
         * @summary Get a list of store locations
         * @param {string} baseSiteId Base site identifier
         * @param {number} [accuracy] Accuracy in meters.
         * @param {number} [currentPage] The current result page requested.
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {number} [latitude] Coordinate that specifies the north-south position of a point on the Earth\&#39;s surface.
         * @param {number} [longitude] Coordinate that specifies the east-west position of a point on the Earth\&#39;s surface.
         * @param {number} [pageSize] The number of results returned per page.
         * @param {string} [query] Location in natural language i.e. city or country.
         * @param {number} [radius] Radius in meters. Max value: 40075000.0 (Earth\&#39;s perimeter).
         * @param {string} [sort] Sorting method applied to the return results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStoreLocations: function (baseSiteId, accuracy, currentPage, fields, latitude, longitude, pageSize, query, radius, sort, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('getStoreLocations', 'baseSiteId', baseSiteId);
                            localVarPath = "/{baseSiteId}/stores".replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (accuracy !== undefined) {
                                localVarQueryParameter['accuracy'] = accuracy;
                            }
                            if (currentPage !== undefined) {
                                localVarQueryParameter['currentPage'] = currentPage;
                            }
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            if (latitude !== undefined) {
                                localVarQueryParameter['latitude'] = latitude;
                            }
                            if (longitude !== undefined) {
                                localVarQueryParameter['longitude'] = longitude;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['pageSize'] = pageSize;
                            }
                            if (query !== undefined) {
                                localVarQueryParameter['query'] = query;
                            }
                            if (radius !== undefined) {
                                localVarQueryParameter['radius'] = radius;
                            }
                            if (sort !== undefined) {
                                localVarQueryParameter['sort'] = sort;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Lists all store locations that are in the specified country.
         * @summary Get a list of store locations for a given country
         * @param {string} baseSiteId Base site identifier
         * @param {string} countryIso Country ISO code
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStoresByCountry: function (baseSiteId, countryIso, fields, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('getStoresByCountry', 'baseSiteId', baseSiteId);
                            // verify required parameter 'countryIso' is not null or undefined
                            assertParamExists('getStoresByCountry', 'countryIso', countryIso);
                            localVarPath = "/{baseSiteId}/stores/country/{countryIso}"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'countryIso' + "}", encodeURIComponent(String(countryIso)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Lists all store locations that are in the specified country and region.
         * @summary Get a list of store locations for a given country and region
         * @param {string} baseSiteId Base site identifier
         * @param {string} countryIso Country ISO code
         * @param {string} regionIso Region ISO code
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStoresByCountryAndRegion: function (baseSiteId, countryIso, regionIso, fields, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('getStoresByCountryAndRegion', 'baseSiteId', baseSiteId);
                            // verify required parameter 'countryIso' is not null or undefined
                            assertParamExists('getStoresByCountryAndRegion', 'countryIso', countryIso);
                            // verify required parameter 'regionIso' is not null or undefined
                            assertParamExists('getStoresByCountryAndRegion', 'regionIso', regionIso);
                            localVarPath = "/{baseSiteId}/stores/country/{countryIso}/region/{regionIso}"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'countryIso' + "}", encodeURIComponent(String(countryIso)))
                                .replace("{" + 'regionIso' + "}", encodeURIComponent(String(regionIso)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        }
    };
};
/**
 * StoresApi - functional programming interface
 * @export
 */
var StoresApiFp = function (configuration) {
    var localVarAxiosParamCreator = StoresApiAxiosParamCreator(configuration);
    return {
        /**
         * In the response header, the \"x-total-count\" indicates the number of all store locations that are near the location specified in a query, or based on latitude and longitude.
         * @summary Get a header with the number of store locations.
         * @param {string} baseSiteId Base site identifier
         * @param {number} [accuracy] Accuracy in meters.
         * @param {number} [latitude] Coordinate that specifies the north-south position of a point on the Earth\&#39;s surface.
         * @param {number} [longitude] Coordinate that specifies the east-west position of a point on the Earth\&#39;s surface.
         * @param {string} [query] Location in natural language i.e. city or country.
         * @param {number} [radius] Radius in meters. Max value: 40075000.0 (Earth\&#39;s perimeter).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countStoreLocations: function (baseSiteId, accuracy, latitude, longitude, query, radius, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.countStoreLocations(baseSiteId, accuracy, latitude, longitude, query, radius, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns store counts in countries and regions
         * @summary Gets a store location count per country and regions
         * @param {string} baseSiteId Base site identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocationCounts: function (baseSiteId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getLocationCounts(baseSiteId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns store location based on its unique name.
         * @summary Get a store location
         * @param {string} baseSiteId Base site identifier
         * @param {string} storeId Store identifier (currently store name)
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStoreLocation: function (baseSiteId, storeId, fields, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getStoreLocation(baseSiteId, storeId, fields, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Lists all store locations that are near the location specified in a query or based on latitude and longitude.
         * @summary Get a list of store locations
         * @param {string} baseSiteId Base site identifier
         * @param {number} [accuracy] Accuracy in meters.
         * @param {number} [currentPage] The current result page requested.
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {number} [latitude] Coordinate that specifies the north-south position of a point on the Earth\&#39;s surface.
         * @param {number} [longitude] Coordinate that specifies the east-west position of a point on the Earth\&#39;s surface.
         * @param {number} [pageSize] The number of results returned per page.
         * @param {string} [query] Location in natural language i.e. city or country.
         * @param {number} [radius] Radius in meters. Max value: 40075000.0 (Earth\&#39;s perimeter).
         * @param {string} [sort] Sorting method applied to the return results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStoreLocations: function (baseSiteId, accuracy, currentPage, fields, latitude, longitude, pageSize, query, radius, sort, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getStoreLocations(baseSiteId, accuracy, currentPage, fields, latitude, longitude, pageSize, query, radius, sort, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Lists all store locations that are in the specified country.
         * @summary Get a list of store locations for a given country
         * @param {string} baseSiteId Base site identifier
         * @param {string} countryIso Country ISO code
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStoresByCountry: function (baseSiteId, countryIso, fields, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getStoresByCountry(baseSiteId, countryIso, fields, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Lists all store locations that are in the specified country and region.
         * @summary Get a list of store locations for a given country and region
         * @param {string} baseSiteId Base site identifier
         * @param {string} countryIso Country ISO code
         * @param {string} regionIso Region ISO code
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStoresByCountryAndRegion: function (baseSiteId, countryIso, regionIso, fields, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getStoresByCountryAndRegion(baseSiteId, countryIso, regionIso, fields, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        }
    };
};
/**
 * StoresApi - factory interface
 * @export
 */
var StoresApiFactory = function (configuration, basePath, axios) {
    var localVarFp = StoresApiFp(configuration);
    return {
        /**
         * In the response header, the \"x-total-count\" indicates the number of all store locations that are near the location specified in a query, or based on latitude and longitude.
         * @summary Get a header with the number of store locations.
         * @param {string} baseSiteId Base site identifier
         * @param {number} [accuracy] Accuracy in meters.
         * @param {number} [latitude] Coordinate that specifies the north-south position of a point on the Earth\&#39;s surface.
         * @param {number} [longitude] Coordinate that specifies the east-west position of a point on the Earth\&#39;s surface.
         * @param {string} [query] Location in natural language i.e. city or country.
         * @param {number} [radius] Radius in meters. Max value: 40075000.0 (Earth\&#39;s perimeter).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countStoreLocations: function (baseSiteId, accuracy, latitude, longitude, query, radius, options) {
            return localVarFp
                .countStoreLocations(baseSiteId, accuracy, latitude, longitude, query, radius, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns store counts in countries and regions
         * @summary Gets a store location count per country and regions
         * @param {string} baseSiteId Base site identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocationCounts: function (baseSiteId, options) {
            return localVarFp
                .getLocationCounts(baseSiteId, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns store location based on its unique name.
         * @summary Get a store location
         * @param {string} baseSiteId Base site identifier
         * @param {string} storeId Store identifier (currently store name)
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStoreLocation: function (baseSiteId, storeId, fields, options) {
            return localVarFp
                .getStoreLocation(baseSiteId, storeId, fields, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Lists all store locations that are near the location specified in a query or based on latitude and longitude.
         * @summary Get a list of store locations
         * @param {string} baseSiteId Base site identifier
         * @param {number} [accuracy] Accuracy in meters.
         * @param {number} [currentPage] The current result page requested.
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {number} [latitude] Coordinate that specifies the north-south position of a point on the Earth\&#39;s surface.
         * @param {number} [longitude] Coordinate that specifies the east-west position of a point on the Earth\&#39;s surface.
         * @param {number} [pageSize] The number of results returned per page.
         * @param {string} [query] Location in natural language i.e. city or country.
         * @param {number} [radius] Radius in meters. Max value: 40075000.0 (Earth\&#39;s perimeter).
         * @param {string} [sort] Sorting method applied to the return results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStoreLocations: function (baseSiteId, accuracy, currentPage, fields, latitude, longitude, pageSize, query, radius, sort, options) {
            return localVarFp
                .getStoreLocations(baseSiteId, accuracy, currentPage, fields, latitude, longitude, pageSize, query, radius, sort, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Lists all store locations that are in the specified country.
         * @summary Get a list of store locations for a given country
         * @param {string} baseSiteId Base site identifier
         * @param {string} countryIso Country ISO code
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStoresByCountry: function (baseSiteId, countryIso, fields, options) {
            return localVarFp
                .getStoresByCountry(baseSiteId, countryIso, fields, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Lists all store locations that are in the specified country and region.
         * @summary Get a list of store locations for a given country and region
         * @param {string} baseSiteId Base site identifier
         * @param {string} countryIso Country ISO code
         * @param {string} regionIso Region ISO code
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStoresByCountryAndRegion: function (baseSiteId, countryIso, regionIso, fields, options) {
            return localVarFp
                .getStoresByCountryAndRegion(baseSiteId, countryIso, regionIso, fields, options)
                .then(function (request) { return request(axios, basePath); });
        }
    };
};
/**
 * StoresApi - object-oriented interface
 * @export
 * @class StoresApi
 * @extends {BaseAPI}
 */
var StoresApi = /** @class */ (function (_super) {
    __extends(StoresApi, _super);
    function StoresApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * In the response header, the \"x-total-count\" indicates the number of all store locations that are near the location specified in a query, or based on latitude and longitude.
     * @summary Get a header with the number of store locations.
     * @param {string} baseSiteId Base site identifier
     * @param {number} [accuracy] Accuracy in meters.
     * @param {number} [latitude] Coordinate that specifies the north-south position of a point on the Earth\&#39;s surface.
     * @param {number} [longitude] Coordinate that specifies the east-west position of a point on the Earth\&#39;s surface.
     * @param {string} [query] Location in natural language i.e. city or country.
     * @param {number} [radius] Radius in meters. Max value: 40075000.0 (Earth\&#39;s perimeter).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoresApi
     */
    StoresApi.prototype.countStoreLocations = function (baseSiteId, accuracy, latitude, longitude, query, radius, options) {
        var _this = this;
        return StoresApiFp(this.configuration)
            .countStoreLocations(baseSiteId, accuracy, latitude, longitude, query, radius, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns store counts in countries and regions
     * @summary Gets a store location count per country and regions
     * @param {string} baseSiteId Base site identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoresApi
     */
    StoresApi.prototype.getLocationCounts = function (baseSiteId, options) {
        var _this = this;
        return StoresApiFp(this.configuration)
            .getLocationCounts(baseSiteId, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns store location based on its unique name.
     * @summary Get a store location
     * @param {string} baseSiteId Base site identifier
     * @param {string} storeId Store identifier (currently store name)
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoresApi
     */
    StoresApi.prototype.getStoreLocation = function (baseSiteId, storeId, fields, options) {
        var _this = this;
        return StoresApiFp(this.configuration)
            .getStoreLocation(baseSiteId, storeId, fields, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Lists all store locations that are near the location specified in a query or based on latitude and longitude.
     * @summary Get a list of store locations
     * @param {string} baseSiteId Base site identifier
     * @param {number} [accuracy] Accuracy in meters.
     * @param {number} [currentPage] The current result page requested.
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
     * @param {number} [latitude] Coordinate that specifies the north-south position of a point on the Earth\&#39;s surface.
     * @param {number} [longitude] Coordinate that specifies the east-west position of a point on the Earth\&#39;s surface.
     * @param {number} [pageSize] The number of results returned per page.
     * @param {string} [query] Location in natural language i.e. city or country.
     * @param {number} [radius] Radius in meters. Max value: 40075000.0 (Earth\&#39;s perimeter).
     * @param {string} [sort] Sorting method applied to the return results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoresApi
     */
    StoresApi.prototype.getStoreLocations = function (baseSiteId, accuracy, currentPage, fields, latitude, longitude, pageSize, query, radius, sort, options) {
        var _this = this;
        return StoresApiFp(this.configuration)
            .getStoreLocations(baseSiteId, accuracy, currentPage, fields, latitude, longitude, pageSize, query, radius, sort, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Lists all store locations that are in the specified country.
     * @summary Get a list of store locations for a given country
     * @param {string} baseSiteId Base site identifier
     * @param {string} countryIso Country ISO code
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoresApi
     */
    StoresApi.prototype.getStoresByCountry = function (baseSiteId, countryIso, fields, options) {
        var _this = this;
        return StoresApiFp(this.configuration)
            .getStoresByCountry(baseSiteId, countryIso, fields, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Lists all store locations that are in the specified country and region.
     * @summary Get a list of store locations for a given country and region
     * @param {string} baseSiteId Base site identifier
     * @param {string} countryIso Country ISO code
     * @param {string} regionIso Region ISO code
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoresApi
     */
    StoresApi.prototype.getStoresByCountryAndRegion = function (baseSiteId, countryIso, regionIso, fields, options) {
        var _this = this;
        return StoresApiFp(this.configuration)
            .getStoresByCountryAndRegion(baseSiteId, countryIso, regionIso, fields, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return StoresApi;
}(BaseAPI));
/**
 * UserControllerApi - axios parameter creator
 * @export
 */
var UserControllerApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary getProfilePicture
         * @param {string} baseSiteId baseSiteId
         * @param {string} userId userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfilePictureUsingGET: function (baseSiteId, userId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('getProfilePictureUsingGET', 'baseSiteId', baseSiteId);
                            // verify required parameter 'userId' is not null or undefined
                            assertParamExists('getProfilePictureUsingGET', 'userId', userId);
                            localVarPath = "/{baseSiteId}/users/{userId}/profilepicture"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'userId' + "}", encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary setProfilePicture
         * @param {string} baseSiteId baseSiteId
         * @param {string} userId userId
         * @param {any} file file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setProfilePictureUsingPOST: function (baseSiteId, userId, file, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarFormParams, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('setProfilePictureUsingPOST', 'baseSiteId', baseSiteId);
                            // verify required parameter 'userId' is not null or undefined
                            assertParamExists('setProfilePictureUsingPOST', 'userId', userId);
                            // verify required parameter 'file' is not null or undefined
                            assertParamExists('setProfilePictureUsingPOST', 'file', file);
                            localVarPath = "/{baseSiteId}/users/{userId}/profilepicture"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'userId' + "}", encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            localVarFormParams = new ((configuration &&
                                configuration.formDataCtor) ||
                                FormData)();
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (file !== undefined) {
                                localVarFormParams.append('file', file);
                            }
                            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = localVarFormParams;
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        }
    };
};
/**
 * UserControllerApi - functional programming interface
 * @export
 */
var UserControllerApiFp = function (configuration) {
    var localVarAxiosParamCreator = UserControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary getProfilePicture
         * @param {string} baseSiteId baseSiteId
         * @param {string} userId userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfilePictureUsingGET: function (baseSiteId, userId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getProfilePictureUsingGET(baseSiteId, userId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary setProfilePicture
         * @param {string} baseSiteId baseSiteId
         * @param {string} userId userId
         * @param {any} file file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setProfilePictureUsingPOST: function (baseSiteId, userId, file, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.setProfilePictureUsingPOST(baseSiteId, userId, file, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        }
    };
};
/**
 * UserControllerApi - factory interface
 * @export
 */
var UserControllerApiFactory = function (configuration, basePath, axios) {
    var localVarFp = UserControllerApiFp(configuration);
    return {
        /**
         *
         * @summary getProfilePicture
         * @param {string} baseSiteId baseSiteId
         * @param {string} userId userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfilePictureUsingGET: function (baseSiteId, userId, options) {
            return localVarFp
                .getProfilePictureUsingGET(baseSiteId, userId, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary setProfilePicture
         * @param {string} baseSiteId baseSiteId
         * @param {string} userId userId
         * @param {any} file file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setProfilePictureUsingPOST: function (baseSiteId, userId, file, options) {
            return localVarFp
                .setProfilePictureUsingPOST(baseSiteId, userId, file, options)
                .then(function (request) { return request(axios, basePath); });
        }
    };
};
/**
 * UserControllerApi - object-oriented interface
 * @export
 * @class UserControllerApi
 * @extends {BaseAPI}
 */
var UserControllerApi = /** @class */ (function (_super) {
    __extends(UserControllerApi, _super);
    function UserControllerApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary getProfilePicture
     * @param {string} baseSiteId baseSiteId
     * @param {string} userId userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApi
     */
    UserControllerApi.prototype.getProfilePictureUsingGET = function (baseSiteId, userId, options) {
        var _this = this;
        return UserControllerApiFp(this.configuration)
            .getProfilePictureUsingGET(baseSiteId, userId, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary setProfilePicture
     * @param {string} baseSiteId baseSiteId
     * @param {string} userId userId
     * @param {any} file file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApi
     */
    UserControllerApi.prototype.setProfilePictureUsingPOST = function (baseSiteId, userId, file, options) {
        var _this = this;
        return UserControllerApiFp(this.configuration)
            .setProfilePictureUsingPOST(baseSiteId, userId, file, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return UserControllerApi;
}(BaseAPI));
/**
 * UsersApi - axios parameter creator
 * @export
 */
var UsersApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Registers a customer. Requires the following parameters: login, password, firstName, lastName, titleCode.
         * @summary  Registers a customer
         * @param {string} baseSiteId Base site identifier
         * @param {UserSignUp} user User\&#39;s object.
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser: function (baseSiteId, user, fields, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('createUser', 'baseSiteId', baseSiteId);
                            // verify required parameter 'user' is not null or undefined
                            assertParamExists('createUser', 'user', user);
                            localVarPath = "/{baseSiteId}/users".replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/xml';
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = serializeDataIfNeeded(user, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Returns customer profile.
         * @summary Get customer profile
         * @param {string} baseSiteId Base site identifier
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUser: function (baseSiteId, userId, fields, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('getUser', 'baseSiteId', baseSiteId);
                            // verify required parameter 'userId' is not null or undefined
                            assertParamExists('getUser', 'userId', userId);
                            localVarPath = "/{baseSiteId}/users/{userId}"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'userId' + "}", encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Returns all customer groups of a customer.
         * @summary Get all customer groups of a customer.
         * @param {string} baseSiteId Base site identifier
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserCustomerGroups: function (baseSiteId, userId, fields, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('getUserCustomerGroups', 'baseSiteId', baseSiteId);
                            // verify required parameter 'userId' is not null or undefined
                            assertParamExists('getUserCustomerGroups', 'userId', userId);
                            localVarPath = "/{baseSiteId}/users/{userId}/customergroups"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'userId' + "}", encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Removes customer profile.
         * @summary Delete customer profile.
         * @param {string} baseSiteId Base site identifier
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeUser: function (baseSiteId, userId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('removeUser', 'baseSiteId', baseSiteId);
                            // verify required parameter 'userId' is not null or undefined
                            assertParamExists('removeUser', 'userId', userId);
                            localVarPath = "/{baseSiteId}/users/{userId}"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'userId' + "}", encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Updates customer profile. Attributes not provided in the request body will be defined again (set to null or default).
         * @summary Updates customer profile
         * @param {string} baseSiteId Base site identifier
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {User} user User\&#39;s object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceUser: function (baseSiteId, userId, user, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('replaceUser', 'baseSiteId', baseSiteId);
                            // verify required parameter 'userId' is not null or undefined
                            assertParamExists('replaceUser', 'userId', userId);
                            // verify required parameter 'user' is not null or undefined
                            assertParamExists('replaceUser', 'user', user);
                            localVarPath = "/{baseSiteId}/users/{userId}"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'userId' + "}", encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/xml';
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = serializeDataIfNeeded(user, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Changes a customer\'s login name. Requires the customer\'s current password.
         * @summary Changes customer\'s login name.
         * @param {string} baseSiteId Base site identifier
         * @param {string} newLogin Customer\&#39;s new login name. Customer login is case insensitive.
         * @param {string} password Customer\&#39;s current password.
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceUserLogin: function (baseSiteId, newLogin, password, userId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('replaceUserLogin', 'baseSiteId', baseSiteId);
                            // verify required parameter 'newLogin' is not null or undefined
                            assertParamExists('replaceUserLogin', 'newLogin', newLogin);
                            // verify required parameter 'password' is not null or undefined
                            assertParamExists('replaceUserLogin', 'password', password);
                            // verify required parameter 'userId' is not null or undefined
                            assertParamExists('replaceUserLogin', 'userId', userId);
                            localVarPath = "/{baseSiteId}/users/{userId}/login"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'userId' + "}", encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (newLogin !== undefined) {
                                localVarQueryParameter['newLogin'] = newLogin;
                            }
                            if (password !== undefined) {
                                localVarQueryParameter['password'] = password;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Changes customer\'s password.
         * @summary Changes customer\'s password
         * @param {string} baseSiteId Base site identifier
         * @param {string} _new New password.
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {string} [old] Old password. Required only for ROLE_CUSTOMERGROUP
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceUserPassword: function (baseSiteId, _new, userId, old, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('replaceUserPassword', 'baseSiteId', baseSiteId);
                            // verify required parameter '_new' is not null or undefined
                            assertParamExists('replaceUserPassword', '_new', _new);
                            // verify required parameter 'userId' is not null or undefined
                            assertParamExists('replaceUserPassword', 'userId', userId);
                            localVarPath = "/{baseSiteId}/users/{userId}/password"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'userId' + "}", encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (_new !== undefined) {
                                localVarQueryParameter['new'] = _new;
                            }
                            if (old !== undefined) {
                                localVarQueryParameter['old'] = old;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        },
        /**
         * Updates customer profile. Only attributes provided in the request body will be changed.
         * @summary Updates customer profile
         * @param {string} baseSiteId Base site identifier
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {User} user User\&#39;s object.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser: function (baseSiteId, userId, user, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('updateUser', 'baseSiteId', baseSiteId);
                            // verify required parameter 'userId' is not null or undefined
                            assertParamExists('updateUser', 'userId', userId);
                            // verify required parameter 'user' is not null or undefined
                            assertParamExists('updateUser', 'user', user);
                            localVarPath = "/{baseSiteId}/users/{userId}"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'userId' + "}", encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/xml';
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = serializeDataIfNeeded(user, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        }
    };
};
/**
 * UsersApi - functional programming interface
 * @export
 */
var UsersApiFp = function (configuration) {
    var localVarAxiosParamCreator = UsersApiAxiosParamCreator(configuration);
    return {
        /**
         * Registers a customer. Requires the following parameters: login, password, firstName, lastName, titleCode.
         * @summary  Registers a customer
         * @param {string} baseSiteId Base site identifier
         * @param {UserSignUp} user User\&#39;s object.
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser: function (baseSiteId, user, fields, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createUser(baseSiteId, user, fields, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns customer profile.
         * @summary Get customer profile
         * @param {string} baseSiteId Base site identifier
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUser: function (baseSiteId, userId, fields, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getUser(baseSiteId, userId, fields, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns all customer groups of a customer.
         * @summary Get all customer groups of a customer.
         * @param {string} baseSiteId Base site identifier
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserCustomerGroups: function (baseSiteId, userId, fields, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getUserCustomerGroups(baseSiteId, userId, fields, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Removes customer profile.
         * @summary Delete customer profile.
         * @param {string} baseSiteId Base site identifier
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeUser: function (baseSiteId, userId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.removeUser(baseSiteId, userId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Updates customer profile. Attributes not provided in the request body will be defined again (set to null or default).
         * @summary Updates customer profile
         * @param {string} baseSiteId Base site identifier
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {User} user User\&#39;s object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceUser: function (baseSiteId, userId, user, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.replaceUser(baseSiteId, userId, user, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Changes a customer\'s login name. Requires the customer\'s current password.
         * @summary Changes customer\'s login name.
         * @param {string} baseSiteId Base site identifier
         * @param {string} newLogin Customer\&#39;s new login name. Customer login is case insensitive.
         * @param {string} password Customer\&#39;s current password.
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceUserLogin: function (baseSiteId, newLogin, password, userId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.replaceUserLogin(baseSiteId, newLogin, password, userId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Changes customer\'s password.
         * @summary Changes customer\'s password
         * @param {string} baseSiteId Base site identifier
         * @param {string} _new New password.
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {string} [old] Old password. Required only for ROLE_CUSTOMERGROUP
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceUserPassword: function (baseSiteId, _new, userId, old, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.replaceUserPassword(baseSiteId, _new, userId, old, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Updates customer profile. Only attributes provided in the request body will be changed.
         * @summary Updates customer profile
         * @param {string} baseSiteId Base site identifier
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {User} user User\&#39;s object.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser: function (baseSiteId, userId, user, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateUser(baseSiteId, userId, user, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        }
    };
};
/**
 * UsersApi - factory interface
 * @export
 */
var UsersApiFactory = function (configuration, basePath, axios) {
    var localVarFp = UsersApiFp(configuration);
    return {
        /**
         * Registers a customer. Requires the following parameters: login, password, firstName, lastName, titleCode.
         * @summary  Registers a customer
         * @param {string} baseSiteId Base site identifier
         * @param {UserSignUp} user User\&#39;s object.
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser: function (baseSiteId, user, fields, options) {
            return localVarFp
                .createUser(baseSiteId, user, fields, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns customer profile.
         * @summary Get customer profile
         * @param {string} baseSiteId Base site identifier
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUser: function (baseSiteId, userId, fields, options) {
            return localVarFp
                .getUser(baseSiteId, userId, fields, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns all customer groups of a customer.
         * @summary Get all customer groups of a customer.
         * @param {string} baseSiteId Base site identifier
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserCustomerGroups: function (baseSiteId, userId, fields, options) {
            return localVarFp
                .getUserCustomerGroups(baseSiteId, userId, fields, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Removes customer profile.
         * @summary Delete customer profile.
         * @param {string} baseSiteId Base site identifier
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeUser: function (baseSiteId, userId, options) {
            return localVarFp
                .removeUser(baseSiteId, userId, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Updates customer profile. Attributes not provided in the request body will be defined again (set to null or default).
         * @summary Updates customer profile
         * @param {string} baseSiteId Base site identifier
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {User} user User\&#39;s object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceUser: function (baseSiteId, userId, user, options) {
            return localVarFp
                .replaceUser(baseSiteId, userId, user, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Changes a customer\'s login name. Requires the customer\'s current password.
         * @summary Changes customer\'s login name.
         * @param {string} baseSiteId Base site identifier
         * @param {string} newLogin Customer\&#39;s new login name. Customer login is case insensitive.
         * @param {string} password Customer\&#39;s current password.
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceUserLogin: function (baseSiteId, newLogin, password, userId, options) {
            return localVarFp
                .replaceUserLogin(baseSiteId, newLogin, password, userId, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Changes customer\'s password.
         * @summary Changes customer\'s password
         * @param {string} baseSiteId Base site identifier
         * @param {string} _new New password.
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {string} [old] Old password. Required only for ROLE_CUSTOMERGROUP
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceUserPassword: function (baseSiteId, _new, userId, old, options) {
            return localVarFp
                .replaceUserPassword(baseSiteId, _new, userId, old, options)
                .then(function (request) { return request(axios, basePath); });
        },
        /**
         * Updates customer profile. Only attributes provided in the request body will be changed.
         * @summary Updates customer profile
         * @param {string} baseSiteId Base site identifier
         * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
         * @param {User} user User\&#39;s object.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser: function (baseSiteId, userId, user, options) {
            return localVarFp
                .updateUser(baseSiteId, userId, user, options)
                .then(function (request) { return request(axios, basePath); });
        }
    };
};
/**
 * UsersApi - object-oriented interface
 * @export
 * @class UsersApi
 * @extends {BaseAPI}
 */
var UsersApi = /** @class */ (function (_super) {
    __extends(UsersApi, _super);
    function UsersApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Registers a customer. Requires the following parameters: login, password, firstName, lastName, titleCode.
     * @summary  Registers a customer
     * @param {string} baseSiteId Base site identifier
     * @param {UserSignUp} user User\&#39;s object.
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    UsersApi.prototype.createUser = function (baseSiteId, user, fields, options) {
        var _this = this;
        return UsersApiFp(this.configuration)
            .createUser(baseSiteId, user, fields, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns customer profile.
     * @summary Get customer profile
     * @param {string} baseSiteId Base site identifier
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    UsersApi.prototype.getUser = function (baseSiteId, userId, fields, options) {
        var _this = this;
        return UsersApiFp(this.configuration)
            .getUser(baseSiteId, userId, fields, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns all customer groups of a customer.
     * @summary Get all customer groups of a customer.
     * @param {string} baseSiteId Base site identifier
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    UsersApi.prototype.getUserCustomerGroups = function (baseSiteId, userId, fields, options) {
        var _this = this;
        return UsersApiFp(this.configuration)
            .getUserCustomerGroups(baseSiteId, userId, fields, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Removes customer profile.
     * @summary Delete customer profile.
     * @param {string} baseSiteId Base site identifier
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    UsersApi.prototype.removeUser = function (baseSiteId, userId, options) {
        var _this = this;
        return UsersApiFp(this.configuration)
            .removeUser(baseSiteId, userId, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Updates customer profile. Attributes not provided in the request body will be defined again (set to null or default).
     * @summary Updates customer profile
     * @param {string} baseSiteId Base site identifier
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {User} user User\&#39;s object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    UsersApi.prototype.replaceUser = function (baseSiteId, userId, user, options) {
        var _this = this;
        return UsersApiFp(this.configuration)
            .replaceUser(baseSiteId, userId, user, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Changes a customer\'s login name. Requires the customer\'s current password.
     * @summary Changes customer\'s login name.
     * @param {string} baseSiteId Base site identifier
     * @param {string} newLogin Customer\&#39;s new login name. Customer login is case insensitive.
     * @param {string} password Customer\&#39;s current password.
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    UsersApi.prototype.replaceUserLogin = function (baseSiteId, newLogin, password, userId, options) {
        var _this = this;
        return UsersApiFp(this.configuration)
            .replaceUserLogin(baseSiteId, newLogin, password, userId, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Changes customer\'s password.
     * @summary Changes customer\'s password
     * @param {string} baseSiteId Base site identifier
     * @param {string} _new New password.
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {string} [old] Old password. Required only for ROLE_CUSTOMERGROUP
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    UsersApi.prototype.replaceUserPassword = function (baseSiteId, _new, userId, old, options) {
        var _this = this;
        return UsersApiFp(this.configuration)
            .replaceUserPassword(baseSiteId, _new, userId, old, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Updates customer profile. Only attributes provided in the request body will be changed.
     * @summary Updates customer profile
     * @param {string} baseSiteId Base site identifier
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {User} user User\&#39;s object.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    UsersApi.prototype.updateUser = function (baseSiteId, userId, user, options) {
        var _this = this;
        return UsersApiFp(this.configuration)
            .updateUser(baseSiteId, userId, user, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return UsersApi;
}(BaseAPI));
/**
 * VouchersApi - axios parameter creator
 * @export
 */
var VouchersApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Returns details of a single voucher that is specified by its voucher identification code.
         * @summary Get a voucher based on code.
         * @param {string} baseSiteId Base site identifier
         * @param {string} code Voucher identifier (code)
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVoucher: function (baseSiteId, code, fields, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'baseSiteId' is not null or undefined
                            assertParamExists('getVoucher', 'baseSiteId', baseSiteId);
                            // verify required parameter 'code' is not null or undefined
                            assertParamExists('getVoucher', 'code', code);
                            localVarPath = "/{baseSiteId}/vouchers/{code}"
                                .replace("{" + 'baseSiteId' + "}", encodeURIComponent(String(baseSiteId)))
                                .replace("{" + 'code' + "}", encodeURIComponent(String(code)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2_Password required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_Password', [], configuration)];
                        case 1:
                            // authentication oauth2_Password required
                            // oauth required
                            _a.sent();
                            // authentication oauth2_client_credentials required
                            // oauth required
                            return [4 /*yield*/, setOAuthToObject(localVarHeaderParameter, 'oauth2_client_credentials', [], configuration)];
                        case 2:
                            // authentication oauth2_client_credentials required
                            // oauth required
                            _a.sent();
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions
                                }];
                    }
                });
            });
        }
    };
};
/**
 * VouchersApi - functional programming interface
 * @export
 */
var VouchersApiFp = function (configuration) {
    var localVarAxiosParamCreator = VouchersApiAxiosParamCreator(configuration);
    return {
        /**
         * Returns details of a single voucher that is specified by its voucher identification code.
         * @summary Get a voucher based on code.
         * @param {string} baseSiteId Base site identifier
         * @param {string} code Voucher identifier (code)
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVoucher: function (baseSiteId, code, fields, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getVoucher(baseSiteId, code, fields, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        }
    };
};
/**
 * VouchersApi - factory interface
 * @export
 */
var VouchersApiFactory = function (configuration, basePath, axios) {
    var localVarFp = VouchersApiFp(configuration);
    return {
        /**
         * Returns details of a single voucher that is specified by its voucher identification code.
         * @summary Get a voucher based on code.
         * @param {string} baseSiteId Base site identifier
         * @param {string} code Voucher identifier (code)
         * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVoucher: function (baseSiteId, code, fields, options) {
            return localVarFp
                .getVoucher(baseSiteId, code, fields, options)
                .then(function (request) { return request(axios, basePath); });
        }
    };
};
/**
 * VouchersApi - object-oriented interface
 * @export
 * @class VouchersApi
 * @extends {BaseAPI}
 */
var VouchersApi = /** @class */ (function (_super) {
    __extends(VouchersApi, _super);
    function VouchersApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Returns details of a single voucher that is specified by its voucher identification code.
     * @summary Get a voucher based on code.
     * @param {string} baseSiteId Base site identifier
     * @param {string} code Voucher identifier (code)
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VouchersApi
     */
    VouchersApi.prototype.getVoucher = function (baseSiteId, code, fields, options) {
        var _this = this;
        return VouchersApiFp(this.configuration)
            .getVoucher(baseSiteId, code, fields, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return VouchersApi;
}(BaseAPI));

/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices v2
 * These services manage all of the common commerce functionality, and also include customizations from installed AddOns.
 *
 * The version of the OpenAPI document: 2.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var Configuration = /** @class */ (function () {
    function Configuration(param) {
        if (param === void 0) { param = {}; }
        this.apiKey = param.apiKey;
        this.username = param.username;
        this.password = param.password;
        this.accessToken = param.accessToken;
        this.basePath = param.basePath;
        this.baseOptions = param.baseOptions;
        this.formDataCtor = param.formDataCtor;
    }
    /**
     * Check if the given MIME is a JSON MIME.
     * JSON MIME examples:
     *   application/json
     *   application/json; charset=UTF8
     *   APPLICATION/JSON
     *   application/vnd.company+json
     * @param mime - MIME (Multipurpose Internet Mail Extensions)
     * @return True if the given MIME is JSON, false otherwise.
     */
    Configuration.prototype.isJsonMime = function (mime) {
        var jsonMime = new RegExp('^(application\/json|[^;/ \t]+\/[^;/ \t]+[+]json)[ \t]*(;.*)?$', 'i');
        return mime !== null && (jsonMime.test(mime) || mime.toLowerCase() === 'application/json-patch+json');
    };
    return Configuration;
}());

export { AddressApi, AddressApiAxiosParamCreator, AddressApiFactory, AddressApiFp, BaseSitesApi, BaseSitesApiAxiosParamCreator, BaseSitesApiFactory, BaseSitesApiFp, BaseStoresApi, BaseStoresApiAxiosParamCreator, BaseStoresApiFactory, BaseStoresApiFp, CartsApi, CartsApiAxiosParamCreator, CartsApiFactory, CartsApiFp, CatalogsApi, CatalogsApiAxiosParamCreator, CatalogsApiFactory, CatalogsApiFp, ComponentApi, ComponentApiAxiosParamCreator, ComponentApiFactory, ComponentApiFp, Configuration, ConsentsApi, ConsentsApiAxiosParamCreator, ConsentsApiFactory, ConsentsApiFp, ConsignmentTrackingApi, ConsignmentTrackingApiAxiosParamCreator, ConsignmentTrackingApiFactory, ConsignmentTrackingApiFp, CountriesApi, CountriesApiAxiosParamCreator, CountriesApiFactory, CountriesApiFp, CustomerGroupsApi, CustomerGroupsApiAxiosParamCreator, CustomerGroupsApiFactory, CustomerGroupsApiFp, CustomerProximityControllerApi, CustomerProximityControllerApiAxiosParamCreator, CustomerProximityControllerApiFactory, CustomerProximityControllerApiFp, ExportApi, ExportApiAxiosParamCreator, ExportApiFactory, ExportApiFp, ExtendedCartsApi, ExtendedCartsApiAxiosParamCreator, ExtendedCartsApiFactory, ExtendedCartsApiFp, FeedsApi, FeedsApiAxiosParamCreator, FeedsApiFactory, FeedsApiFp, ForgottenPasswordsApi, ForgottenPasswordsApiAxiosParamCreator, ForgottenPasswordsApiFactory, ForgottenPasswordsApiFp, ImageImageTypeEnum, MerchantCallbackApi, MerchantCallbackApiAxiosParamCreator, MerchantCallbackApiFactory, MerchantCallbackApiFp, MiscsApi, MiscsApiAxiosParamCreator, MiscsApiFactory, MiscsApiFp, OrderFormsControllerApi, OrderFormsControllerApiAxiosParamCreator, OrderFormsControllerApiFactory, OrderFormsControllerApiFp, OrdersApi, OrdersApiAxiosParamCreator, OrdersApiFactory, OrdersApiFp, PageApi, PageApiAxiosParamCreator, PageApiFactory, PageApiFp, PaymentDetailsApi, PaymentDetailsApiAxiosParamCreator, PaymentDetailsApiFactory, PaymentDetailsApiFp, PaymentModesApi, PaymentModesApiAxiosParamCreator, PaymentModesApiFactory, PaymentModesApiFp, PricePriceTypeEnum, ProductListControllerApi, ProductListControllerApiAxiosParamCreator, ProductListControllerApiFactory, ProductListControllerApiFp, ProductListForUserControllerApi, ProductListForUserControllerApiAxiosParamCreator, ProductListForUserControllerApiFactory, ProductListForUserControllerApiFp, ProductSetControllerApi, ProductSetControllerApiAxiosParamCreator, ProductSetControllerApiFactory, ProductSetControllerApiFp, ProductsApi, ProductsApiAxiosParamCreator, ProductsApiFactory, ProductsApiFp, PromotionsApi, PromotionsApiAxiosParamCreator, PromotionsApiFactory, PromotionsApiFp, QualtricsCdcControllerApi, QualtricsCdcControllerApiAxiosParamCreator, QualtricsCdcControllerApiFactory, QualtricsCdcControllerApiFp, QualtricsConfigurationControllerApi, QualtricsConfigurationControllerApiAxiosParamCreator, QualtricsConfigurationControllerApiFactory, QualtricsConfigurationControllerApiFp, SaveCartApi, SaveCartApiAxiosParamCreator, SaveCartApiFactory, SaveCartApiFp, ShowcaseUserApi, ShowcaseUserApiAxiosParamCreator, ShowcaseUserApiFactory, ShowcaseUserApiFp, StoresApi, StoresApiAxiosParamCreator, StoresApiFactory, StoresApiFp, UserControllerApi, UserControllerApiAxiosParamCreator, UserControllerApiFactory, UserControllerApiFp, UsersApi, UsersApiAxiosParamCreator, UsersApiFactory, UsersApiFp, VouchersApi, VouchersApiAxiosParamCreator, VouchersApiFactory, VouchersApiFp };
//# sourceMappingURL=index.es.js.map
